import { Currency, Locale } from 'chaika-enums';
export const common = {
    create: {
        [Locale.Ru]: 'Создать',
        [Locale.Am]: 'Ստեղծել',
        [Locale.En]: 'Create',
        [Locale.Pt]: 'Criar',
        [Locale.Ge]: 'შექმნა',
    },
    continue: {
        [Locale.Ru]: 'Продолжить',
        [Locale.Am]: 'Շարունակել',
        [Locale.En]: 'Continue',
        [Locale.Pt]: 'Continuar',
        [Locale.Ge]: 'გაგრძელება',
    },
    stay: {
        [Locale.Ru]: 'Остаться',
        [Locale.Am]: 'Մնալ',
        [Locale.En]: 'Stay',
        [Locale.Pt]: 'Ficar',
        [Locale.Ge]: 'დარჩენა',
    },
    save: {
        [Locale.Ru]: 'Сохранить',
        [Locale.Am]: 'Պահպանել',
        [Locale.En]: 'Save',
        [Locale.Pt]: 'Salvar',
        [Locale.Ge]: 'შენახვა',
    },
    saveChanges: {
        [Locale.Ru]: 'Сохранить изменения',
        [Locale.Am]: 'Պահպանել փոփոխությունները',
        [Locale.En]: 'Save changes',
        [Locale.Pt]: 'Salvar alterações',
        [Locale.Ge]: 'ცვლილებების შენახვა',
    },
    saveComment: {
        [Locale.Ru]: 'Сохранить комментарий',
        [Locale.Am]: 'Պահպանել մեկնաբանությունը',
        [Locale.En]: 'Save comment',
        [Locale.Pt]: 'Salvar comentário',
        [Locale.Ge]: 'კომენტარის შენახვა',
    },
    saved: {
        [Locale.Ru]: 'Сохранено',
        [Locale.Am]: 'Պահպանված է',
        [Locale.En]: 'Saved',
        [Locale.Pt]: 'Salvo',
        [Locale.Ge]: 'შენახული',
    },
    change: {
        [Locale.Ru]: 'Изменить',
        [Locale.Am]: 'Փոփոխել',
        [Locale.En]: 'Change',
        [Locale.Pt]: 'Alterar',
        [Locale.Ge]: 'შეცვლა',
    },
    delete: {
        [Locale.Ru]: 'Удалить',
        [Locale.Am]: 'Ջնջել',
        [Locale.En]: 'Delete',
        [Locale.Pt]: 'Excluir',
        [Locale.Ge]: 'ამოღება',
    },
    cancel: {
        [Locale.Ru]: 'Отменить',
        [Locale.Am]: 'Չեղարկել',
        [Locale.En]: 'Cancel',
        [Locale.Pt]: 'Cancelar',
        [Locale.Ge]: 'წაშლა',
    },
    /** Существительное — для кнопок, где макет просит «Отмена», а не «Отменить». */
    cancelSecond: {
        [Locale.Ru]: 'Отмена',
        [Locale.Am]: 'Չեղարկում',
        [Locale.En]: 'Cancel',
        [Locale.Pt]: 'Cancelar',
        [Locale.Ge]: 'გაუქმება',
    },
    canceled: {
        [Locale.Ru]: 'Отменено',
        [Locale.Am]: 'Չեղարկված է',
        [Locale.En]: 'Canceled',
        [Locale.Pt]: 'Cancelado',
        [Locale.Ge]: 'წაშლა',
    },
    cancellation: {
        [Locale.Ru]: 'Отмена',
        [Locale.Am]: 'Չեղարկել',
        [Locale.En]: 'Cancel',
        [Locale.Pt]: 'Cancelar',
        [Locale.Ge]: 'გაუქმება',
    },
    revert: {
        [Locale.Ru]: 'Вернуть',
        [Locale.Am]: 'Վերականգնել',
        [Locale.En]: 'Revert',
        [Locale.Pt]: 'Reverter',
        [Locale.Ge]: 'დაბრუნება',
    },
    field: {
        [Locale.Ru]: 'Поле',
        [Locale.Am]: 'Դաշտ',
        [Locale.En]: 'Field',
        [Locale.Pt]: 'Campo',
        [Locale.Ge]: 'ველი',
    },
    edit: {
        [Locale.Ru]: 'Редактировать',
        [Locale.Am]: 'Խմբագրել',
        [Locale.En]: 'Edit',
        [Locale.Pt]: 'Editar',
        [Locale.Ge]: 'რედაქტირება',
    },
    publish: {
        [Locale.Ru]: 'Опубликовать',
        [Locale.Am]: 'Հրապարակել',
        [Locale.En]: 'Publish',
        [Locale.Pt]: 'Publicar',
        [Locale.Ge]: 'გამოსაქვეყნებლად',
    },
    publishEntry: {
        [Locale.Ru]: 'Опубликовать запись',
        [Locale.Am]: 'Հրապարակել գրառումը',
        [Locale.En]: 'Publish entry',
        [Locale.Pt]: 'Publicar entrada',
        [Locale.Ge]: 'Publish entry',
    },
    publishRemaining: {
        [Locale.Ru]: 'Опубликовать оставшиеся',
        [Locale.Am]: 'Հրապարակել մնացածը',
        [Locale.En]: 'Publish remaining',
        [Locale.Pt]: 'Postagem restante',
        [Locale.Ge]: 'დანარჩენი გამოაქვეყნეთ',
    },
    published: {
        [Locale.Ru]: 'Опубликована',
        [Locale.Am]: 'Հրապարակված է',
        [Locale.En]: 'Published',
        [Locale.Pt]: 'Publicado',
        [Locale.Ge]: 'გამოქვეყნებულია',
    },
    ready: {
        [Locale.Ru]: 'Готово',
        [Locale.Am]: 'Պատրաստ է',
        [Locale.En]: 'Ready',
        [Locale.Pt]: 'Pronto',
        [Locale.Ge]: 'შესრულებულია',
    },
    print: {
        [Locale.Ru]: 'Распечатать',
        [Locale.Am]: 'Տպել',
        [Locale.En]: 'Print',
        [Locale.Pt]: 'Imprimir',
        [Locale.Ge]: 'ბეჭდვა',
    },
    printSecond: {
        [Locale.Ru]: 'Напечатать',
        [Locale.Am]: 'Տպել',
        [Locale.En]: 'Print',
        [Locale.Pt]: 'Imprimir',
        [Locale.Ge]: 'ბეჭდვა',
    },
    printFullEntry: {
        [Locale.Ru]: 'Распечатать всю запись',
        [Locale.Am]: 'Տպել ամբողջ գրառումը',
        [Locale.En]: 'Print full entry',
        [Locale.Pt]: 'Imprimir entrada completa',
        [Locale.Ge]: 'გამოქვეყნების ბეჭდვა',
    },
    printObjectiveEntry: {
        [Locale.Ru]: 'Распечатать объективное',
        [Locale.Am]: 'Տպել օբյեկտիվ տվյալները',
        [Locale.En]: 'Print objective',
        [Locale.Pt]: 'Imprimir alvo',
        [Locale.Ge]: 'Print objective',
    },
    signEDS: {
        [Locale.Ru]: 'Подписать с помощью ЭЦП',
        [Locale.Am]: 'Ստորագրել էլեկտրոնային ստորագրությամբ',
        [Locale.En]: 'Sign with EDS',
        [Locale.Pt]: 'Assinar com EDS',
        [Locale.Ge]: 'ნიშანი EDS-ით',
    },
    sign: {
        [Locale.Ru]: 'Подписать',
        [Locale.Am]: 'Ստորագրել',
        [Locale.En]: 'Sign',
        [Locale.Pt]: 'Assinar',
        [Locale.Ge]: 'ნიშანი',
    },
    group: {
        [Locale.Ru]: 'Группа',
        [Locale.Am]: 'Խումբ',
        [Locale.En]: 'Group',
        [Locale.Pt]: 'Grupo',
        [Locale.Ge]: 'ჯგუფი',
    },
    title: {
        [Locale.Ru]: 'Название',
        [Locale.Am]: 'Անվանում',
        [Locale.En]: 'Title',
        [Locale.Pt]: 'Título',
        [Locale.Ge]: 'სახელი',
    },
    name: {
        [Locale.Ru]: 'Имя',
        [Locale.Am]: 'Անուն',
        [Locale.En]: 'Name',
        [Locale.Pt]: 'Nome',
        [Locale.Ge]: 'სახელი',
    },
    firstName: {
        [Locale.Ru]: 'Имя',
        [Locale.Am]: 'Անուն',
        [Locale.En]: 'First name',
        [Locale.Pt]: 'Nome',
        [Locale.Ge]: 'სახელი',
    },
    lastName: {
        [Locale.Ru]: 'Фамилия',
        [Locale.Am]: 'Ազգանուն',
        [Locale.En]: 'Last name',
        [Locale.Pt]: 'Sobrenome',
        [Locale.Ge]: 'Last name',
    },
    oldLastName: {
        [Locale.Ru]: 'Старая фамилия',
        [Locale.Am]: 'Հին ազգանուն',
        [Locale.En]: 'Old last name',
        [Locale.Pt]: 'Sobrenome anterior',
        [Locale.Ge]: 'Old last name',
    },
    patronymic: {
        [Locale.Ru]: 'Отчество',
        [Locale.Am]: 'Հայրանուն',
        [Locale.En]: 'Patronymic',
        [Locale.Pt]: 'Nome do meio',
        [Locale.Ge]: 'Patronymic',
    },
    search: {
        [Locale.Ru]: 'Поиск',
        [Locale.Am]: 'Փնտրել',
        [Locale.En]: 'Search',
        [Locale.Pt]: 'Procurar',
        [Locale.Ge]: 'ძებნა',
    },
    makeSearch: {
        [Locale.Ru]: 'Искать',
        [Locale.Am]: 'Որոնել',
        [Locale.En]: 'Search',
        [Locale.Pt]: 'Pesquisar',
        [Locale.Ge]: 'ძებნა',
    },
    conclusion: {
        [Locale.Ru]: 'Заключение',
        [Locale.Am]: 'Եզրակացություն',
        [Locale.En]: 'Conclusion',
        [Locale.Pt]: 'Conclusão',
        [Locale.Ge]: 'დასკვნა',
    },
    shortConclusion: {
        [Locale.Ru]: 'Короткое заключение',
        [Locale.Am]: 'Կարճ եզրակացություն',
        [Locale.En]: 'Short conclusion',
        [Locale.Pt]: 'Conclusão curta',
        [Locale.Ge]: 'მოკლე დასკვნა',
    },
    printPlanAndDiagnosis: {
        [Locale.Ru]: 'Распечатать план и диагноз',
        [Locale.Am]: 'Տպել պլանը և ախտորոշումը',
        [Locale.En]: 'Print plan and diagnosis',
        [Locale.Pt]: 'Imprimir plano e diagnóstico',
        [Locale.Ge]: 'გამოქვეყნების ბეჭდვა',
    },
    printLabel: {
        [Locale.Ru]: 'Распечатать этикетку',
        [Locale.Am]: 'Տպել պիտակը',
        [Locale.En]: 'Print label',
        [Locale.Pt]: 'Imprimir etiqueta',
        [Locale.Ge]: 'ეტიკეტის დაბეჭდვა',
    },
    printIndividualReport: {
        [Locale.Ru]: 'Распечатать отчет',
        [Locale.Am]: 'Տպել հաշվետվությունը',
        [Locale.En]: 'Print report',
        [Locale.Pt]: 'porta',
        [Locale.Ge]: 'დაბეჭდეთ ანგარიში',
    },
    examinationLink: {
        [Locale.Ru]: 'Ссылка на исследование',
        [Locale.En]: 'Examination link',
        [Locale.Pt]: 'Link do exame',
        [Locale.Ge]: 'კვლევის ბმული',
        [Locale.Am]: 'Հետազոտության հղում',
    },
    addExaminationLink: {
        [Locale.Ru]: 'Добавить ссылку на исследование',
        [Locale.En]: 'Add examination link',
        [Locale.Pt]: 'Adicionar link do exame',
        [Locale.Ge]: 'კვლევის ბმულის დამატება',
        [Locale.Am]: 'Ավելացնել հետազոտության հղում',
    },
    updatePrintHtml: {
        [Locale.Ru]: 'Обновить печатное заключение',
        [Locale.En]: 'Update printed conclusion',
        [Locale.Pt]: 'Atualizar conclusão impressa',
        [Locale.Ge]: 'Update printed conclusion',
        [Locale.Am]: 'Թարմացնել տպվող եզրակացությունը',
    },
    changeDate: {
        [Locale.Ru]: 'Изменить дату',
        [Locale.Am]: 'Փոփոխել ամսաթիվը',
        [Locale.En]: 'Change date',
        [Locale.Pt]: 'Alterar data',
        [Locale.Ge]: 'თარიღის შეცვლა',
    },
    changeDoctor: {
        [Locale.Ru]: 'Изменить доктора',
        [Locale.Am]: 'Փոփոխել բժշկին',
        [Locale.En]: 'Change doctor',
        [Locale.Pt]: 'Alterar médico',
        [Locale.Ge]: 'შეცვალე ექიმი',
    },
    changeEntryData: {
        [Locale.Ru]: 'Изменить данные записи',
        [Locale.Am]: 'Փոփոխել գրառման տվյալները',
        [Locale.En]: 'Change entry data',
        [Locale.Pt]: 'Alterar dados da entrada',
        [Locale.Ge]: 'შეცვალეთ შესვლის დეტალები',
    },
    sendEmail: {
        [Locale.Ru]: 'Отправить на почту',
        [Locale.Am]: 'Ուղարկել էլ. փոստով',
        [Locale.En]: 'Send on email',
        [Locale.Pt]: 'Enviar por e-mail',
        [Locale.Ge]: 'ფოსტაზე გაგზავნა',
    },
    showFull: {
        [Locale.Ru]: 'Показать полностью',
        [Locale.Am]: 'Ցուցադրել ամբողջությամբ',
        [Locale.En]: 'Show full',
        [Locale.Pt]: 'Mostrar completo',
        [Locale.Ge]: 'შოუ სრულად',
    },
    collapse: {
        [Locale.Ru]: 'Свернуть',
        [Locale.Am]: 'Ծալել',
        [Locale.En]: 'Collapse',
        [Locale.Pt]: 'Recolher',
        [Locale.Ge]: 'კოლაფსი',
    },
    collapseAll: {
        [Locale.Ru]: 'Свернуть все',
        [Locale.Am]: 'Ծալել բոլորը',
        [Locale.En]: 'Collapse all',
        [Locale.Pt]: 'Recolher tudo',
        [Locale.Ge]: 'ყველას ჩამოშლა',
    },
    expandAll: {
        [Locale.Ru]: 'Развернуть все',
        [Locale.Am]: 'Բացել բոլորը',
        [Locale.En]: 'Expand all',
        [Locale.Pt]: 'Expandir tudo',
        [Locale.Ge]: 'ყველას გაფართოება',
    },
    opened: {
        [Locale.Ru]: 'Открыт',
        [Locale.Am]: 'Բաց է',
        [Locale.En]: 'Opened',
        [Locale.Pt]: 'Aberto',
        [Locale.Ge]: 'ღია',
    },
    open: {
        [Locale.Ru]: 'Открыть',
        [Locale.Am]: 'Բացել',
        [Locale.En]: 'Open',
        [Locale.Pt]: 'Abrir',
        [Locale.Ge]: 'ღია',
    },
    now: {
        [Locale.Ru]: 'Сегодня',
        [Locale.Am]: 'Այսօր',
        [Locale.En]: 'Now',
        [Locale.Pt]: 'Hoje',
        [Locale.Ge]: 'დღეს',
    },
    back: {
        [Locale.Ru]: 'Назад',
        [Locale.Am]: 'Հետ',
        [Locale.En]: 'Back',
        [Locale.Pt]: 'Voltar',
        [Locale.Ge]: 'უკან',
    },
    patient: {
        [Locale.Ru]: 'Пациент',
        [Locale.Am]: 'Պացիենտ',
        [Locale.En]: 'Patient',
        [Locale.Pt]: 'Paciente',
        [Locale.Ge]: 'პაციენტი',
    },
    patients: {
        [Locale.Ru]: 'Пациенты',
        [Locale.Am]: 'Պացիենտներ',
        [Locale.En]: 'Patients',
        [Locale.Pt]: 'Pacientes',
        [Locale.Ge]: 'პაციენტები',
    },
    doctor: {
        [Locale.Ru]: 'Доктор',
        [Locale.Am]: 'Բժիշկ',
        [Locale.En]: 'Doctor',
        [Locale.Pt]: 'Médico',
        [Locale.Ge]: 'ექიმი',
    },
    doctors: {
        [Locale.Ru]: 'Доктора',
        [Locale.Am]: 'Բժիշկներ',
        [Locale.En]: 'Doctors',
        [Locale.Pt]: 'Médicos',
        [Locale.Ge]: 'ექიმები',
    },
    coAuthors: {
        [Locale.Ru]: 'Соавторы',
        [Locale.Am]: 'Համահեղինակներ',
        [Locale.En]: 'Co-authors',
        [Locale.Pt]: 'Coautores',
        [Locale.Ge]: 'თანაავტორები',
    },
    closed: {
        [Locale.Ru]: 'Закрыт',
        [Locale.Am]: 'Փակ է',
        [Locale.En]: 'Closed',
        [Locale.Pt]: 'Fechado',
        [Locale.Ge]: 'დახურულია',
    },
    closedMasculine: {
        [Locale.Ru]: 'Закрытый',
        [Locale.Am]: 'Փակված',
        [Locale.En]: 'Closed',
        [Locale.Pt]: 'Fechado',
        [Locale.Ge]: 'დახურულია',
    },
    pause: {
        [Locale.Ru]: 'Пауза',
        [Locale.Am]: 'Դադար',
        [Locale.En]: 'Pause',
        [Locale.Pt]: 'Pausar',
        [Locale.Ge]: 'შეჩერება',
    },
    paused: {
        [Locale.Ru]: 'Приостановлен',
        [Locale.Am]: 'Կասեցված է',
        [Locale.En]: 'Paused',
        [Locale.Pt]: 'Lento',
        [Locale.Ge]: 'შეჩერებულია',
    },
    pausedMasculine: {
        [Locale.Ru]: 'Приостановленный',
        [Locale.Am]: 'Կասեցված',
        [Locale.En]: 'Paused',
        [Locale.Pt]: 'Lento',
        [Locale.Ge]: 'შეჩერებულია',
    },
    openedNow: {
        [Locale.Ru]: 'Открыт сегодня',
        [Locale.Am]: 'Բացվել է այսօր',
        [Locale.En]: 'Opened now',
        [Locale.Pt]: 'Aberto agora',
        [Locale.Ge]: 'გახსენი დღეს',
    },
    actions: {
        [Locale.Ru]: 'Действия',
        [Locale.Am]: 'Գործողություններ',
        [Locale.En]: 'Actions',
        [Locale.Pt]: 'Ações',
        [Locale.Ge]: 'მოქმედებები',
    },
    action: {
        [Locale.Ru]: 'Действие',
        [Locale.Am]: 'Գործողություն',
        [Locale.En]: 'Action',
        [Locale.Pt]: 'Ação',
        [Locale.Ge]: 'მოქმედებები',
    },
    condition: {
        [Locale.Ru]: 'Состояние',
        [Locale.Am]: 'Վիճակ',
        [Locale.En]: 'Condition',
        [Locale.Pt]: 'Condição',
        [Locale.Ge]: 'მდგომარეობა',
    },
    you: {
        [Locale.Ru]: 'Вы',
        [Locale.Am]: 'Դուք',
        [Locale.En]: 'You',
        [Locale.Pt]: 'Você',
        [Locale.Ge]: 'შენ',
    },
    description: {
        [Locale.Ru]: 'Описание',
        [Locale.Am]: 'Նկարագրություն',
        [Locale.En]: 'Descriptions',
        [Locale.Pt]: 'Descrição',
        [Locale.Ge]: 'აღწერილობა',
    },
    descriptionFrom: {
        [Locale.Ru]: 'Описание от',
        [Locale.Am]: 'Նկարագրություն՝',
        [Locale.En]: 'Descriptions from',
        [Locale.Pt]: 'Descrições de',
        [Locale.Ge]: 'აღწერილობა',
    },
    showMore: {
        [Locale.Ru]: 'Показать еще',
        [Locale.Am]: 'Ցուցադրել ավելին',
        [Locale.En]: 'Show more',
        [Locale.Pt]: 'Mostrar mais',
        [Locale.Ge]: 'მეტის ჩვენება',
    },
    showAlways: {
        [Locale.Ru]: 'Показывать всегда',
        [Locale.Am]: 'Ցուցադրել միշտ',
        [Locale.En]: 'Show always',
        [Locale.Pt]: 'Sempre mostrar',
        [Locale.Ge]: 'ჩვენება ყველაზე',
    },
    hide: {
        [Locale.Ru]: 'Скрыть',
        [Locale.Am]: 'Թաքցնել',
        [Locale.En]: 'Hide',
        [Locale.Pt]: 'Disfarce',
        [Locale.Ge]: 'დამალვა',
    },
    add: {
        [Locale.Ru]: 'Добавить',
        [Locale.Am]: 'Ավելացնել',
        [Locale.En]: 'Add',
        [Locale.Pt]: 'Adicionar',
        [Locale.Ge]: 'დამატება',
    },
    notSelected: {
        [Locale.Ru]: 'Не выбран',
        [Locale.Am]: 'Ընտրված չէ',
        [Locale.En]: 'Not selected',
        [Locale.Pt]: 'Não selecionado',
        [Locale.Ge]: 'არ არის არჩეული',
    },
    notSelectedFeminine: {
        [Locale.Ru]: 'Не выбрана',
        [Locale.Am]: 'Ընտրված չէ',
        [Locale.En]: 'Not selected',
        [Locale.Pt]: 'Não selecionada',
        [Locale.Ge]: 'არ არის არჩეული',
    },
    year: {
        [Locale.Ru]: 'Год',
        [Locale.Am]: 'Տարի',
        [Locale.En]: 'Year',
        [Locale.Pt]: 'Ano',
        [Locale.Ge]: 'წელი',
    },
    yearTwo: {
        [Locale.Ru]: 'Года',
        [Locale.Am]: 'Տարի',
        [Locale.En]: 'Years',
        [Locale.Pt]: 'Anos',
        [Locale.Ge]: 'წელი',
    },
    years: {
        [Locale.Ru]: 'Лет',
        [Locale.Am]: 'Տարի',
        [Locale.En]: 'Years',
        [Locale.Pt]: 'Anos',
        [Locale.Ge]: 'წელი',
    },
    result: {
        [Locale.Ru]: 'Итог',
        [Locale.Am]: 'Ընդամենը',
        [Locale.En]: 'Total',
        [Locale.Pt]: 'Resultado',
        [Locale.Ge]: 'შედეგი',
    },
    total: {
        [Locale.Ru]: 'Всего',
        [Locale.Am]: 'Ընդամենը',
        [Locale.En]: 'Total',
        [Locale.Pt]: 'Total',
        [Locale.Ge]: 'Total',
    },
    totalSecond: {
        [Locale.Ru]: 'Итого',
        [Locale.Am]: 'Ընդամենը',
        [Locale.En]: 'Total',
        [Locale.Pt]: 'Total',
        [Locale.Ge]: 'სულ',
    },
    term: {
        [Locale.Ru]: 'Срок',
        [Locale.Am]: 'Ժամկետ',
        [Locale.En]: 'Term',
        [Locale.Pt]: 'Termo',
        [Locale.Ge]: 'ბოლო ვადა',
    },
    inputYear: {
        [Locale.Ru]: 'Введите год',
        [Locale.Am]: 'Մուտքագրեք տարին',
        [Locale.En]: 'Input year',
        [Locale.Pt]: 'Ano de entrada',
        [Locale.Ge]: 'შეიყვანეთ წელი',
    },
    inputTerm: {
        [Locale.Ru]: 'Введите итог',
        [Locale.Am]: 'Մուտքագրեք արդյունքը',
        [Locale.En]: 'Input term',
        [Locale.Pt]: 'Termo de entrada',
        [Locale.Ge]: 'შეიყვანეთ მთლიანი',
    },
    inputTotal: {
        [Locale.Ru]: 'Введите срок',
        [Locale.Am]: 'Մուտքագրեք ժամկետը',
        [Locale.En]: 'Input total',
        [Locale.Pt]: 'Total de entrada',
        [Locale.Ge]: 'შეიყვანეთ ტერმინი',
    },
    concluded: {
        [Locale.Ru]: 'Заключен',
        [Locale.Am]: 'Կնքված է',
        [Locale.En]: 'Concluded',
        [Locale.Pt]: 'Concluído',
        [Locale.Ge]: 'დასრულებულია',
    },
    heading: {
        [Locale.Ru]: 'Заголовок',
        [Locale.Am]: 'Վերնագիր',
        [Locale.En]: 'Heading',
        [Locale.Pt]: 'Cabeçalho',
        [Locale.Ge]: 'სათაური',
    },
    synonyms: {
        [Locale.Ru]: 'Синонимы',
        [Locale.Am]: 'Հոմանիշներ',
        [Locale.En]: 'Synonyms',
        [Locale.Pt]: 'Sinônimos',
        [Locale.Ge]: 'სინონიმები',
    },
    toFavorites: {
        [Locale.Ru]: 'В избранное',
        [Locale.Am]: 'Ավելացնել ընտրյալներին',
        [Locale.En]: 'To favorites',
        [Locale.Pt]: 'Para favoritos',
        [Locale.Ge]: 'დაამატე რჩეულებში',
    },
    new: {
        [Locale.Ru]: 'Новый',
        [Locale.Am]: 'Նոր',
        [Locale.En]: 'New',
        [Locale.Pt]: 'novo',
        [Locale.Ge]: 'ახალი',
    },
    startNew: {
        [Locale.Ru]: 'Начать новый',
        [Locale.Am]: 'Սկսել նորը',
        [Locale.En]: 'Start new',
        [Locale.Pt]: 'Comece novo',
        [Locale.Ge]: 'დაწყება ახალი',
    },
    startRecord: {
        [Locale.Ru]: 'Начать запись',
        [Locale.Am]: 'Սկսել գրառումը',
        [Locale.En]: 'Start record',
        [Locale.Pt]: 'Iniciar gravação',
        [Locale.Ge]: 'დაწყება რეგისტრაცია',
    },
    startNewRecord: {
        [Locale.Ru]: 'Начать новую аудиозапись',
        [Locale.Am]: 'Սկսել նոր ձայնագրություն',
        [Locale.En]: 'Start a new audio record',
        [Locale.Pt]: 'Iniciar uma nova gravação',
        [Locale.Ge]: 'ახალი აუდიოჩანაწერის დაწყება',
    },
    process: {
        [Locale.Ru]: 'Обработать',
        [Locale.Am]: 'Մշակել',
        [Locale.En]: 'Process',
        [Locale.Pt]: 'Processo',
        [Locale.Ge]: 'განახლება',
    },
    processed: {
        [Locale.Ru]: 'Обработано',
        [Locale.Am]: 'Վերամշակված',
        [Locale.En]: 'Processed',
        [Locale.Pt]: 'Processado',
        [Locale.Ge]: 'დამუშავებული',
    },
    retrySendForTranscription: {
        [Locale.Ru]: 'Отправить заново на расшифровку',
        [Locale.Am]: 'Կրկին ուղարկել վերծանման',
        [Locale.En]: 'Resend for transcription',
        [Locale.Pt]: 'Reenviar para transcrição',
        [Locale.Ge]: 'ხელახლა გაგზავნა გაშიფვრისთვის',
    },
    dictaphoneTranscriptionError: {
        [Locale.Ru]: 'Ошибка обработки аудиозаписи. Все данные сохранились, попробуйте отправить на обработку ещё раз',
        [Locale.Am]: 'Ձայնագրության մշակման սխալ։ Բոլոր տվյալները պահպանվել են, փորձեք կրկին ուղարկել մշակման։',
        [Locale.En]: 'Failed to process the audio record. Nothing was lost, try sending it for processing once more.',
        [Locale.Pt]: 'Falha ao processar a gravação. Nenhum dado foi perdido, tente enviá-la para processamento novamente.',
        [Locale.Ge]: 'აუდიოჩანაწერის დამუშავების შეცდომა. ყველა მონაცემი შენახულია, სცადეთ ხელახლა გაგზავნა დასამუშავებლად',
    },
    listenRecord: {
        [Locale.Ru]: 'Прослушать запись',
        [Locale.Am]: 'Լսել ձայնագրությունը',
        [Locale.En]: 'Listen record',
        [Locale.Pt]: 'Ouça o registro',
        [Locale.Ge]: 'შესახებ რეგისტრაცია',
    },
    deleteAudioRecord: {
        [Locale.Ru]: 'Удалить аудиозапись',
        [Locale.Am]: 'Ջնջել ձայնագրությունը',
        [Locale.En]: 'Delete audio record',
        [Locale.Pt]: 'Excluir gravação de áudio',
        [Locale.Ge]: 'წაშლა აუდრია რეგისტრაცია',
    },
    newNeutral: {
        [Locale.Ru]: 'Новое',
        [Locale.Am]: 'Նոր',
        [Locale.En]: 'New',
        [Locale.Pt]: 'novo',
        [Locale.Ge]: 'ახალი',
    },
    favorite: {
        [Locale.Ru]: 'Избранное',
        [Locale.Am]: 'Ընտրյալներ',
        [Locale.En]: 'Favorite',
        [Locale.Pt]: 'Favorito',
        [Locale.Ge]: 'რჩეულები',
    },
    nothingFound: {
        [Locale.Ru]: 'Ничего не найдено',
        [Locale.Am]: 'Ոչինչ չի գտնվել',
        [Locale.En]: 'Nothing found',
        [Locale.Pt]: 'Nada encontrado',
        [Locale.Ge]: 'არაფერი ნაპოვნია',
    },
    nothingFoundTryChangeRequest: {
        [Locale.Ru]: 'Ничего не найдено. Попробуйте изменить условия поиска',
        [Locale.Am]: 'Ոչինչ չի գտնվել։ Փորձեք փոխել որոնման պայմանները',
        [Locale.En]: 'Nothing found. Try changing your search terms',
        [Locale.Pt]: 'Nada encontrado. Tente alterar seus termos de pesquisa',
        [Locale.Ge]: 'Nothing found. Try changing your search terms',
    },
    referralBoundToScheduleReservation: {
        [Locale.Ru]: 'Направление привязано к брони расписания. Отвязать направление от брони и ответить на него?',
        [Locale.Am]: 'Ուղեգիրը կապված է ժամանակացույցի ամրագրման հետ։ Անջատե՞լ ուղեգիրը ամրագրումից և պատասխանել դրան։',
        [Locale.En]: 'The referral is bound to a schedule reservation. Unbind the referral from the reservation and answer it?',
        [Locale.Pt]: 'O encaminhamento está vinculado a uma reserva da agenda. Desvincular o encaminhamento da reserva e respondê-lo?',
        [Locale.Ge]: 'The referral is bound to a schedule reservation. Unbind the referral from the reservation and answer it?',
    },
    referral: {
        [Locale.Ru]: 'Направление',
        [Locale.Am]: 'Ուղեգիր',
        [Locale.En]: 'Referral',
        [Locale.Pt]: 'Indicação',
        [Locale.Ge]: 'მიმართულება',
    },
    referrals: {
        [Locale.Ru]: 'Направления',
        [Locale.Am]: 'Ուղեգրեր',
        [Locale.En]: 'Referrals',
        [Locale.Pt]: 'Indicações',
        [Locale.Ge]: 'მიმართულება',
    },
    referralMany: {
        [Locale.Ru]: 'Направлений',
        [Locale.Am]: 'Ուղեգրեր',
        [Locale.En]: 'Referrals',
        [Locale.Pt]: 'Indicações',
        [Locale.Ge]: 'მიმართულება',
    },
    medicine: {
        [Locale.Ru]: 'Медикамент',
        [Locale.Am]: 'Դեղամիջոց',
        [Locale.En]: 'Drug',
        [Locale.Pt]: 'Medicamento',
        [Locale.Ge]: 'მედიკამენტები',
    },
    task: {
        [Locale.Ru]: 'Задание',
        [Locale.Am]: 'Առաջադրանք',
        [Locale.En]: 'Task',
        [Locale.Pt]: 'Tarefa',
        [Locale.Ge]: 'დავალება',
    },
    recommendation: {
        [Locale.Ru]: 'Рекомендация',
        [Locale.Am]: 'Հանձնարարական',
        [Locale.En]: 'Recommendation',
        [Locale.Pt]: 'Recomendação',
        [Locale.Ge]: 'რეკომენდაცია',
    },
    recommendations: {
        [Locale.Ru]: 'Рекомендации',
        [Locale.Am]: 'Հանձնարարականներ',
        [Locale.En]: 'Recommendations',
        [Locale.Pt]: 'Recomendações',
        [Locale.Ge]: 'რეკომენდაციები',
    },
    examination: {
        [Locale.Ru]: 'Осмотр',
        [Locale.Am]: 'Զննում',
        [Locale.En]: 'Examination',
        [Locale.Pt]: 'Exame',
        [Locale.Ge]: 'Examination',
    },
    signed: {
        [Locale.Ru]: 'Подписана',
        [Locale.Am]: 'Ստորագրված է',
        [Locale.En]: 'Signed',
        [Locale.Pt]: 'Assinado',
        [Locale.Ge]: 'Signed',
    },
    draft: {
        [Locale.Ru]: 'Черновик',
        [Locale.Am]: 'Սևագիր',
        [Locale.En]: 'Draft',
        [Locale.Pt]: 'Rascunho',
        [Locale.Ge]: 'პროექტი',
    },
    drafts: {
        [Locale.Ru]: 'Черновики',
        [Locale.Am]: 'Նախագծեր',
        [Locale.En]: 'Drafts',
        [Locale.Pt]: 'Rascunhos',
        [Locale.Ge]: 'პროექტები',
    },
    assistant: {
        [Locale.Ru]: 'Ассистент',
        [Locale.Am]: 'Օգնական',
        [Locale.En]: 'Assistant',
        [Locale.Pt]: 'Assistente',
        [Locale.Ge]: 'ასისტენტი',
    },
    assistants: {
        [Locale.Ru]: 'Ассистенты',
        [Locale.Am]: 'Օգնականներ',
        [Locale.En]: 'Assistants',
        [Locale.Pt]: 'Assistentes',
        [Locale.Ge]: 'ასისტენტი',
    },
    assistantFirstShift: {
        [Locale.Ru]: 'Ассистент 1 смены',
        [Locale.Am]: '1-ին հերթափոխի օգնական',
        [Locale.En]: 'Shift 1 assistant',
        [Locale.Pt]: 'Assistente do turno 1',
        [Locale.Ge]: 'Shift 1 assistant',
    },
    assistantSecondShift: {
        [Locale.Ru]: 'Ассистент 2 смены',
        [Locale.Am]: '2-րդ հերթափոխի օգնական',
        [Locale.En]: 'Shift 2 assistant',
        [Locale.Pt]: 'Assistente do turno 2',
        [Locale.Ge]: 'Shift 2 assistant',
    },
    assistantsFirstShift: {
        [Locale.Ru]: 'Ассистенты 1 смены',
        [Locale.Am]: '1-ին հերթափոխի օգնականներ',
        [Locale.En]: 'Shift 1 assistants',
        [Locale.Pt]: 'Assistentes do turno 1',
        [Locale.Ge]: 'Shift 1 assistants',
    },
    assistantsSecondShift: {
        [Locale.Ru]: 'Ассистенты 2 смены',
        [Locale.Am]: '2-րդ հերթափոխի օգնականներ',
        [Locale.En]: 'Shift 2 assistants',
        [Locale.Pt]: 'Assistentes do turno 2',
        [Locale.Ge]: 'Shift 2 assistants',
    },
    additionalDoctors: {
        [Locale.Ru]: 'Дополнительные врачи',
        [Locale.Am]: 'Լրացուցիչ բժիշկներ',
        [Locale.En]: 'Additional doctors',
        [Locale.Pt]: 'Médicos adicionais',
        [Locale.Ge]: 'Additional doctors',
    },
    additionalDoctorFirstShift: {
        [Locale.Ru]: 'Дополнительный врач 1 смены',
        [Locale.Am]: '1-ին հերթափոխի լրացուցիչ բժիշկ',
        [Locale.En]: 'Shift 1 additional doctor',
        [Locale.Pt]: 'Médico adicional do turno 1',
        [Locale.Ge]: 'Shift 1 additional doctor',
    },
    additionalDoctorSecondShift: {
        [Locale.Ru]: 'Дополнительный врач 2 смены',
        [Locale.Am]: '2-րդ հերթափոխի լրացուցիչ բժիշկ',
        [Locale.En]: 'Shift 2 additional doctor',
        [Locale.Pt]: 'Médico adicional do turno 2',
        [Locale.Ge]: 'Shift 2 additional doctor',
    },
    additionalDoctorsFirstShift: {
        [Locale.Ru]: 'Дополнительные врачи 1 смены',
        [Locale.Am]: '1-ին հերթափոխի լրացուցիչ բժիշկներ',
        [Locale.En]: 'Shift 1 additional doctors',
        [Locale.Pt]: 'Médicos adicionais do turno 1',
        [Locale.Ge]: 'Shift 1 additional doctors',
    },
    additionalDoctorsSecondShift: {
        [Locale.Ru]: 'Дополнительные врачи 2 смены',
        [Locale.Am]: '2-րդ հերթափոխի լրացուցիչ բժիշկներ',
        [Locale.En]: 'Shift 2 additional doctors',
        [Locale.Pt]: 'Médicos adicionais do turno 2',
        [Locale.Ge]: 'Shift 2 additional doctors',
    },
    piece: {
        [Locale.Ru]: 'шт.',
        [Locale.Am]: 'հատ',
        [Locale.En]: 'pcs.',
        [Locale.Pt]: 'peças.',
        [Locale.Ge]: 'pcs.',
    },
    appointed: {
        [Locale.Ru]: 'Назначил',
        [Locale.Am]: 'Նշանակել է',
        [Locale.En]: 'Appointed by',
        [Locale.Pt]: 'Nomeado por',
        [Locale.Ge]: 'დანიშნულია',
    },
    appointedByDoctor: {
        [Locale.Ru]: 'Назначил доктор',
        [Locale.Am]: 'Նշանակել է բժիշկը',
        [Locale.En]: 'Appointed by doctor',
        [Locale.Pt]: 'Nomeado pelo médico',
        [Locale.Ge]: 'ექიმმა დანიშნა',
    },
    performed: {
        [Locale.Ru]: 'Исполнено',
        [Locale.Am]: 'Կատարված է',
        [Locale.En]: 'Performed',
        [Locale.Pt]: 'Realizado',
        [Locale.Ge]: 'შესრულებულია',
    },
    expired: {
        [Locale.Ru]: 'Истекло',
        [Locale.Am]: 'Ժամկետն անցել է',
        [Locale.En]: 'Expired',
        [Locale.Pt]: 'Expirado',
        [Locale.Ge]: 'Expired',
    },
    expiredFem: {
        [Locale.Ru]: 'Истекла',
        [Locale.Am]: 'Ժամկետն անցել է',
        [Locale.En]: 'Expired',
        [Locale.Pt]: 'Expirado',
        [Locale.Ge]: 'Expired',
    },
    inProgress: {
        [Locale.Ru]: 'В процессе',
        [Locale.Am]: 'Ընթացքի մեջ',
        [Locale.En]: 'In progress',
        [Locale.Pt]: 'Em andamento',
        [Locale.Ge]: 'In progress',
    },
    visit: {
        [Locale.Ru]: 'Визит',
        [Locale.Am]: 'Այց',
        [Locale.En]: 'Visit',
        [Locale.Pt]: 'Visita',
        [Locale.Ge]: 'ვიზიტი',
    },
    from: {
        [Locale.Ru]: 'От',
        [Locale.Am]: 'Սկսած',
        [Locale.En]: 'From',
        [Locale.Pt]: 'De',
        [Locale.Ge]: 'დან',
    },
    fromIz: {
        [Locale.Ru]: 'из',
        [Locale.Am]: 'ից',
        [Locale.En]: 'from',
        [Locale.Pt]: 'de',
        [Locale.Ge]: 'დან',
    },
    programs: {
        [Locale.Ru]: 'Программы',
        [Locale.Am]: 'Ծրագրեր',
        [Locale.En]: 'Plans',
        [Locale.Pt]: 'Planos',
        [Locale.Ge]: 'პროგრამები',
    },
    indefinitely: {
        [Locale.Ru]: 'Бессрочно',
        [Locale.Am]: 'Անժամկետ',
        [Locale.En]: 'Indefinitely',
        [Locale.Pt]: 'Indefinidamente',
        [Locale.Ge]: 'განუსაზღვრელი ვადით',
    },
    fillAllFreeTimeForDay: {
        [Locale.Ru]: 'Заполнить все свободное время на день',
        [Locale.Am]: 'Լրացնել օրվա ամբողջ ազատ ժամանակը',
        [Locale.En]: 'Fill all free time for the day',
        [Locale.Pt]: 'Preencher todo o tempo livre do dia',
        [Locale.Ge]: 'დღის მთელი თავისუფალი დროის შევსება',
    },
    fromSecond: {
        [Locale.Ru]: 'С',
        [Locale.Am]: 'Սկսած',
        [Locale.En]: 'From',
        [Locale.Pt]: 'De',
        [Locale.Ge]: 'თან',
    },
    to: {
        [Locale.Ru]: 'По',
        [Locale.Am]: 'Մինչև',
        [Locale.En]: 'To',
        [Locale.Pt]: 'Para',
        [Locale.Ge]: 'მიერ',
    },
    toSecond: {
        [Locale.Ru]: 'До',
        [Locale.Am]: 'Մինչև',
        [Locale.En]: 'To',
        [Locale.Pt]: 'Para',
        [Locale.Ge]: 'მიერ',
    },
    clearSearch: {
        [Locale.Ru]: 'Очистить поиск',
        [Locale.Am]: 'Մաքրել որոնումը',
        [Locale.En]: 'Clear search',
        [Locale.Pt]: 'Limpar busca',
        [Locale.Ge]: 'ძიების გასუფთავება',
    },
    clear: {
        [Locale.Ru]: 'Очистить',
        [Locale.Am]: 'Մաքրել',
        [Locale.En]: 'Clear',
        [Locale.Pt]: 'Limpar',
        [Locale.Ge]: 'გასუფთავება',
    },
    clearTitle: {
        [Locale.Ru]: 'Очистить заголовок',
        [Locale.Am]: 'Մաքրել վերնագիրը',
        [Locale.En]: 'Clear title',
        [Locale.Pt]: 'Limpar título',
        [Locale.Ge]: 'გასუფთავება სათაური',
    },
    allOne: {
        [Locale.Ru]: 'Весь',
        [Locale.Am]: 'Ամբողջը',
        [Locale.En]: 'All',
        [Locale.Pt]: 'Todos',
        [Locale.Ge]: 'ყველა',
    },
    all: {
        [Locale.Ru]: 'Все',
        [Locale.Am]: 'Բոլորը',
        [Locale.En]: 'All',
        [Locale.Pt]: 'Tudo',
        [Locale.Ge]: 'ყველა',
    },
    return: {
        [Locale.Ru]: 'Вернуть',
        [Locale.Am]: 'Վերադարձնել',
        [Locale.En]: 'Return',
        [Locale.Pt]: 'Retornar',
        [Locale.Ge]: 'დაბრუნება',
    },
    start: {
        [Locale.Ru]: 'Начало',
        [Locale.Am]: 'Սկիզբ',
        [Locale.En]: 'Start',
        [Locale.Pt]: 'Começar',
        [Locale.Ge]: 'დაწყება',
    },
    startSecond: {
        [Locale.Ru]: 'Начать',
        [Locale.Am]: 'Սկսել',
        [Locale.En]: 'Start',
        [Locale.Pt]: 'Começar',
        [Locale.Ge]: 'დაწყება',
    },
    end: {
        [Locale.Ru]: 'Окончание',
        [Locale.Am]: 'Ավարտ',
        [Locale.En]: 'End',
        [Locale.Pt]: 'Fim',
        [Locale.Ge]: 'დასასრული',
    },
    startAction: {
        [Locale.Ru]: 'Начало действия',
        [Locale.Am]: 'Գործողության սկիզբ',
        [Locale.En]: 'Start action',
        [Locale.Pt]: 'Iniciar ação',
        [Locale.Ge]: 'მოქმედების დაწყება',
    },
    endAction: {
        [Locale.Ru]: 'Окончание действия',
        [Locale.Am]: 'Գործողության ավարտ',
        [Locale.En]: 'End action',
        [Locale.Pt]: 'Finalizar ação',
        [Locale.Ge]: 'End action',
    },
    clinic: {
        [Locale.Ru]: 'Клиника',
        [Locale.Am]: 'Կլինիկա',
        [Locale.En]: 'Clinic',
        [Locale.Pt]: 'Clínica',
        [Locale.Ge]: 'კლინიკა',
    },
    myClinic: {
        [Locale.Ru]: 'Моя клиника',
        [Locale.Am]: 'Իմ կլինիկան',
        [Locale.En]: 'My clinic',
        [Locale.Pt]: 'Minha clínica',
        [Locale.Ge]: 'My clinic',
    },
    cancelChanges: {
        [Locale.Ru]: 'Отменить изменения',
        [Locale.Am]: 'Չեղարկել փոփոխությունները',
        [Locale.En]: 'Cancel Changes',
        [Locale.Pt]: 'Cancelar alterações',
        [Locale.Ge]: 'ცვლილებების დაბრუნება',
    },
    quantity: {
        [Locale.Ru]: 'Количество',
        [Locale.Am]: 'Քանակ',
        [Locale.En]: 'Quantity',
        [Locale.Pt]: 'Quantidade',
        [Locale.Ge]: 'თანხა',
    },
    quantityShort: {
        [Locale.Ru]: 'Кол-во',
        [Locale.Am]: 'Քանակ',
        [Locale.En]: 'Quantity',
        [Locale.Pt]: 'Quantidade',
        [Locale.Ge]: 'თანხა',
    },
    okay: {
        [Locale.Ru]: 'Понятно',
        [Locale.Am]: 'Հասկանալի է',
        [Locale.En]: 'Okay',
        [Locale.Pt]: 'OK',
        [Locale.Ge]: 'დიდი',
    },
    comment: {
        [Locale.Ru]: 'Комментарий',
        [Locale.Am]: 'Մեկնաբանություն',
        [Locale.En]: 'Comment',
        [Locale.Pt]: 'Comentário',
        [Locale.Ge]: 'კომენტარი',
    },
    comments: {
        [Locale.Ru]: 'Комментарии',
        [Locale.Am]: 'Մեկնաբանություններ',
        [Locale.En]: 'Comments',
        [Locale.Pt]: 'Comentários',
        [Locale.Ge]: 'კომენტარი',
    },
    instructions: {
        [Locale.Ru]: 'Указания',
        [Locale.Am]: 'Ցուցումներ',
        [Locale.En]: 'Instructions',
        [Locale.Pt]: 'Instruções',
        [Locale.Ge]: 'ინსტრუქციები',
    },
    assign: {
        [Locale.Ru]: 'Назначить',
        [Locale.Am]: 'Նշանակել',
        [Locale.En]: 'Assign',
        [Locale.Pt]: 'Atribuir',
        [Locale.Ge]: 'მინიშნება',
    },
    chosenOne: {
        [Locale.Ru]: 'Выбран',
        [Locale.Am]: 'Ընտրված է',
        [Locale.En]: 'Chosen',
        [Locale.Pt]: 'Escolhido',
        [Locale.Ge]: 'შერჩეული',
    },
    chosen: {
        [Locale.Ru]: 'Выбрано',
        [Locale.Am]: 'Ընտրված է',
        [Locale.En]: 'Chosen',
        [Locale.Pt]: 'Escolhido',
        [Locale.Ge]: 'შერჩეული',
    },
    chosenFem: {
        [Locale.Ru]: 'Выбрана',
        [Locale.Am]: 'Ընտրված է',
        [Locale.En]: 'Chosen',
        [Locale.Pt]: 'Escolhido',
        [Locale.Ge]: 'შერჩეული',
    },
    take: {
        [Locale.Ru]: 'Принимать',
        [Locale.Am]: 'Ընդունել',
        [Locale.En]: 'Take',
        [Locale.Pt]: 'Pegar',
        [Locale.Ge]: 'მიღება',
    },
    inputValue: {
        [Locale.Ru]: 'Введите значение',
        [Locale.Am]: 'Մուտքագրեք արժեքը',
        [Locale.En]: 'Input value',
        [Locale.Pt]: 'Valor de entrada',
        [Locale.Ge]: 'შეიყვანეთ მნიშვნელობა',
    },
    loading: {
        [Locale.Ru]: 'Идет загрузка...',
        [Locale.Am]: 'Բեռնվում է...',
        [Locale.En]: 'Loading...',
        [Locale.Pt]: 'Carregando...',
        [Locale.Ge]: 'იტვირთება...',
    },
    participants: {
        [Locale.Ru]: 'Участники',
        [Locale.Am]: 'Մասնակիցներ',
        [Locale.En]: 'Participants',
        [Locale.Pt]: 'Participantes',
        [Locale.Ge]: 'მონაწილეები',
    },
    author: {
        [Locale.Ru]: 'Автор',
        [Locale.Am]: 'Հեղինակ',
        [Locale.En]: 'Author',
        [Locale.Pt]: 'Autor',
        [Locale.Ge]: 'ავტორი',
    },
    taskAuthor: {
        [Locale.Ru]: 'Автор задания',
        [Locale.Am]: 'Առաջադրանքի հեղինակ',
        [Locale.En]: 'Task author',
        [Locale.Pt]: 'Autor da tarefa',
        [Locale.Ge]: 'თემის ავტორი',
    },
    requester: {
        [Locale.Ru]: 'Заявитель',
        [Locale.Am]: 'Դիմող',
        [Locale.En]: 'Applicant',
        [Locale.Pt]: 'Requerente',
        [Locale.Ge]: 'განმცხადებელი',
    },
    dateTimeFrame: {
        [Locale.Ru]: 'Когда нужно сделать',
        [Locale.Am]: 'Երբ է անհրաժեշտ կատարել',
        [Locale.En]: 'When to do it',
        [Locale.Pt]: 'Quando fazer',
        [Locale.Ge]: 'როდის უნდა გავაკეთოთ ეს',
    },
    creationDate: {
        [Locale.Ru]: 'Дата создания',
        [Locale.Am]: 'Ստեղծման ամսաթիվ',
        [Locale.En]: 'Creation date',
        [Locale.Pt]: 'Data de criação',
        [Locale.Ge]: 'შექმნის თარიღი',
    },
    startDate: {
        [Locale.Ru]: 'Дата начала',
        [Locale.Am]: 'Սկզբի ամսաթիվ',
        [Locale.En]: 'Start date',
        [Locale.Pt]: 'Data de início',
        [Locale.Ge]: 'Start date',
    },
    endDate: {
        [Locale.Ru]: 'Дата окончания',
        [Locale.Am]: 'Ավարտի ամսաթիվ',
        [Locale.En]: 'End date',
        [Locale.Pt]: 'Data de término',
        [Locale.Ge]: 'End date',
    },
    endDateInclusive: {
        [Locale.Ru]: 'Дата окончания (включительно)',
        [Locale.Am]: 'Ավարտի ամսաթիվ (ներառյալ)',
        [Locale.En]: 'End date (inclusive)',
        [Locale.Pt]: 'Data de término (inclusive)',
        [Locale.Ge]: 'End date (inclusive)',
    },
    repeat: {
        [Locale.Ru]: 'Повторять',
        [Locale.Am]: 'Կրկնել',
        [Locale.En]: 'Repeat',
        [Locale.Pt]: 'Repetir',
        [Locale.Ge]: 'Repeat',
    },
    onSelectedDays: {
        [Locale.Ru]: 'В выбранные дни',
        [Locale.Am]: 'Ընտրված օրերին',
        [Locale.En]: 'On selected days',
        [Locale.Pt]: 'Nos dias selecionados',
        [Locale.Ge]: 'On selected days',
    },
    doNotRepeat: {
        [Locale.Ru]: 'Не повторять',
        [Locale.Am]: 'Չկրկնել',
        [Locale.En]: 'Do not repeat',
        [Locale.Pt]: 'Não repetir',
        [Locale.Ge]: 'Do not repeat',
    },
    creationTime: {
        [Locale.Ru]: 'Время создания',
        [Locale.Am]: 'Ստեղծման ժամ',
        [Locale.En]: 'Creation Time',
        [Locale.Pt]: 'Hora de criação',
        [Locale.Ge]: 'შექმნის დრო',
    },
    visitDate: {
        [Locale.Ru]: 'Дата приема',
        [Locale.Am]: 'Ընդունելության ամսաթիվ',
        [Locale.En]: 'Visit date',
        [Locale.Pt]: 'Data da visita',
        [Locale.Ge]: 'ვიზიტის თარიღი',
    },
    runFrom: {
        [Locale.Ru]: 'Выполнить c',
        [Locale.Am]: 'Կատարել սկսած',
        [Locale.En]: 'Run from',
        [Locale.Pt]: 'Fugir de',
        [Locale.Ge]: 'გაიქეცი',
    },
    runTo: {
        [Locale.Ru]: 'Выполнить до',
        [Locale.Am]: 'Կատարել մինչև',
        [Locale.En]: 'Run to',
        [Locale.Pt]: 'Corra para',
        [Locale.Ge]: 'გაიქცე',
    },
    doFrom: {
        [Locale.Ru]: 'Сделать с',
        [Locale.Am]: 'Անել սկսած',
        [Locale.En]: 'Do from',
        [Locale.Pt]: 'Fazer a partir de',
        [Locale.Ge]: 'გააკეთეთ -დან',
    },
    doTo: {
        [Locale.Ru]: 'Сделать до',
        [Locale.Am]: 'Անել մինչև',
        [Locale.En]: 'Do by',
        [Locale.Pt]: 'Fazer até',
        [Locale.Ge]: 'გააკეთეთ -მდე',
    },
    date: {
        [Locale.Ru]: 'Дата',
        [Locale.Am]: 'Ամսաթիվ',
        [Locale.En]: 'Date',
        [Locale.Pt]: 'Dados',
        [Locale.Ge]: 'თარიღი',
    },
    time: {
        [Locale.Ru]: 'Время',
        [Locale.Am]: 'Ժամ',
        [Locale.En]: 'Time',
        [Locale.Pt]: 'Hora',
        [Locale.Ge]: 'დრო',
    },
    urgency: {
        [Locale.Ru]: 'Срочность',
        [Locale.Am]: 'Հրատապություն',
        [Locale.En]: 'Urgency',
        [Locale.Pt]: 'Urgência',
        [Locale.Ge]: 'გადაუდებელი',
    },
    taskType: {
        [Locale.Ru]: 'Тип задачи',
        [Locale.Am]: 'Առաջադրանքի տեսակ',
        [Locale.En]: 'Task Type',
        [Locale.Pt]: 'Tipo de tarefa',
        [Locale.Ge]: 'დავალების ტიპი',
    },
    taskTypeSecond: {
        [Locale.Ru]: 'Тип задания',
        [Locale.Am]: 'Առաջադրանքի տեսակ',
        [Locale.En]: 'Task type',
        [Locale.Pt]: 'Tipo de tarefa',
        [Locale.Ge]: 'დავალების ტიპი',
    },
    chooseFromList: {
        [Locale.Ru]: 'Выберите из списка',
        [Locale.Am]: 'Ընտրեք ցանկից',
        [Locale.En]: 'Select from the list',
        [Locale.Pt]: 'Selecione na lista',
        [Locale.Ge]: 'აირჩიეთ სიიდან',
    },
    episodeOfCare: {
        [Locale.Ru]: 'Эпизод',
        [Locale.Am]: 'Էպիզոդ',
        [Locale.En]: 'Episode of care',
        [Locale.Pt]: 'Episódio de cuidado',
        [Locale.Ge]: 'ზრუნვის ეპიზოდი',
    },
    accept: {
        [Locale.Ru]: 'Принять',
        [Locale.Am]: 'Ընդունել',
        [Locale.En]: 'Accept',
        [Locale.Pt]: 'Aceitar',
        [Locale.Ge]: 'მიღება',
    },
    decline: {
        [Locale.Ru]: 'Отклонить',
        [Locale.Am]: 'Մերժել',
        [Locale.En]: 'Decline',
        [Locale.Pt]: 'Recusar',
        [Locale.Ge]: 'უარი',
    },
    close: {
        [Locale.Ru]: 'Закрыть',
        [Locale.Am]: 'Փակել',
        [Locale.En]: 'Close',
        [Locale.Pt]: 'Fechar',
        [Locale.Ge]: 'დახურვა',
    },
    deleteDoctorShiftConfirm: {
        [Locale.Ru]: 'Вы хотите удалить смену доктора',
        [Locale.Am]: 'Ցանկանում եք ջնջել բժշկի հերթափոխը',
        [Locale.En]: 'Do you want to delete the doctor shift',
        [Locale.Pt]: 'Deseja excluir o turno do médico',
        [Locale.Ge]: 'Do you want to delete the doctor shift',
    },
    deleteAssistantShiftConfirm: {
        [Locale.Ru]: 'Вы хотите удалить смену ассистента',
        [Locale.Am]: 'Ցանկանում եք ջնջել օգնականի հերթափոխը',
        [Locale.En]: 'Do you want to delete the assistant shift',
        [Locale.Pt]: 'Deseja excluir o turno do assistente',
        [Locale.Ge]: 'Do you want to delete the assistant shift',
    },
    deleteAdditionalDoctorShiftConfirm: {
        [Locale.Ru]: 'Вы хотите удалить смену доп. доктора',
        [Locale.Am]: 'Ցանկանում եք ջնջել լրացուցիչ բժշկի հերթափոխը',
        [Locale.En]: 'Do you want to delete the additional doctor shift',
        [Locale.Pt]: 'Deseja excluir o turno do médico adicional',
        [Locale.Ge]: 'Do you want to delete the additional doctor shift',
    },
    deleteOnlySelectedDay: {
        [Locale.Ru]: 'Удалить только выбранный день',
        [Locale.Am]: 'Ջնջել միայն ընտրված օրը',
        [Locale.En]: 'Delete only the selected day',
        [Locale.Pt]: 'Excluir apenas o dia selecionado',
        [Locale.Ge]: 'Delete only the selected day',
    },
    deleteSelectedAndFollowing: {
        [Locale.Ru]: 'Удалить выбранный и все последующие',
        [Locale.Am]: 'Ջնջել ընտրվածը և բոլոր հաջորդները',
        [Locale.En]: 'Delete selected and all following',
        [Locale.Pt]: 'Excluir selecionado e todos os seguintes',
        [Locale.Ge]: 'Delete selected and all following',
    },
    timeBlockRuleTitle: {
        [Locale.Ru]: 'Блок времени',
        [Locale.Am]: 'Ժամանակի բլոկ',
        [Locale.En]: 'Time block',
        [Locale.Pt]: 'Bloco de tempo',
        [Locale.Ge]: 'Time block',
    },
    timeBlockRuleApplyTitle: {
        [Locale.Ru]: 'Вы изменяете повторяющееся событие',
        [Locale.Am]: 'Դուք փոփոխում եք կրկնվող իրադարձությունը',
        [Locale.En]: 'You are changing a recurring event',
        [Locale.Pt]: 'Você está alterando um evento recorrente',
        [Locale.Ge]: 'თქვენ ცვლით განმეორებად მოვლენას',
    },
    timeBlockRuleApplyDescription: {
        [Locale.Ru]: 'Вы хотите изменить только событие от $date в $time или изменить его и все последующие?',
        [Locale.Am]: 'Ցանկանո՞ւմ եք փոփոխել միայն $date, $time իրադարձությունը, թե՞ այն և բոլոր հաջորդները',
        [Locale.En]: 'Do you want to change only the event on $date at $time, or this and all following events?',
        [Locale.Pt]: 'Deseja alterar apenas o evento de $date às $time ou ele e todos os seguintes?',
        [Locale.Ge]: 'გსურთ შეცვალოთ მხოლოდ $date $time-ის მოვლენა თუ ის და ყველა მომდევნო?',
    },
    timeBlockRuleApplyFollowingDescription: {
        [Locale.Ru]: 'Вы хотите изменить событие от $date в $time и все последующие?',
        [Locale.Am]: 'Ցանկանո՞ւմ եք փոփոխել $date, $time իրադարձությունը և բոլոր հաջորդները',
        [Locale.En]: 'Do you want to change the event on $date at $time and all following events?',
        [Locale.Pt]: 'Deseja alterar o evento de $date às $time e todos os seguintes?',
        [Locale.Ge]: 'გსურთ შეცვალოთ $date $time-ის მოვლენა და ყველა მომდევნო?',
    },
    timeBlockRuleApplySingleTitle: {
        [Locale.Ru]: 'Вы изменяете событие',
        [Locale.Am]: 'Դուք փոփոխում եք իրադարձությունը',
        [Locale.En]: 'You are changing an event',
        [Locale.Pt]: 'Você está alterando um evento',
        [Locale.Ge]: 'თქვენ ცვლით მოვლენას',
    },
    timeBlockRuleApplySingleDescription: {
        [Locale.Ru]: 'Подтвердите изменение события от $date в $time',
        [Locale.Am]: 'Հաստատեք $date, $time իրադարձության փոփոխումը',
        [Locale.En]: 'Confirm changes to the event on $date at $time',
        [Locale.Pt]: 'Confirme a alteração do evento de $date às $time',
        [Locale.Ge]: 'დაადასტურეთ $date $time-ის მოვლენის შეცვლა',
    },
    timeBlockRuleDeleteTitle: {
        [Locale.Ru]: 'Вы удаляете повторяющееся событие',
        [Locale.Am]: 'Դուք ջնջում եք կրկնվող իրադարձությունը',
        [Locale.En]: 'You are deleting a recurring event',
        [Locale.Pt]: 'Você está excluindo um evento recorrente',
        [Locale.Ge]: 'თქვენ შლით განმეორებად მოვლენას',
    },
    timeBlockRuleDeleteDescription: {
        [Locale.Ru]: 'Вы хотите удалить только выбранное событие от $date в $time или удалить его и все последующие?',
        [Locale.Am]: 'Ցանկանո՞ւմ եք ջնջել միայն ընտրված՝ $date, $time իրադարձությունը, թե՞ այն և բոլոր հաջորդները',
        [Locale.En]: 'Do you want to delete only the selected event on $date at $time, or this and all following events?',
        [Locale.Pt]: 'Deseja excluir apenas o evento selecionado de $date às $time ou ele e todos os seguintes?',
        [Locale.Ge]: 'გსურთ წაშალოთ მხოლოდ არჩეული $date $time-ის მოვლენა თუ ის და ყველა მომდევნო?',
    },
    timeBlockRuleDeleteSingleTitle: {
        [Locale.Ru]: 'Вы удаляете событие',
        [Locale.Am]: 'Դուք ջնջում եք իրադարձությունը',
        [Locale.En]: 'You are deleting an event',
        [Locale.Pt]: 'Você está excluindo um evento',
        [Locale.Ge]: 'თქვენ შლით მოვლენას',
    },
    timeBlockRuleDeleteSingleDescription: {
        [Locale.Ru]: 'Подтвердите удаление события от $date в $time',
        [Locale.Am]: 'Հաստատեք $date, $time իրադարձության ջնջումը',
        [Locale.En]: 'Confirm deletion of the event on $date at $time',
        [Locale.Pt]: 'Confirme a exclusão do evento de $date às $time',
        [Locale.Ge]: 'დაადასტურეთ $date $time-ის მოვლენის წაშლა',
    },
    timeBlockRuleApplyThisDay: {
        [Locale.Ru]: 'Только выбранное',
        [Locale.Am]: 'Միայն ընտրվածը',
        [Locale.En]: 'Only selected',
        [Locale.Pt]: 'Apenas o selecionado',
        [Locale.Ge]: 'მხოლოდ არჩეული',
    },
    timeBlockRuleDeleteThisDay: {
        [Locale.Ru]: 'Удалить выбранное',
        [Locale.Am]: 'Ջնջել ընտրվածը',
        [Locale.En]: 'Delete selected',
        [Locale.Pt]: 'Excluir selecionado',
        [Locale.Ge]: 'არჩეულის წაშლა',
    },
    timeBlockRuleApplyFollowing: {
        [Locale.Ru]: 'Выбранное и все последующие',
        [Locale.Am]: 'Ընտրվածը և բոլոր հաջորդները',
        [Locale.En]: 'Selected and all following',
        [Locale.Pt]: 'O selecionado e todos os seguintes',
        [Locale.Ge]: 'არჩეული და ყველა მომდევნო',
    },
    failedToSaveShift: {
        [Locale.Ru]: 'Не удалось сохранить смену',
        [Locale.Am]: 'Չհաջողվեց պահպանել հերթափոխը',
        [Locale.En]: 'Failed to save the shift',
        [Locale.Pt]: 'Falha ao salvar o turno',
        [Locale.Ge]: 'Failed to save the shift',
    },
    failedToDeleteShift: {
        [Locale.Ru]: 'Не удалось удалить смену',
        [Locale.Am]: 'Չհաջողվեց ջնջել հերթափոխը',
        [Locale.En]: 'Failed to delete the shift',
        [Locale.Pt]: 'Falha ao excluir o turno',
        [Locale.Ge]: 'Failed to delete the shift',
    },
    shiftOfficeOccupiedByOtherDoctor: {
        [Locale.Ru]: 'Один или несколько дней уже заняты другим доктором',
        [Locale.Am]: 'Մեկ կամ մի քանի օր արդեն զբաղեցված են այլ բժշկի կողմից',
        [Locale.En]: 'One or more days are already taken by another doctor',
        [Locale.Pt]: 'Um ou mais dias já estão ocupados por outro médico',
        [Locale.Ge]: 'One or more days are already taken by another doctor',
    },
    shiftUserAlreadyHasShifts: {
        [Locale.Ru]: 'На один или несколько дней уже есть смены у этого доктора',
        [Locale.Am]: 'Այս բժիշկն արդեն ունի հերթափոխեր մեկ կամ մի քանի օրերի համար',
        [Locale.En]: 'This doctor already has shifts on one or more days',
        [Locale.Pt]: 'Este médico já tem turnos em um ou mais dias',
        [Locale.Ge]: 'This doctor already has shifts on one or more days',
    },
    shiftCannotDisableMultipleOffices: {
        [Locale.Ru]: 'Нельзя отключить «Может быть в нескольких кабинетах одновременно»: есть параллельные активные смены в кабинетах: $offices',
        [Locale.Am]: 'Հնարավոր չէ անջատել «Կարող է լինել մի քանի կաբինետում միաժամանակ»՝ կան զուգահեռ ակտիվ հերթափոխեր կաբինետներում՝ $offices',
        [Locale.En]: 'Cannot disable "Can be in multiple offices at the same time": there are parallel active shifts in offices: $offices',
        [Locale.Pt]: 'Não é possível desativar "Pode estar em vários consultórios ao mesmo tempo": há turnos ativos paralelos nos consultórios: $offices',
        [Locale.Ge]: 'შეუძლებელია გამორთვა "Can be in multiple offices at the same time": კაბინეტებში არის პარალელური აქტიური ცვლები: $offices',
    },
    backToEditing: {
        [Locale.Ru]: 'Вернуться к редактированию',
        [Locale.Am]: 'Վերադառնալ խմբագրմանը',
        [Locale.En]: 'Back to editing',
        [Locale.Pt]: 'Voltar a editar',
        [Locale.Ge]: 'Back to editing',
    },
    shiftHasActiveReservations: {
        [Locale.Ru]: 'Нельзя изменить расписание: на затронутые дни есть активные записи пациентов',
        [Locale.Am]: 'Հնարավոր չէ փոփոխել ժամանակացույցը՝ ազդակիր օրերին կան հիվանդների ակտիվ գրանցումներ',
        [Locale.En]: 'Cannot change the schedule: there are active patient bookings on the affected days',
        [Locale.Pt]: 'Não é possível alterar a agenda: há reservas ativas de pacientes nos dias afetados',
        [Locale.Ge]: 'Cannot change the schedule: there are active patient bookings on the affected days',
    },
    shiftAssistantInOtherPractice: {
        [Locale.Ru]: 'В эту смену ассистент уже работает в кабинете другой практики',
        [Locale.Am]: 'Այս հերթափոխում ասիստենտն արդեն աշխատում է այլ պրակտիկայի կաբինետում',
        [Locale.En]: 'The assistant already works in an office of another practice during this shift',
        [Locale.Pt]: 'O assistente já trabalha em um consultório de outra prática neste turno',
        [Locale.Ge]: 'ამ ცვლაში ასისტენტი უკვე მუშაობს სხვა პრაქტიკის კაბინეტში',
    },
    shiftAssistantHasShiftsInOtherPractice: {
        [Locale.Ru]: 'У ассистента в это время уже есть смены в другой практике: $practice ($office)',
        [Locale.Am]: 'Ասիստենտն այս ժամին արդեն ունի հերթափոխեր այլ պրակտիկայում՝ $practice ($office)',
        [Locale.En]: 'The assistant already has shifts in another practice at this time: $practice ($office)',
        [Locale.Pt]: 'O assistente já tem turnos em outra prática neste horário: $practice ($office)',
        [Locale.Ge]: 'ასისტენტს ამ დროს უკვე აქვს ცვლები სხვა პრაქტიკაში: $practice ($office)',
    },
    shiftAssistantNotInPractice: {
        [Locale.Ru]: 'Ассистент не состоит в этой практике ($practice), поэтому не может одновременно работать в нескольких её кабинетах',
        [Locale.Am]: 'Ասիստենտն այս պրակտիկայի անդամ չէ ($practice), ուստի չի կարող միաժամանակ աշխատել դրա մի քանի կաբինետներում',
        [Locale.En]: 'The assistant is not a member of this practice ($practice), so they cannot work in several of its offices at the same time',
        [Locale.Pt]: 'O assistente não faz parte desta prática ($practice), por isso não pode trabalhar em vários dos seus consultórios ao mesmo tempo',
        [Locale.Ge]: 'ასისტენტი არ არის ამ პრაქტიკის წევრი ($practice), ამიტომ ვერ იმუშავებს მის რამდენიმე კაბინეტში ერთდროულად',
    },
    shiftNotCreatedInPracticeOffices: {
        [Locale.Ru]: 'Смена не создана ни в одном кабинете: в кабинетах практики есть пересечения',
        [Locale.Am]: 'Հերթափոխը չի ստեղծվել ոչ մի կաբինետում՝ պրակտիկայի կաբինետներում կան համընկնումներ',
        [Locale.En]: 'The shift was not created in any office: there are overlaps in the practice offices',
        [Locale.Pt]: 'O turno não foi criado em nenhum consultório: há sobreposições nos consultórios da prática',
        [Locale.Ge]: 'ცვლა არცერთ კაბინეტში არ შეიქმნა: პრაქტიკის კაბინეტებში არის გადაფარვები',
    },
    settings: {
        [Locale.Ru]: 'Настройки',
        [Locale.Am]: 'Կարգավորումներ',
        [Locale.En]: 'Settings',
        [Locale.Pt]: 'Configurações',
        [Locale.Ge]: 'პარამეტრები',
    },
    halfShift: {
        [Locale.Ru]: 'Половина смены',
        [Locale.Am]: 'Հերթափոխի կես',
        [Locale.En]: 'Half shift',
        [Locale.Pt]: 'Meio turno',
        [Locale.Ge]: 'ნახევარი ცვლა',
    },
    takesHalfShift: {
        [Locale.Ru]: 'Займет половину смены',
        [Locale.Am]: 'Կզբաղեցնի հերթափոխի կեսը',
        [Locale.En]: 'Takes half of the shift',
        [Locale.Pt]: 'Ocupará metade do turno',
        [Locale.Ge]: 'დაიკავებს ცვლის ნახევარს',
    },
    worksInAllPracticeOffices: {
        [Locale.Ru]: 'Будет работать во всех кабинетах практики',
        [Locale.Am]: 'Կաշխատի պրակտիկայի բոլոր կաբինետներում',
        [Locale.En]: 'Will work in all practice offices',
        [Locale.Pt]: 'Trabalhará em todos os consultórios da prática',
        [Locale.Ge]: 'იმუშავებს პრაქტიკის ყველა კაბინეტში',
    },
    openScheduleForDay: {
        [Locale.Ru]: 'Открыть расписание',
        [Locale.Am]: 'Բացել ժամանակացույցը',
        [Locale.En]: 'Open schedule',
        [Locale.Pt]: 'Abrir agenda',
        [Locale.Ge]: 'Open schedule',
    },
    virtualOffices: {
        [Locale.Ru]: 'Виртуальные кабинеты',
        [Locale.Am]: 'Վիրտուալ կաբինետներ',
        [Locale.En]: 'Virtual offices',
        [Locale.Pt]: 'Consultórios virtuais',
        [Locale.Ge]: 'Virtual offices',
    },
    openOnlineReception: {
        [Locale.Ru]: 'Открыть приём онлайн',
        [Locale.Am]: 'Բացել առցանց ընդունելություն',
        [Locale.En]: 'Open online reception',
        [Locale.Pt]: 'Abrir recepção online',
        [Locale.Ge]: 'Open online reception',
    },
    virtualOffice: {
        [Locale.Ru]: 'Виртуальный кабинет',
        [Locale.Am]: 'Վիրտուալ կաբինետ',
        [Locale.En]: 'Virtual office',
        [Locale.Pt]: 'Consultório virtual',
        [Locale.Ge]: 'Virtual office',
    },
    selectVirtualOfficeAttendees: {
        [Locale.Ru]: 'Выберите, для кого открыть кабинет',
        [Locale.Am]: 'Ընտրեք, թե ում համար բացել կաբինետը',
        [Locale.En]: 'Select who to open the office for',
        [Locale.Pt]: 'Selecione para quem abrir o consultório',
        [Locale.Ge]: 'Select who to open the office for',
    },
    openShifts: {
        [Locale.Ru]: 'Открыть смены',
        [Locale.Am]: 'Բացել հերթափոխեր',
        [Locale.En]: 'Open shifts',
        [Locale.Pt]: 'Abrir turnos',
        [Locale.Ge]: 'Open shifts',
    },
    closeOffice: {
        [Locale.Ru]: 'Закрыть кабинет',
        [Locale.Am]: 'Փակել կաբինետը',
        [Locale.En]: 'Close office',
        [Locale.Pt]: 'Fechar consultório',
        [Locale.Ge]: 'Close office',
    },
    listIsEmpty: {
        [Locale.Ru]: 'Список пуст',
        [Locale.Am]: 'Ցանկը դատարկ է',
        [Locale.En]: 'The list is empty',
        [Locale.Pt]: 'A lista está vazia',
        [Locale.Ge]: 'The list is empty',
    },
    officeClosing: {
        [Locale.Ru]: 'Закрытие кабинета',
        [Locale.Am]: 'Կաբինետի փակում',
        [Locale.En]: 'Office closing',
        [Locale.Pt]: 'Fecho do consultório',
        [Locale.Ge]: 'Office closing',
    },
    confirmVirtualOfficeClosing: {
        [Locale.Ru]: 'Подтвердите закрытие виртуального кабинета $officeName',
        [Locale.Am]: 'Հաստատեք $officeName վիրտուալ կաբինետի փակումը',
        [Locale.En]: 'Confirm closing of the virtual office $officeName',
        [Locale.Pt]: 'Confirme o fecho do consultório virtual $officeName',
        [Locale.Ge]: 'Confirm closing of the virtual office $officeName',
    },
    activeShiftsExist: {
        [Locale.Ru]: 'Есть активные смены',
        [Locale.Am]: 'Կան ակտիվ հերթափոխեր',
        [Locale.En]: 'There are active shifts',
        [Locale.Pt]: 'Existem turnos ativos',
        [Locale.Ge]: 'There are active shifts',
    },
    virtualOfficeActiveShiftsWarning: {
        [Locale.Ru]: 'Вы хотите закрыть виртуальный кабинет, но у доктора $doctorName есть активные смены. При закрытии кабинета они будут удалены',
        [Locale.Am]: 'Դուք ցանկանում եք փակել վիրտուալ կաբինետը, սակայն $doctorName բժիշկն ունի ակտիվ հերթափոխեր։ Կաբինետը փակելիս դրանք կջնջվեն',
        [Locale.En]: 'You are about to close the virtual office, but doctor $doctorName has active shifts. They will be deleted when the office is closed',
        [Locale.Pt]: 'Quer fechar o consultório virtual, mas o médico $doctorName tem turnos ativos. Serão eliminados quando o consultório for fechado',
        [Locale.Ge]: 'You are about to close the virtual office, but doctor $doctorName has active shifts. They will be deleted when the office is closed',
    },
    closeOfficeAndDeleteShifts: {
        [Locale.Ru]: 'Закрыть кабинет и удалить смены',
        [Locale.Am]: 'Փակել կաբինետը և ջնջել հերթափոխերը',
        [Locale.En]: 'Close office and delete shifts',
        [Locale.Pt]: 'Fechar consultório e eliminar turnos',
        [Locale.Ge]: 'Close office and delete shifts',
    },
    format: {
        [Locale.Ru]: 'Формат',
        [Locale.Am]: 'Ձևաչափ',
        [Locale.En]: 'Format',
        [Locale.Pt]: 'Formato',
        [Locale.Ge]: 'ფორმატი',
    },
    favorites: {
        [Locale.Ru]: 'Избранные',
        [Locale.Am]: 'Ընտրյալներ',
        [Locale.En]: 'Favorites',
        [Locale.Pt]: 'Favoritos',
        [Locale.Ge]: 'რჩეულები',
    },
    important: {
        [Locale.Ru]: 'Важное',
        [Locale.Am]: 'Կարևոր',
        [Locale.En]: 'Important',
        [Locale.Pt]: 'Importante',
        [Locale.Ge]: 'მნიშვნელოვანი',
    },
    duration: {
        [Locale.Ru]: 'Длительность',
        [Locale.Am]: 'Տևողություն',
        [Locale.En]: 'Duration',
        [Locale.Pt]: 'Duração',
        [Locale.Ge]: 'ხანგრძლივობა',
    },
    use: {
        [Locale.Ru]: 'Использовать',
        [Locale.Am]: 'Օգտագործել',
        [Locale.En]: 'Use',
        [Locale.Pt]: 'Usar',
        [Locale.Ge]: 'გამოიყენე',
    },
    found: {
        [Locale.Ru]: 'Найдено',
        [Locale.Am]: 'Գտնվել է',
        [Locale.En]: 'Found',
        [Locale.Pt]: 'Encontrado',
        [Locale.Ge]: 'იპოვეს',
    },
    foundFem: {
        [Locale.Ru]: 'Найдена',
        [Locale.Am]: 'Գտնվել է',
        [Locale.En]: 'Found',
        [Locale.Pt]: 'Encontrado',
        [Locale.Ge]: 'იპოვეს',
    },
    foundMasc: {
        [Locale.Ru]: 'Найден',
        [Locale.Am]: 'Գտնվել է',
        [Locale.En]: 'Found',
        [Locale.Pt]: 'Encontrado',
        [Locale.Ge]: 'იპოვეს',
    },
    shown: {
        [Locale.Ru]: 'Показано',
        [Locale.Am]: 'Ցուցադրված է',
        [Locale.En]: 'Shown',
        [Locale.Pt]: 'Mostrado',
        [Locale.Ge]: 'Shown',
    },
    show: {
        [Locale.Ru]: 'Показать',
        [Locale.Am]: 'Ցուցադրել',
        [Locale.En]: 'Show',
        [Locale.Pt]: 'Mostrar',
        [Locale.Ge]: 'Show',
    },
    fields: {
        [Locale.Ru]: 'Поля',
        [Locale.Am]: 'Դաշտեր',
        [Locale.En]: 'Fields',
        [Locale.Pt]: 'Campos',
        [Locale.Ge]: 'ველები',
    },
    groups: {
        [Locale.Ru]: 'Группы',
        [Locale.Am]: 'Խմբեր',
        [Locale.En]: 'Groups',
        [Locale.Pt]: 'Grupos',
        [Locale.Ge]: 'ჯგუფები',
    },
    subGroups: {
        [Locale.Ru]: 'Подгруппы',
        [Locale.Am]: 'Ենթախմբեր',
        [Locale.En]: 'Subgroups',
        [Locale.Pt]: 'Subgrupos',
        [Locale.Ge]: 'ქვეჯგუფები',
    },
    templates: {
        [Locale.Ru]: 'Шаблоны',
        [Locale.Am]: 'Ձևանմուշներ',
        [Locale.En]: 'Templates',
        [Locale.Pt]: 'Modelos',
        [Locale.Ge]: 'თარგები',
    },
    blocks: {
        [Locale.Ru]: 'Блоки',
        [Locale.Am]: 'Բլոկներ',
        [Locale.En]: 'Blocks',
        [Locale.Pt]: 'Blocos',
        [Locale.Ge]: 'Blocks',
    },
    during: {
        [Locale.Ru]: 'В течение',
        [Locale.Am]: 'Ընթացքում',
        [Locale.En]: 'During',
        [Locale.Pt]: 'Durante',
        [Locale.Ge]: 'მსვლელობისას',
    },
    inUsualWay: {
        [Locale.Ru]: 'В обычном порядке',
        [Locale.Am]: 'Սովորական կարգով',
        [Locale.En]: 'In the usual way',
        [Locale.Pt]: 'Da maneira habitual',
        [Locale.Ge]: 'ჩვეულებრივი გზით',
    },
    urgently: {
        [Locale.Ru]: 'Срочно',
        [Locale.Am]: 'Հրատապ',
        [Locale.En]: 'Urgently',
        [Locale.Pt]: 'Urgentemente',
        [Locale.Ge]: 'სასწრაფო',
    },
    asSoonAsPossible: {
        [Locale.Ru]: 'Как можно скорее',
        [Locale.Am]: 'Հնարավորինս շուտ',
        [Locale.En]: 'As soon as possible',
        [Locale.Pt]: 'O mais breve possível',
        [Locale.Ge]: 'რაც შეიძლება მალე',
    },
    immediately: {
        [Locale.Ru]: 'Немедленно',
        [Locale.Am]: 'Անհապաղ',
        [Locale.En]: 'Immediately',
        [Locale.Pt]: 'Imediatamente',
        [Locale.Ge]: 'მაშინვე',
    },
    load: {
        [Locale.Ru]: 'Загрузка',
        [Locale.Am]: 'Բեռնում',
        [Locale.En]: 'Loading',
        [Locale.Pt]: 'Carregando',
        [Locale.Ge]: 'იტვირთება',
    },
    termsOfCooperation: {
        [Locale.Ru]: 'Условия сотрудничества',
        [Locale.Am]: 'Համագործակցության պայմաններ',
        [Locale.En]: 'Terms of Cooperation',
        [Locale.Pt]: 'Termos de Cooperação',
        [Locale.Ge]: 'თანამშრომლობის პირობები',
    },
    address: {
        [Locale.Ru]: 'Адрес',
        [Locale.Am]: 'Հասցե',
        [Locale.En]: 'Address',
        [Locale.Pt]: 'Endereço',
        [Locale.Ge]: 'მისამართი',
    },
    mail: {
        [Locale.Ru]: 'Почта',
        [Locale.Am]: 'Էլ. փոստ',
        [Locale.En]: 'Mail',
        [Locale.Pt]: 'Correspondência',
        [Locale.Ge]: 'Mail',
    },
    phone: {
        [Locale.Ru]: 'Телефон',
        [Locale.Am]: 'Հեռախոս',
        [Locale.En]: 'Phone',
        [Locale.Pt]: 'Telefone',
        [Locale.Ge]: 'ტელეფონი',
    },
    country: {
        [Locale.Ru]: 'Страна',
        [Locale.Am]: 'Երկիր',
        [Locale.En]: 'Country',
        [Locale.Pt]: 'País',
        [Locale.Ge]: 'ქვეყა',
    },
    site: {
        [Locale.Ru]: 'Сайт',
        [Locale.Am]: 'Կայք',
        [Locale.En]: 'Site',
        [Locale.Pt]: 'Site',
        [Locale.Ge]: 'ვებგვერდი',
    },
    go: {
        [Locale.Ru]: 'Перейти',
        [Locale.Am]: 'Անցնել',
        [Locale.En]: 'Go',
        [Locale.Pt]: 'Ir',
        [Locale.Ge]: 'წადი',
    },
    costFrom: {
        [Locale.Ru]: 'Стоимость от',
        [Locale.Am]: 'Արժեքը՝ սկսած',
        [Locale.En]: 'Cost from',
        [Locale.Pt]: 'Custo de',
        [Locale.Ge]: 'ღირებულება',
    },
    cost: {
        [Locale.Ru]: 'Стоимость',
        [Locale.Am]: 'Արժեք',
        [Locale.En]: 'Cost',
        [Locale.Pt]: 'Custo',
        [Locale.Ge]: 'Cost',
    },
    before: {
        [Locale.Ru]: 'До',
        [Locale.Am]: 'Մինչև',
        [Locale.En]: 'before',
        [Locale.Pt]: 'antes',
        [Locale.Ge]: 'ადრე',
    },
    beforeSecond: {
        [Locale.Ru]: 'До',
        [Locale.Am]: 'Մինչև',
        [Locale.En]: 'Until',
        [Locale.Pt]: 'Até',
        [Locale.Ge]: 'მდე',
    },
    periodTo: {
        [Locale.Ru]: 'До',
        [Locale.Am]: 'Մինչև',
        [Locale.En]: 'To',
        [Locale.Pt]: 'Até',
        [Locale.Ge]: 'მდე',
    },
    paymentUrl: {
        [Locale.Ru]: 'Ссылка',
        [Locale.Am]: 'Հղում',
        [Locale.En]: 'Payment url',
        [Locale.Pt]: 'URL de pagamento',
        [Locale.Ge]: 'გადახდის ბმული',
    },
    paymentUrlText: {
        [Locale.Ru]: 'Ссылка для оплаты',
        [Locale.Am]: 'Վճարման հղում',
        [Locale.En]: 'Payment url',
        [Locale.Pt]: 'URL de pagamento',
        [Locale.Ge]: 'გადახდის ბმული',
    },
    [Currency.RUB]: {
        [Locale.Ru]: 'Рубль',
        [Locale.Am]: 'Ռուբլի',
        [Locale.En]: 'Ruble',
        [Locale.Pt]: 'Rublo',
        [Locale.Ge]: 'რუბლი',
    },
    rubTwo: {
        [Locale.Ru]: 'Рубля',
        [Locale.Am]: 'Ռուբլի',
        [Locale.En]: 'Rubles',
        [Locale.Pt]: 'Rublos',
        [Locale.Ge]: 'რუბლი',
    },
    rubs: {
        [Locale.Ru]: 'Рублей',
        [Locale.Am]: 'Ռուբլի',
        [Locale.En]: 'Rubles',
        [Locale.Pt]: 'Rublos',
        [Locale.Ge]: 'რუბლი',
    },
    [Currency.AED]: {
        [Locale.Ru]: 'Дирхам',
        [Locale.Am]: 'Դիրհամ',
        [Locale.En]: 'Dirham',
        [Locale.Pt]: 'Dirham',
        [Locale.Ge]: 'დირჰამი',
    },
    [Currency.USD]: {
        [Locale.Ru]: 'Доллар',
        [Locale.Am]: 'Դոլար',
        [Locale.En]: 'Dollar',
        [Locale.Pt]: 'Dólar',
        [Locale.Ge]: 'დოლარი',
    },
    [Currency.EUR]: {
        [Locale.Ru]: 'Евро',
        [Locale.Am]: 'Եվրո',
        [Locale.En]: 'Euro',
        [Locale.Pt]: 'Euro',
        [Locale.Ge]: 'ევრო',
    },
    [Currency.GEL]: {
        [Locale.Ru]: 'Лари',
        [Locale.Am]: 'Լարի',
        [Locale.En]: 'Lari',
        [Locale.Pt]: 'Correr',
        [Locale.Ge]: 'ლარი',
    },
    [Currency.AMD]: {
        [Locale.Ru]: 'Драм',
        [Locale.Am]: 'Դրամ',
        [Locale.En]: 'Dram',
        [Locale.Pt]: 'Dram',
        [Locale.Ge]: 'დრამი',
    },
    [Currency.GBP]: {
        [Locale.Ru]: 'Фунт стерлингов',
        [Locale.Am]: 'Ֆունտ ստերլինգ',
        [Locale.En]: 'Pound sterling',
        [Locale.Pt]: 'Libra esterlina',
        [Locale.Ge]: 'ფუნტი სტერლინგი',
    },
    [`in_${Currency.RUB}`]: {
        [Locale.Ru]: 'В рублях',
        [Locale.Am]: 'Ռուբլով',
        [Locale.En]: 'In rubles',
        [Locale.Pt]: 'Em rublos',
        [Locale.Ge]: 'რუბებში',
    },
    [`in_${Currency.AED}`]: {
        [Locale.Ru]: 'В дихармах',
        [Locale.Am]: 'Դիրհամով',
        [Locale.En]: 'In dirhams',
        [Locale.Pt]: 'Em dirrãs',
        [Locale.Ge]: 'დიჰარმებში',
    },
    [`in_${Currency.USD}`]: {
        [Locale.Ru]: 'В долларах',
        [Locale.Am]: 'Դոլարով',
        [Locale.En]: 'In dollars',
        [Locale.Pt]: 'Em dólares',
        [Locale.Ge]: 'დოლარებში',
    },
    [`in_${Currency.EUR}`]: {
        [Locale.Ru]: 'В евро',
        [Locale.Am]: 'Եվրոյով',
        [Locale.En]: 'In euros',
        [Locale.Pt]: 'Em euros',
        [Locale.Ge]: 'ევროში',
    },
    [`in_${Currency.GEL}`]: {
        [Locale.Ru]: 'В лари',
        [Locale.Am]: 'Լարիով',
        [Locale.En]: 'In lari',
        [Locale.Pt]: 'Em lari',
        [Locale.Ge]: 'ლარში',
    },
    [`in_${Currency.AMD}`]: {
        [Locale.Ru]: 'В драмах',
        [Locale.Am]: 'Դրամով',
        [Locale.En]: 'In dram',
        [Locale.Pt]: 'Em trago',
        [Locale.Ge]: 'დრამებში',
    },
    [`in_${Currency.GBP}`]: {
        [Locale.Ru]: 'В фунтах стерлингов',
        [Locale.Am]: 'Ֆունտ ստերլինգով',
        [Locale.En]: 'In pounds sterling',
        [Locale.Pt]: 'Em libras esterlinas',
        [Locale.Ge]: 'ფუნტ სტერლინგებში',
    },
    type: {
        [Locale.Ru]: 'Тип',
        [Locale.Am]: 'Տեսակ',
        [Locale.En]: 'Type',
        [Locale.Pt]: 'Tipo',
        [Locale.Ge]: 'ტიპი',
    },
    printReceipt: {
        [Locale.Ru]: 'Распечатать чек',
        [Locale.Am]: 'Տպել կտրոնը',
        [Locale.En]: 'Print the receipt',
        [Locale.Pt]: 'Imprima o recibo',
        [Locale.Ge]: 'დაბეჭდეთ ქვითარი',
    },
    issueReceipt: {
        [Locale.Ru]: 'Пробить чек',
        [Locale.Am]: 'Կտրոն դուրս գրել',
        [Locale.En]: 'Issue a receipt',
        [Locale.Pt]: 'Emitir um recibo',
        [Locale.Ge]: 'ქვითრის გატარება',
    },
    receiptSentToCashRegister: {
        [Locale.Ru]: 'Чек отправлен в кассу',
        [Locale.Am]: 'Կտրոնն ուղարկվել է դրամարկղ',
        [Locale.En]: 'The receipt has been sent to the cash register',
        [Locale.Pt]: 'O recibo foi enviado para a caixa registradora',
        [Locale.Ge]: 'ქვითარი გაიგზავნა სალაროში',
    },
    linkToReceipt: {
        [Locale.Ru]: 'Ссылка на чек',
        [Locale.Am]: 'Կտրոնի հղում',
        [Locale.En]: 'Link to receipt',
        [Locale.Pt]: 'Link para recibo',
        [Locale.Ge]: 'ქვითარის ბმული',
    },
    resume: {
        [Locale.Ru]: 'Возобновить',
        [Locale.Am]: 'Վերսկսել',
        [Locale.En]: 'Resume',
        [Locale.Pt]: 'Retomar',
        [Locale.Ge]: 'რეზიუმე',
    },
    continueRecord: {
        [Locale.Ru]: 'Продолжить запись',
        [Locale.Am]: 'Շարունակել գրառումը',
        [Locale.En]: 'Continue recording',
        [Locale.Pt]: 'Continuar gravando',
        [Locale.Ge]: 'განახლება',
    },
    reopen: {
        [Locale.Ru]: 'Открыть заново',
        [Locale.Am]: 'Կրկին բացել',
        [Locale.En]: 'Reopen',
        [Locale.Pt]: 'Reabrir',
        [Locale.Ge]: 'ხელახლა გახსნა',
    },
    suspend: {
        [Locale.Ru]: 'Приостановить',
        [Locale.Am]: 'Կասեցնել',
        [Locale.En]: 'Suspend',
        [Locale.Pt]: 'Suspender',
        [Locale.Ge]: 'შეაჩერე',
    },
    and: {
        [Locale.Ru]: 'и',
        [Locale.Am]: 'և',
        [Locale.En]: 'and',
        [Locale.Pt]: 'e',
        [Locale.Ge]: 'და',
    },
    complete: {
        [Locale.Ru]: 'Завершить',
        [Locale.Am]: 'Ավարտել',
        [Locale.En]: 'Complete',
        [Locale.Pt]: 'Completo',
        [Locale.Ge]: 'სრული',
    },
    yes: {
        [Locale.Ru]: 'Да',
        [Locale.Am]: 'Այո',
        [Locale.En]: 'Yes',
        [Locale.Pt]: 'Sim',
        [Locale.Ge]: 'Yes',
    },
    have: {
        [Locale.Ru]: 'Есть',
        [Locale.Am]: 'Կա',
        [Locale.En]: 'Have',
        [Locale.Pt]: 'Ter',
        [Locale.Ge]: 'Have',
    },
    no: {
        [Locale.Ru]: 'Нет',
        [Locale.Am]: 'Ոչ',
        [Locale.En]: 'No',
        [Locale.Pt]: 'Não',
        [Locale.Ge]: 'No',
    },
    free: {
        [Locale.Ru]: 'Бесплатно',
        [Locale.Am]: 'Անվճար',
        [Locale.En]: 'Free',
        [Locale.Pt]: 'Grátis',
        [Locale.Ge]: 'უფასო',
    },
    returnToInProcess: {
        [Locale.Ru]: 'Вернуть в невыполенные',
        [Locale.Am]: 'Վերադարձնել չկատարվածների մեջ',
        [Locale.En]: 'Return to unfulfilled',
        [Locale.Pt]: 'Voltar para não cumprido',
        [Locale.Ge]: 'Return to unfulfilled',
    },
    complicated: {
        [Locale.Ru]: 'Выполнено',
        [Locale.Am]: 'Կատարված է',
        [Locale.En]: 'Done',
        [Locale.Pt]: 'Feito',
        [Locale.Ge]: 'Done',
    },
    birthDate: {
        [Locale.Ru]: 'Дата рождения',
        [Locale.Am]: 'Ծննդյան ամսաթիվ',
        [Locale.En]: 'Date of birth',
        [Locale.Pt]: 'Data de nascimento',
        [Locale.Ge]: 'Date of birth',
    },
    showDetails: {
        [Locale.Ru]: 'Посмотреть подробности',
        [Locale.Am]: 'Դիտել մանրամասները',
        [Locale.En]: 'View details',
        [Locale.Pt]: 'Ver detalhes',
        [Locale.Ge]: 'View details',
    },
    view: {
        [Locale.Ru]: 'Посмотреть',
        [Locale.Am]: 'Դիտել',
        [Locale.En]: 'View',
        [Locale.Pt]: 'Visualizar',
        [Locale.Ge]: 'View',
    },
    viewSecond: {
        [Locale.Ru]: 'Вид',
        [Locale.Am]: 'Տեսք',
        [Locale.En]: 'View',
        [Locale.Pt]: 'Visualizar',
        [Locale.Ge]: 'View',
    },
    newGroup: {
        [Locale.Ru]: 'Новая группа',
        [Locale.Am]: 'Նոր խումբ',
        [Locale.En]: 'New Group',
        [Locale.Pt]: 'Novo grupo',
        [Locale.Ge]: 'ახალი ჯგუფი',
    },
    yoursFavorite: {
        [Locale.Ru]: 'Ваше избранное',
        [Locale.Am]: 'Ձեր ընտրյալները',
        [Locale.En]: 'Your favorites',
        [Locale.Pt]: 'Seus favoritos',
        [Locale.Ge]: 'Your favorites',
    },
    notChosen: {
        [Locale.Ru]: 'Не выбрано',
        [Locale.Am]: 'Ընտրված չէ',
        [Locale.En]: 'Not chosen',
        [Locale.Pt]: 'Não escolhido',
        [Locale.Ge]: 'Not chosen',
    },
    apply: {
        [Locale.Ru]: 'Применить',
        [Locale.Am]: 'Կիրառել',
        [Locale.En]: 'Apply',
        [Locale.Pt]: 'Aplicar',
        [Locale.Ge]: 'Apply',
    },
    applyToAll: {
        [Locale.Ru]: 'Применить ко всем',
        [Locale.Am]: 'Կիրառել բոլորի նկատմամբ',
        [Locale.En]: 'Apply to all',
        [Locale.Pt]: 'Aplicar a todos',
        [Locale.Ge]: 'Apply to all',
    },
    selectAll: {
        [Locale.Ru]: 'Выбрать все',
        [Locale.Am]: 'Ընտրել բոլորը',
        [Locale.En]: 'Select all',
        [Locale.Pt]: 'Selecionar tudo',
        [Locale.Ge]: 'Select all',
    },
    select: {
        [Locale.Ru]: 'Выбрать',
        [Locale.Am]: 'Ընտրել',
        [Locale.En]: 'Select',
        [Locale.Pt]: 'Selecionar',
        [Locale.Ge]: 'Select',
    },
    makeSelect: {
        [Locale.Ru]: 'Выберите',
        [Locale.Am]: 'Ընտրեք',
        [Locale.En]: 'Select',
        [Locale.Pt]: 'Selecionar',
        [Locale.Ge]: 'Select',
    },
    clearSelection: {
        [Locale.Ru]: 'Снять выбор',
        [Locale.Am]: 'Հանել ընտրությունը',
        [Locale.En]: 'Clear selection',
        [Locale.Pt]: 'Limpar seleção',
        [Locale.Ge]: 'Clear selection',
    },
    clearState: {
        [Locale.Ru]: 'Очистить состояние',
        [Locale.Am]: 'Մաքրել վիճակը',
        [Locale.En]: 'Clear state',
        [Locale.Pt]: 'Estado claro',
        [Locale.Ge]: 'Clear state',
    },
    beginningOfPeriod: {
        [Locale.Ru]: 'Начало периода',
        [Locale.Am]: 'Ժամանակահատվածի սկիզբ',
        [Locale.En]: 'Beginning of period',
        [Locale.Pt]: 'Início do período',
        [Locale.Ge]: 'Beginning of period',
    },
    endOfPeriod: {
        [Locale.Ru]: 'Конец периода',
        [Locale.Am]: 'Ժամանակահատվածի ավարտ',
        [Locale.En]: 'End of period',
        [Locale.Pt]: 'Fim do período',
        [Locale.Ge]: 'End of period',
    },
    period: {
        [Locale.Ru]: 'Период',
        [Locale.Am]: 'Ժամանակահատված',
        [Locale.En]: 'Period',
        [Locale.Pt]: 'Período',
        [Locale.Ge]: 'პერიოდი',
    },
    expand: {
        [Locale.Ru]: 'Раскрыть',
        [Locale.Am]: 'Բացել',
        [Locale.En]: 'Expand',
        [Locale.Pt]: 'Expandir',
        [Locale.Ge]: 'Expand',
    },
    filters: {
        [Locale.Ru]: 'Фильтры',
        [Locale.Am]: 'Զտիչներ',
        [Locale.En]: 'Filters',
        [Locale.Pt]: 'Filtros',
        [Locale.Ge]: 'Filters',
    },
    left: {
        [Locale.Ru]: 'Осталось',
        [Locale.Am]: 'Մնացել է',
        [Locale.En]: 'Left',
        [Locale.Pt]: 'Esquerda',
        [Locale.Ge]: 'Left',
    },
    error: {
        [Locale.Ru]: 'Ошибка',
        [Locale.Am]: 'Սխալ',
        [Locale.En]: 'Error',
        [Locale.Pt]: 'Erro',
        [Locale.Ge]: 'Error',
    },
    language: {
        [Locale.Ru]: 'Язык',
        [Locale.Am]: 'Լեզու',
        [Locale.En]: 'Language',
        [Locale.Pt]: 'Idioma',
        [Locale.Ge]: 'Language',
    },
    currency: {
        [Locale.Ru]: 'Валюта',
        [Locale.Am]: 'Արժույթ',
        [Locale.En]: 'Currency',
        [Locale.Pt]: 'Moeda',
        [Locale.Ge]: 'Currency',
    },
    month: {
        [Locale.Ru]: 'Месяц',
        [Locale.Am]: 'Ամիս',
        [Locale.En]: 'Month',
        [Locale.Pt]: 'Mês',
        [Locale.Ge]: 'Month',
    },
    monthTwo: {
        [Locale.Ru]: 'Месяца',
        [Locale.Am]: 'Ամիս',
        [Locale.En]: 'Months',
        [Locale.Pt]: 'Meses',
        [Locale.Ge]: 'Months',
    },
    months: {
        [Locale.Ru]: 'Месяцев',
        [Locale.Am]: 'Ամիս',
        [Locale.En]: 'Months',
        [Locale.Pt]: 'Meses',
        [Locale.Ge]: 'Months',
    },
    hour: {
        [Locale.Ru]: `час`,
        [Locale.Am]: `ժամ`,
        [Locale.En]: `hour`,
        [Locale.Pt]: 'Hora',
        [Locale.Ge]: `hour`,
    },
    hourTwo: {
        [Locale.Ru]: `часа`,
        [Locale.Am]: `ժամ`,
        [Locale.En]: `hours`,
        [Locale.Pt]: 'Horas',
        [Locale.Ge]: `hours`,
    },
    hours: {
        [Locale.Ru]: `часов`,
        [Locale.Am]: `ժամ`,
        [Locale.En]: `hours`,
        [Locale.Pt]: 'Horas',
        [Locale.Ge]: `hours`,
    },
    minute: {
        [Locale.Ru]: `минута`,
        [Locale.Am]: `րոպե`,
        [Locale.En]: `minute`,
        [Locale.Pt]: 'minuto',
        [Locale.Ge]: `minute`,
    },
    minuteTwo: {
        [Locale.Ru]: `минуты`,
        [Locale.Am]: `րոպե`,
        [Locale.En]: `minutes`,
        [Locale.Pt]: 'Minutos',
        [Locale.Ge]: `minutes`,
    },
    minutes: {
        [Locale.Ru]: `минут`,
        [Locale.Am]: `րոպե`,
        [Locale.En]: `minutes`,
        [Locale.Pt]: 'Minutos',
        [Locale.Ge]: `minutes`,
    },
    pay: {
        [Locale.Ru]: 'Оплатить',
        [Locale.Am]: 'Վճարել',
        [Locale.En]: 'Pay',
        [Locale.Pt]: 'Pagar',
        [Locale.Ge]: 'Pay',
    },
    payMale: {
        [Locale.Ru]: 'Оплачивает',
        [Locale.Am]: 'Վճարում է',
        [Locale.En]: 'Pay',
        [Locale.Pt]: 'Pagar',
        [Locale.Ge]: 'Pay',
    },
    payed: {
        [Locale.Ru]: 'Оплачено',
        [Locale.Am]: 'Վճարված է',
        [Locale.En]: 'Payed',
        [Locale.Pt]: 'Pago',
        [Locale.Ge]: 'Payed',
    },
    notPayed: {
        [Locale.Ru]: 'Не оплачено',
        [Locale.Am]: 'Չվճարված',
        [Locale.En]: 'Not payed',
        [Locale.Pt]: 'Não pago',
        [Locale.Ge]: 'Not payed',
    },
    age: {
        [Locale.Ru]: 'Возраст',
        [Locale.Am]: 'Տարիք',
        [Locale.En]: 'Age',
        [Locale.Pt]: 'Idade',
        [Locale.Ge]: 'Age',
    },
    ageFrom: {
        [Locale.Ru]: 'Возраст с',
        [Locale.Am]: 'Տարիքը՝ սկսած',
        [Locale.En]: 'Age from',
        [Locale.Pt]: 'Idade de',
        [Locale.Ge]: 'Age from',
    },
    ageTo: {
        [Locale.Ru]: 'Возраст по',
        [Locale.Am]: 'Տարիքը՝ մինչև',
        [Locale.En]: 'Age to',
        [Locale.Pt]: 'Idade até',
        [Locale.Ge]: 'Age to',
    },
    valueMin: {
        [Locale.Ru]: 'Значение минимальное',
        [Locale.Am]: 'Նվազագույն արժեք',
        [Locale.En]: 'Minimal value',
        [Locale.Pt]: 'Valor mínimo',
        [Locale.Ge]: 'Minimal value',
    },
    valueMax: {
        [Locale.Ru]: 'Значение максимальное',
        [Locale.Am]: 'Առավելագույն արժեք',
        [Locale.En]: 'Maximal value',
        [Locale.Pt]: 'Valor máximo',
        [Locale.Ge]: 'Maximal value',
    },
    index: {
        [Locale.Ru]: 'Индекс',
        [Locale.Am]: 'Ինդեքս',
        [Locale.En]: 'Index',
        [Locale.Pt]: 'Índice',
        [Locale.Ge]: 'Index',
    },
    tableValueIndex: {
        [Locale.Ru]: 'Значение табличного индекса',
        [Locale.Am]: 'Աղյուսակային ինդեքսի արժեք',
        [Locale.En]: 'Table value index',
        [Locale.Pt]: 'Índice de valor da tabela',
        [Locale.Ge]: 'Table value index',
    },
    attention: {
        [Locale.Ru]: 'Внимание',
        [Locale.Am]: 'Ուշադրություն',
        [Locale.En]: 'Attention',
        [Locale.Pt]: 'Atenção',
        [Locale.Ge]: 'Attention',
    },
    yesRemove: {
        [Locale.Ru]: 'Да, удалить',
        [Locale.Am]: 'Այո, ջնջել',
        [Locale.En]: 'Yes, delete',
        [Locale.Pt]: 'Sim, excluir',
        [Locale.Ge]: 'Yes, delete',
    },
    office: {
        [Locale.Ru]: 'Кабинет',
        [Locale.Am]: 'Կաբինետ',
        [Locale.En]: 'Office',
        [Locale.Pt]: 'Escritório',
        [Locale.Ge]: 'Office',
    },
    onlineOffice: {
        [Locale.Ru]: 'Онлайн кабинет',
        [Locale.Am]: 'Առցանց կաբինետ',
        [Locale.En]: 'Online office',
        [Locale.Pt]: 'Consultório on-line',
        [Locale.Ge]: 'Online office',
    },
    officeShort: {
        [Locale.Ru]: 'каб.',
        [Locale.Am]: 'կաբ.',
        [Locale.En]: 'off.',
        [Locale.Pt]: 'cons.',
        [Locale.Ge]: 'off.',
    },
    virtualOfficeShort: {
        [Locale.Ru]: 'Вирт. каб.',
        [Locale.Am]: 'Վիրտ. կաբ.',
        [Locale.En]: 'Virt. off.',
        [Locale.Pt]: 'Cons. virt.',
        [Locale.Ge]: 'Virt. off.',
    },
    busy: {
        [Locale.Ru]: 'Занято',
        [Locale.Am]: 'Զբաղված է',
        [Locale.En]: 'Busy',
        [Locale.Pt]: 'Ocupado',
        [Locale.Ge]: 'Busy',
    },
    busyByDoctor: {
        [Locale.Ru]: 'Занято доктором',
        [Locale.Am]: 'Զբաղված է բժշկի կողմից',
        [Locale.En]: 'Busy by doctor',
        [Locale.Pt]: 'Ocupado pelo médico',
        [Locale.Ge]: 'Busy by doctor',
    },
    conflicts: {
        [Locale.Ru]: 'Конфликты',
        [Locale.Am]: 'Կոնֆլիկտներ',
        [Locale.En]: 'Conflicts',
        [Locale.Pt]: 'Conflitos',
        [Locale.Ge]: 'Conflicts',
    },
    any: {
        [Locale.Ru]: 'Любой',
        [Locale.Am]: 'Ցանկացած',
        [Locale.En]: 'Any',
        [Locale.Pt]: 'Qualquer',
        [Locale.Ge]: 'Any',
    },
    anyFeminine: {
        [Locale.Ru]: 'Любая',
        [Locale.Am]: 'Ցանկացած',
        [Locale.En]: 'Any',
        [Locale.Pt]: 'Qualquer',
        [Locale.Ge]: 'Any',
    },
    notValid: {
        [Locale.Ru]: 'Не валидно',
        [Locale.Am]: 'Վավեր չէ',
        [Locale.En]: 'Not valid',
        [Locale.Pt]: 'Não é válido',
        [Locale.Ge]: 'Not valid',
    },
    createNew: {
        [Locale.Ru]: 'Создать новое',
        [Locale.Am]: 'Ստեղծել նորը',
        [Locale.En]: 'Create a new one',
        [Locale.Pt]: 'Crie um novo',
        [Locale.Ge]: 'შექმენით ახალი',
    },
    exit: {
        [Locale.Ru]: 'Выход',
        [Locale.Am]: 'Ելք',
        [Locale.En]: 'Exit',
        [Locale.Pt]: 'Sair',
        [Locale.Ge]: 'Exit',
    },
    requested: {
        [Locale.Ru]: 'Запрошено',
        [Locale.Am]: 'Հարցված է',
        [Locale.En]: 'Requested',
        [Locale.Pt]: 'Solicitado',
        [Locale.Ge]: 'Requested',
    },
    received: {
        [Locale.Ru]: 'Получено',
        [Locale.Am]: 'Ստացված է',
        [Locale.En]: 'Received',
        [Locale.Pt]: 'Recebido',
        [Locale.Ge]: 'Received',
    },
    accepted: {
        [Locale.Ru]: 'Принято',
        [Locale.Am]: 'Ընդունված է',
        [Locale.En]: 'Accepted',
        [Locale.Pt]: 'Aceito',
        [Locale.Ge]: 'Accepted',
    },
    onHold: {
        [Locale.Ru]: 'На паузе',
        [Locale.Am]: 'Դադարեցված է',
        [Locale.En]: 'On hold',
        [Locale.Pt]: 'Em espera',
        [Locale.Ge]: 'On hold',
    },
    rejected: {
        [Locale.Ru]: 'Отклонено',
        [Locale.Am]: 'Մերժված է',
        [Locale.En]: 'Rejected',
        [Locale.Pt]: 'Rejeitado',
        [Locale.Ge]: 'Rejected',
    },
    failed: {
        [Locale.Ru]: 'Провалено',
        [Locale.Am]: 'Ձախողված է',
        [Locale.En]: 'Failed',
        [Locale.Pt]: 'Falhou',
        [Locale.Ge]: 'Failed',
    },
    unsuccessful: {
        [Locale.Ru]: 'Неудачно',
        [Locale.Am]: 'Անհաջող',
        [Locale.En]: 'Unsuccessful',
        [Locale.Pt]: 'Sem sucesso',
        [Locale.Ge]: 'Unsuccessful',
    },
    enteredInError: {
        [Locale.Ru]: 'Заведено по ошибке',
        [Locale.Am]: 'Ստեղծվել է սխալմամբ',
        [Locale.En]: 'Entered in error',
        [Locale.Pt]: 'Inserido por engano',
        [Locale.Ge]: 'Entered in error',
    },
    completed: {
        [Locale.Ru]: 'Завершено',
        [Locale.Am]: 'Ավարտված է',
        [Locale.En]: 'Completed',
        [Locale.Pt]: 'Concluído',
        [Locale.Ge]: 'Completed',
    },
    completedMulti: {
        [Locale.Ru]: 'Завершенные',
        [Locale.Am]: 'Ավարտվածներ',
        [Locale.En]: 'Completed',
        [Locale.Pt]: 'Concluído',
        [Locale.Ge]: 'დასრულებული',
    },
    completedMasculine: {
        [Locale.Ru]: 'Завершен',
        [Locale.Am]: 'Ավարտված է',
        [Locale.En]: 'Completed',
        [Locale.Pt]: 'Concluído',
        [Locale.Ge]: 'Completed',
    },
    completedFem: {
        [Locale.Ru]: 'Завершена',
        [Locale.Am]: 'Ավարտված է',
        [Locale.En]: 'Completed',
        [Locale.Pt]: 'Concluído',
        [Locale.Ge]: 'Completed',
    },
    started: {
        [Locale.Ru]: 'Начато',
        [Locale.Am]: 'Սկսված է',
        [Locale.En]: 'Started',
        [Locale.Pt]: 'Iniciado',
        [Locale.Ge]: 'Started',
    },
    overdue: {
        [Locale.Ru]: 'Просрочено',
        [Locale.Am]: 'Ժամկետանց է',
        [Locale.En]: 'Overdue',
        [Locale.Pt]: 'Atrasado',
        [Locale.Ge]: 'Overdue',
    },
    active: {
        [Locale.Ru]: 'Активно',
        [Locale.Am]: 'Ակտիվ է',
        [Locale.En]: 'Active',
        [Locale.Pt]: 'Ativo',
        [Locale.Ge]: 'Active',
    },
    Активно: {
        [Locale.Ru]: 'Активно',
        [Locale.Am]: 'Ակտիվ է',
        [Locale.En]: 'Active',
        [Locale.Pt]: 'Ativo',
        [Locale.Ge]: 'Active',
    },
    Просрочено: {
        [Locale.Ru]: 'Просрочено',
        [Locale.Am]: 'Ժամկետանց է',
        [Locale.En]: 'Overdue',
        [Locale.Pt]: 'Atrasado',
        [Locale.Ge]: 'Overdue',
    },
    Отменено: {
        [Locale.Ru]: 'Отменено',
        [Locale.Am]: 'Չեղարկված է',
        [Locale.En]: 'Canceled',
        [Locale.Pt]: 'Cancelado',
        [Locale.Ge]: 'წაშლა',
    },
    Исполнено: {
        [Locale.Ru]: 'Исполнено',
        [Locale.Am]: 'Կատարված է',
        [Locale.En]: 'Performed',
        [Locale.Pt]: 'Realizado',
        [Locale.Ge]: 'შესრულებულია',
    },
    deleted: {
        [Locale.Ru]: 'Удален',
        [Locale.Am]: 'Ջնջված է',
        [Locale.En]: 'Deleted',
        [Locale.Pt]: 'Excluído',
        [Locale.Ge]: 'წაშლილი',
    },
    serviceGenitive: {
        [Locale.Ru]: 'Услугу',
        [Locale.Am]: 'Ծառայությունը',
        [Locale.En]: 'Service',
        [Locale.Pt]: 'Serviço',
        [Locale.Ge]: 'Service',
    },
    contractorGenitive: {
        [Locale.Ru]: 'Подрядчика',
        [Locale.Am]: 'Կապալառուին',
        [Locale.En]: 'Contractor',
        [Locale.Pt]: 'Contratante',
        [Locale.Ge]: 'Contractor',
    },
    contractorPrice: {
        [Locale.Ru]: 'Цена подрядчика',
        [Locale.Am]: 'Կապալառուի գինը',
        [Locale.En]: 'Contractor price',
        [Locale.Pt]: 'Preço do contratante',
        [Locale.Ge]: 'Contractor price',
    },
    customReferralRule: {
        [Locale.Ru]: 'Без оплаты материалов',
        [Locale.Am]: 'Առանց նյութերի վճարման',
        [Locale.En]: 'Materials not paid',
        [Locale.Pt]: 'Sem pagamento de materiais',
        [Locale.Ge]: 'მასალების ანაზღაურების გარეშე',
    },
    activationDate: {
        [Locale.Ru]: 'Дата активации',
        [Locale.Am]: 'Ակտիվացման ամսաթիվ',
        [Locale.En]: 'Activation date',
        [Locale.Pt]: 'Data de ativação',
        [Locale.Ge]: 'Activation date',
    },
    mustSpecify: {
        [Locale.Ru]: 'Необходимо указать',
        [Locale.Am]: 'Անհրաժեշտ է նշել',
        [Locale.En]: 'You must specify',
        [Locale.Pt]: 'Você deve especificar',
        [Locale.Ge]: 'You must specify',
    },
    activeMasculine: {
        [Locale.Ru]: 'Активный',
        [Locale.Am]: 'Ակտիվ',
        [Locale.En]: 'Active',
        [Locale.Pt]: 'Ativo',
        [Locale.Ge]: 'Active',
    },
    activeMasculineMany: {
        [Locale.Ru]: 'Активный',
        [Locale.Am]: 'Ակտիվ',
        [Locale.En]: 'Active',
        [Locale.Pt]: 'Ativo',
        [Locale.Ge]: 'Active',
    },
    activeFeminine: {
        [Locale.Ru]: 'Активна',
        [Locale.Am]: 'Ակտիվ',
        [Locale.En]: 'Active',
        [Locale.Pt]: 'Ativo',
        [Locale.Ge]: 'Active',
    },
    activeFemSecond: {
        [Locale.Ru]: 'Активная',
        [Locale.Am]: 'Ակտիվ',
        [Locale.En]: 'Active',
        [Locale.Pt]: 'Ativo',
        [Locale.Ge]: 'Active',
    },
    planneFemSecond: {
        [Locale.Ru]: 'Планируемая',
        [Locale.Am]: 'Պլանավորվող',
        [Locale.En]: 'Planned',
        [Locale.Pt]: 'Planejado',
        [Locale.Ge]: 'Planned',
    },
    activeNeuter: {
        [Locale.Ru]: 'Активное',
        [Locale.Am]: 'Ակտիվ',
        [Locale.En]: 'Active',
        [Locale.Pt]: 'Ativo',
        [Locale.Ge]: 'Active',
    },
    activeMany: {
        [Locale.Ru]: 'Активные',
        [Locale.Am]: 'Ակտիվներ',
        [Locale.En]: 'Active',
        [Locale.Pt]: 'Ativo',
        [Locale.Ge]: 'Active',
    },
    trialPeriod: {
        [Locale.Ru]: 'Пробный период',
        [Locale.Am]: 'Փորձնական ժամանակահատված',
        [Locale.En]: 'Trial',
        [Locale.Pt]: 'Julgamento',
        [Locale.Ge]: 'Trial',
    },
    waitingForPayment: {
        [Locale.Ru]: 'Ожидает оплаты',
        [Locale.Am]: 'Սպասում է վճարման',
        [Locale.En]: 'Waiting for payment',
        [Locale.Pt]: 'Aguardando pagamento',
        [Locale.Ge]: 'Waiting for payment',
    },
    overdueMany: {
        [Locale.Ru]: 'Просроченные',
        [Locale.Am]: 'Ժամկետանցներ',
        [Locale.En]: 'Overdue',
        [Locale.Pt]: 'Atrasado',
        [Locale.Ge]: 'Overdue',
    },
    notCreatedMany: {
        [Locale.Ru]: 'Не созданы',
        [Locale.Am]: 'Ստեղծված չեն',
        [Locale.En]: 'Not created',
        [Locale.Pt]: 'Não criado',
        [Locale.Ge]: 'Not created',
    },
    plannedFemenine: {
        [Locale.Ru]: 'Запланирована',
        [Locale.Am]: 'Պլանավորված է',
        [Locale.En]: 'Planned',
        [Locale.Pt]: 'Planejado',
        [Locale.Ge]: 'Planned',
    },
    archive: {
        [Locale.Ru]: 'Архив',
        [Locale.Am]: 'Արխիվ',
        [Locale.En]: 'Archive',
        [Locale.Pt]: 'Arquivo',
        [Locale.Ge]: 'Archive',
    },
    archived: {
        [Locale.Ru]: 'Архивный',
        [Locale.Am]: 'Արխիվային',
        [Locale.En]: 'Archived',
        [Locale.Pt]: 'Arquivado',
        [Locale.Ge]: 'არქივული',
    },
    archiveFem: {
        [Locale.Ru]: 'Архивная',
        [Locale.Am]: 'Արխիվային',
        [Locale.En]: 'Archive',
        [Locale.Pt]: 'Arquivo',
        [Locale.Ge]: 'Archive',
    },
    toArchive: {
        [Locale.Ru]: 'В архив',
        [Locale.Am]: 'Արխիվ',
        [Locale.En]: 'To archive',
        [Locale.Pt]: 'Para arquivar',
        [Locale.Ge]: 'To archive',
    },
    reportType: {
        [Locale.Ru]: 'Тип отчета',
        [Locale.Am]: 'Հաշվետվության տեսակ',
        [Locale.En]: 'Report type',
        [Locale.Pt]: 'Tipo de relatório',
        [Locale.Ge]: 'Report type',
    },
    generateReport: {
        [Locale.Ru]: 'Сформировать отчет',
        [Locale.Am]: 'Ձևավորել հաշվետվություն',
        [Locale.En]: 'Generate a report',
        [Locale.Pt]: 'porta',
        [Locale.Ge]: 'Generate a report',
    },
    nameSecond: {
        [Locale.Ru]: 'Наименование',
        [Locale.Am]: 'Անվանում',
        [Locale.En]: 'Name',
        [Locale.Pt]: 'Nome',
        [Locale.Ge]: 'Name',
    },
    byName: {
        [Locale.Ru]: 'По названию',
        [Locale.Am]: 'Ըստ անվանման',
        [Locale.En]: 'By name',
        [Locale.Pt]: 'Por nome',
        [Locale.Ge]: 'By name',
    },
    fileName: {
        [Locale.Ru]: 'Название файла',
        [Locale.Am]: 'Ֆայլի անվանում',
        [Locale.En]: 'File name',
        [Locale.Pt]: 'Nome do arquivo',
        [Locale.Ge]: 'File name',
    },
    status: {
        [Locale.Ru]: 'Статус',
        [Locale.Am]: 'Կարգավիճակ',
        [Locale.En]: 'Status',
        [Locale.Pt]: 'Status',
        [Locale.Ge]: 'Status',
    },
    policyNumber: {
        [Locale.Ru]: 'Номер полиса',
        [Locale.Am]: 'Պոլիսի համար',
        [Locale.En]: 'Policy number',
        [Locale.Pt]: 'Número da apólice',
        [Locale.Ge]: 'პოლისის ნომერი',
    },
    policy: {
        [Locale.Ru]: 'Полис',
        [Locale.Am]: 'Պոլիս',
        [Locale.En]: 'Policy',
        [Locale.Pt]: 'Apólice',
        [Locale.Ge]: 'Policy',
    },
    number: {
        [Locale.Ru]: 'Номер',
        [Locale.Am]: 'Համար',
        [Locale.En]: 'Number',
        [Locale.Pt]: 'Número',
        [Locale.Ge]: 'Number',
    },
    guaranteeLatterNumber: {
        [Locale.Ru]: 'Номер ГП',
        [Locale.Am]: 'Երաշխիքային նամակի համար',
        [Locale.En]: 'Guarantee latter number',
        [Locale.Pt]: 'Garanta o último número',
        [Locale.Ge]: 'Guarantee latter number',
    },
    guaranteeLatterDate: {
        [Locale.Ru]: 'Дата ГП',
        [Locale.Am]: 'Երաշխիքային նամակի ամսաթիվ',
        [Locale.En]: 'Guarantee latter date',
        [Locale.Pt]: 'Garantir a última data',
        [Locale.Ge]: 'Guarantee latter date',
    },
    insuranceCompany: {
        [Locale.Ru]: 'Страховая компания',
        [Locale.Am]: 'Ապահովագրական ընկերություն',
        [Locale.En]: 'Insurance Company',
        [Locale.Pt]: 'Seguradora',
        [Locale.Ge]: 'Insurance Company',
    },
    employer: {
        [Locale.Ru]: 'Работодатель',
        [Locale.Am]: 'Գործատու',
        [Locale.En]: 'Employer',
        [Locale.Pt]: 'Empregador',
        [Locale.Ge]: 'Employer',
    },
    causeOfFailing: {
        [Locale.Ru]: 'Причина ошибки',
        [Locale.Am]: 'Սխալի պատճառ',
        [Locale.En]: 'Cause of failing',
        [Locale.Pt]: 'Causa de falha',
        [Locale.Ge]: 'Cause of failing',
    },
    incomingFile: {
        [Locale.Ru]: 'Входящий файл',
        [Locale.Am]: 'Մուտքային ֆայլ',
        [Locale.En]: 'Incoming file',
        [Locale.Pt]: 'Arquivo recebido',
        [Locale.Ge]: 'Incoming file',
    },
    sbpLink: {
        [Locale.Ru]: 'СБП',
        [Locale.Am]: 'Արագ վճարումների համակարգ',
        [Locale.En]: 'SBP',
        [Locale.Pt]: 'PAS',
        [Locale.Ge]: 'SBP',
    },
    raiffeisenTerminal: {
        [Locale.Ru]: 'Терминал Райффайзен',
        [Locale.Am]: 'Ռայֆայզեն տերմինալ',
        [Locale.En]: 'Raiffeisen Terminal',
        [Locale.Pt]: 'Terminal Raiffeisen',
        [Locale.Ge]: 'Raiffeisen Terminal',
    },
    terminal: {
        [Locale.Ru]: 'Терминал',
        [Locale.Am]: 'Տերմինալ',
        [Locale.En]: 'Terminal',
        [Locale.Pt]: 'terminal',
        [Locale.Ge]: 'Terminal',
    },
    plate: {
        [Locale.Ru]: 'Табличка',
        [Locale.Am]: 'Ցուցանակ',
        [Locale.En]: 'Plate',
        [Locale.Pt]: 'Placa',
        [Locale.Ge]: 'Plate',
    },
    linkedCard: {
        [Locale.Ru]: 'Привязанная карта',
        [Locale.Am]: 'Կցված քարտ',
        [Locale.En]: 'Linked card',
        [Locale.Pt]: 'Cartão vinculado',
        [Locale.Ge]: 'Linked card',
    },
    manually: {
        [Locale.Ru]: 'Вручную',
        [Locale.Am]: 'Ձեռքով',
        [Locale.En]: 'Manually',
        [Locale.Pt]: 'Manualmente',
        [Locale.Ge]: 'Manually',
    },
    manuallyWithoutReceipt: {
        [Locale.Ru]: 'Вручную без чека',
        [Locale.Am]: 'Ձեռքով՝ առանց կտրոնի',
        [Locale.En]: 'Manually without a receipt',
        [Locale.Pt]: 'Manualmente sem recibo',
        [Locale.Ge]: 'Manually without a receipt',
    },
    arcaLink: {
        [Locale.Ru]: 'Ссылка карта - Arca',
        [Locale.Am]: 'Քարտի հղում - Arca',
        [Locale.En]: 'Arca link',
        [Locale.Pt]: 'Link Arca',
        [Locale.Ge]: 'Arca link',
    },
    tbankSplit: {
        [Locale.Ru]: 'Ссылка на оплату Т-Банк',
        [Locale.Am]: 'T-Bank վճարման հղում',
        [Locale.En]: 'T-Bank payment link',
        [Locale.Pt]: 'Link de pagamento T-Bank',
        [Locale.Ge]: 'T-Bank გადახდის ბმული',
    },
    tbank: {
        [Locale.Ru]: 'Т-Банк',
        [Locale.Am]: 'T-Bank',
        [Locale.En]: 'T-Bank',
        [Locale.Pt]: 'T-Bank',
        [Locale.Ge]: 'T-Bank',
    },
    payServicesOfDifferentOrganizations: {
        [Locale.Ru]: 'Оплатить услуги разных организаций одним платежом',
        [Locale.Am]: 'Վճարել տարբեր կազմակերպությունների ծառայությունների համար մեկ վճարումով',
        [Locale.En]: 'Pay for services from different organizations in one payment',
        [Locale.Pt]: 'Pagar serviços de diferentes organizações num único pagamento',
        [Locale.Ge]: 'გადაიხადეთ სხვადასხვა ორგანიზაციის მომსახურება ერთი გადახდით',
    },
    servicesOfDifferentOrganizations: {
        [Locale.Ru]: 'Услуги разных организаций',
        [Locale.Am]: 'Տարբեր կազմակերպությունների ծառայություններ',
        [Locale.En]: 'Services from different organizations',
        [Locale.Pt]: 'Serviços de diferentes organizações',
        [Locale.Ge]: 'სხვადასხვა ორგანიზაციის მომსახურება',
    },
    byDetails: {
        [Locale.Ru]: 'По реквизитам',
        [Locale.Am]: 'Ըստ վավերապայմանների',
        [Locale.En]: 'By details',
        [Locale.Pt]: 'Por detalhes',
        [Locale.Ge]: 'By details',
    },
    cash: {
        [Locale.Ru]: 'Наличные',
        [Locale.Am]: 'Կանխիկ',
        [Locale.En]: 'Cash',
        [Locale.Pt]: 'Dinheiro',
        [Locale.Ge]: 'Cash',
    },
    online: {
        [Locale.Ru]: 'Онлайн',
        [Locale.Am]: 'Առցանց',
        [Locale.En]: 'Online',
        [Locale.Pt]: 'On-line',
        [Locale.Ge]: 'Online',
    },
    unknown: {
        [Locale.Ru]: 'Неизвестно',
        [Locale.Am]: 'Անհայտ',
        [Locale.En]: 'Unknown',
        [Locale.Pt]: 'Desconhecido',
        [Locale.Ge]: 'Unknown',
    },
    personalAccount: {
        [Locale.Ru]: 'Личный счёт',
        [Locale.Am]: 'Անձնական հաշիվ',
        [Locale.En]: 'Personal Account',
        [Locale.Pt]: 'Quantidade',
        [Locale.Ge]: 'Personal Account',
    },
    mockTerminal: {
        [Locale.Ru]: 'Моковый терминал',
        [Locale.Am]: 'Մոկ տերմինալ',
        [Locale.En]: 'Mock terminal',
        [Locale.Pt]: 'Terminal simulado',
        [Locale.Ge]: 'Mock terminal',
    },
    mockCash: {
        [Locale.Ru]: 'Моковые наличные',
        [Locale.Am]: 'Մոկ կանխիկ',
        [Locale.En]: 'Mock cash',
        [Locale.Pt]: 'Dinheiro simulado',
        [Locale.Ge]: 'Mock cash',
    },
    unpaidMany: {
        [Locale.Ru]: 'Неоплаченное',
        [Locale.Am]: 'Չվճարված',
        [Locale.En]: 'Unpaid',
        [Locale.Pt]: 'Não pago',
        [Locale.Ge]: 'Unpaid',
    },
    payments: {
        [Locale.Ru]: 'Оплаты',
        [Locale.Am]: 'Վճարումներ',
        [Locale.En]: 'Payments',
        [Locale.Pt]: 'Pagamentos',
        [Locale.Ge]: 'Payments',
    },
    paymentsByLegalEntity: {
        [Locale.Ru]: 'Оплаты по юридическому лицу',
        [Locale.Am]: 'Վճարումներ ըստ իրավաբանական անձի',
        [Locale.En]: 'Payments by legal entity',
        [Locale.Pt]: 'Pagamentos por pessoa jurídica',
        [Locale.Ge]: 'Payments by legal entity',
    },
    byLegalEntity: {
        [Locale.Ru]: 'По юридическому лицу',
        [Locale.Am]: 'Ըստ իրավաբանական անձի',
        [Locale.En]: 'By legal entity',
        [Locale.Pt]: 'Por pessoa jurídica',
        [Locale.Ge]: 'By legal entity',
    },
    legalEntityOfPaymentMethod: {
        [Locale.Ru]: 'Юридическое лицо метода оплаты',
        [Locale.Am]: 'Վճարման եղանակի իրավաբանական անձ',
        [Locale.En]: 'Legal entity of payment method',
        [Locale.Pt]: 'Pessoa jurídica da forma de pagamento',
        [Locale.Ge]: 'Legal entity of payment method',
    },
    taskResearchDescription: {
        [Locale.Ru]: 'Задание на исследование попадёт в очередь прибора на текущее время',
        [Locale.Am]: 'Հետազոտության առաջադրանքը կհայտնվի սարքի հերթում ընթացիկ ժամի համար',
        [Locale.En]: 'Task to study is placed in the queue at the current time',
        [Locale.Pt]: 'A tarefa para estudar é colocada na fila no horário atual',
        [Locale.Ge]: 'Task to study is placed in the queue at the current time',
    },
    legalEntityServices: {
        [Locale.Ru]: 'Юридическое лицо услуги',
        [Locale.Am]: 'Ծառայության իրավաբանական անձ',
        [Locale.En]: 'Legal entity services',
        [Locale.Pt]: 'Serviços para pessoas jurídicas',
        [Locale.Ge]: 'Legal entity services',
    },
    paymentsOtherVersion: {
        [Locale.Ru]: 'Платежи',
        [Locale.Am]: 'Վճարումներ',
        [Locale.En]: 'Payments',
        [Locale.Pt]: 'Pagamentos',
        [Locale.Ge]: 'Payments',
    },
    reports: {
        [Locale.Ru]: 'Отчёты',
        [Locale.Am]: 'Հաշվետվություններ',
        [Locale.En]: 'Reports',
        [Locale.Pt]: 'Relatórios',
        [Locale.Ge]: 'Reports',
    },
    unpaidRenderedServiceReport: {
        [Locale.Ru]: 'Отчёт по неоплаченным услугам',
        [Locale.Am]: 'Չվճարված ծառայությունների հաշվետվություն',
        [Locale.En]: 'Unpaid rendered service report',
        [Locale.Pt]: 'porta',
        [Locale.Ge]: 'Unpaid rendered service report',
    },
    byUnpaidServices: {
        [Locale.Ru]: 'По неоплаченным услугам',
        [Locale.Am]: 'Ըստ չվճարված ծառայությունների',
        [Locale.En]: 'By unpaid services',
        [Locale.Pt]: 'Por serviços não pagos',
        [Locale.Ge]: 'By unpaid services',
    },
    aboutPayments: {
        [Locale.Ru]: 'Об оплатах',
        [Locale.Am]: 'Վճարումների մասին',
        [Locale.En]: 'About payments',
        [Locale.Pt]: 'Sobre pagamentos',
        [Locale.Ge]: 'About payments',
    },
    waitForGL: {
        [Locale.Ru]: 'Ждем ГП',
        [Locale.Am]: 'Սպասում ենք երաշխիքային նամակի',
        [Locale.En]: 'Wait for GL',
        [Locale.Pt]: 'Aguarde GL',
        [Locale.Ge]: 'Wait for GL',
    },
    selectClinic: {
        [Locale.Ru]: 'Выберите клинику',
        [Locale.Am]: 'Ընտրեք կլինիկան',
        [Locale.En]: 'Select clicnic',
        [Locale.Pt]: 'Selecione a clínica',
        [Locale.Ge]: 'Select clicnic',
    },
    patientSearch: {
        [Locale.Ru]: 'Поиск пациента',
        [Locale.Am]: 'Պացիենտի որոնում',
        [Locale.En]: 'Patient search',
        [Locale.Pt]: 'Pesquisa de pacientes',
        [Locale.Ge]: 'Patient search',
    },
    dateAndTime: {
        [Locale.Ru]: 'Дата и время',
        [Locale.Am]: 'Ամսաթիվ և ժամ',
        [Locale.En]: 'Date and time',
        [Locale.Pt]: 'Data e hora',
        [Locale.Ge]: 'Date and time',
    },
    dateAndTimeOfReception: {
        [Locale.Ru]: 'Дата и время приема',
        [Locale.Am]: 'Ընդունելության ամսաթիվ և ժամ',
        [Locale.En]: 'Date and time of reception',
        [Locale.Pt]: 'Data e hora da recepção',
        [Locale.Ge]: 'Date and time of reception',
    },
    fullName: {
        [Locale.Ru]: 'ФИО',
        [Locale.Am]: 'Անուն, ազգանուն, հայրանուն',
        [Locale.En]: 'Full name',
        [Locale.Pt]: 'Nome completo',
        [Locale.Ge]: 'Full name',
    },
    service: {
        [Locale.Ru]: 'Услуга',
        [Locale.Am]: 'Ծառայություն',
        [Locale.En]: 'Service',
        [Locale.Pt]: 'Serviço',
        [Locale.Ge]: 'სერვისები',
    },
    coordination: {
        [Locale.Ru]: 'Согласование',
        [Locale.Am]: 'Համաձայնեցում',
        [Locale.En]: 'Coordination',
        [Locale.Pt]: 'Coordenação',
        [Locale.Ge]: 'Coordination',
    },
    coverageStatus: {
        [Locale.Ru]: 'Статус согласования',
        [Locale.Am]: 'Համաձայնեցման կարգավիճակ',
        [Locale.En]: 'Coordination status',
        [Locale.Pt]: 'Status de coordenação',
        [Locale.Ge]: 'Coordination status',
    },
    addCoverageStatus: {
        [Locale.Ru]: 'Добавить статус согласования',
        [Locale.Am]: 'Ավելացնել համաձայնեցման կարգավիճակ',
        [Locale.En]: 'Add coordination status',
        [Locale.Pt]: 'Adicionar status de coordenação',
        [Locale.Ge]: 'Add coordination status',
    },
    createCoverageStatus: {
        [Locale.Ru]: 'Создать статус согласования',
        [Locale.Am]: 'Ստեղծել համաձայնեցման կարգավիճակ',
        [Locale.En]: 'Create coordination status',
        [Locale.Pt]: 'Criar status de coordenação',
        [Locale.Ge]: 'Create coordination status',
    },
    editCoverageStatus: {
        [Locale.Ru]: 'Редактировать статус согласования',
        [Locale.Am]: 'Խմբագրել համաձայնեցման կարգավիճակը',
        [Locale.En]: 'Edit coordination status',
        [Locale.Pt]: 'Editar status de coordenação',
        [Locale.Ge]: 'Edit coordination status',
    },
    createdAt: {
        [Locale.Ru]: 'Дата создания',
        [Locale.Am]: 'Ստեղծման ամսաթիվ',
        [Locale.En]: 'Date of creation',
        [Locale.Pt]: 'Data de criação',
        [Locale.Ge]: 'Date of creation',
    },
    serviceCategory: {
        [Locale.Ru]: 'Категория услуги',
        [Locale.Am]: 'Ծառայության կատեգորիա',
        [Locale.En]: 'Service category',
        [Locale.Pt]: 'Categoria de serviço',
        [Locale.Ge]: 'მომსახურების კატეგორია',
    },
    discountType: {
        [Locale.Ru]: 'Тип скидки',
        [Locale.Am]: 'Զեղչի տեսակ',
        [Locale.En]: 'Discount type',
        [Locale.Pt]: 'Tipo de desconto',
        [Locale.Ge]: 'დაკლების ტიპი',
    },
    discountTypeAverage: {
        [Locale.Ru]: 'Средняя скидка',
        [Locale.Am]: 'Միջին զեղչ',
        [Locale.En]: 'Average discount',
        [Locale.Pt]: 'Idade',
        [Locale.Ge]: 'საშუალო ფასდაკლება',
    },
    discountTypeFlat: {
        [Locale.Ru]: 'Фиксированная скидка',
        [Locale.Am]: 'Ֆիքսված զեղչ',
        [Locale.En]: 'Flat discount',
        [Locale.Pt]: 'Em',
        [Locale.Ge]: 'ფიქსირებული ფასდაკლება',
    },
    discountTypeHurdle: {
        [Locale.Ru]: 'Скидка по порогу',
        [Locale.Am]: 'Շեմային զեղչ',
        [Locale.En]: 'Hurdle discount',
        [Locale.Pt]: 'Desconto de barreira',
        [Locale.Ge]: 'ზღვრული ფასდაკლება',
    },
    rate: {
        [Locale.Ru]: 'Ставка',
        [Locale.Am]: 'Դրույքաչափ',
        [Locale.En]: 'Rate',
        [Locale.Pt]: 'Táxons',
        [Locale.Ge]: 'ტარი',
    },
    hurdle: {
        [Locale.Ru]: 'Порог',
        [Locale.Am]: 'Շեմ',
        [Locale.En]: 'Hurdle',
        [Locale.Pt]: 'Obstáculo',
        [Locale.Ge]: 'ზღვარი',
    },
    organization: {
        [Locale.Ru]: 'Организация',
        [Locale.Am]: 'Կազմակերպություն',
        [Locale.En]: 'Organization',
        [Locale.Pt]: 'Organização',
        [Locale.Ge]: 'ორგანიზაცია',
    },
    branch: {
        [Locale.Ru]: 'Филиал',
        [Locale.Am]: 'Մասնաճյուղ',
        [Locale.En]: 'Branch',
        [Locale.Pt]: 'Filial',
        [Locale.Ge]: 'Branch',
    },
    card: {
        [Locale.Ru]: 'Карта',
        [Locale.Am]: 'Քարտ',
        [Locale.En]: 'Card',
        [Locale.Pt]: 'Cartão',
        [Locale.Ge]: 'Card',
    },
    paymentType: {
        [Locale.Ru]: 'Тип оплаты',
        [Locale.Am]: 'Վճարման տեսակ',
        [Locale.En]: 'Payment type',
        [Locale.Pt]: 'Tipo de pagamento',
        [Locale.Ge]: 'Payment type',
    },
    amount: {
        [Locale.Ru]: 'Сумма',
        [Locale.Am]: 'Գումար',
        [Locale.En]: 'Amount',
        [Locale.Pt]: 'Valentia',
        [Locale.Ge]: 'Amount',
    },
    totalAmount: {
        [Locale.Ru]: 'Общая сумма',
        [Locale.Am]: 'Ընդհանուր գումար',
        [Locale.En]: 'Total amount',
        [Locale.Pt]: 'Montante total',
        [Locale.Ge]: 'Total amount',
    },
    slipUrls: {
        [Locale.Ru]: 'Ссылки на чеки',
        [Locale.Am]: 'Կտրոնների հղումներ',
        [Locale.En]: 'Slip urls',
        [Locale.Pt]: 'URLs de deslizamento',
        [Locale.Ge]: 'Slip urls',
    },
    initialization: {
        [Locale.Ru]: 'Инициализация',
        [Locale.Am]: 'Սկզբնավորում',
        [Locale.En]: 'Initialization',
        [Locale.Pt]: 'Inicialização',
        [Locale.Ge]: 'Initialization',
    },
    initializationFailed: {
        [Locale.Ru]: 'Инициализация прервана',
        [Locale.Am]: 'Սկզբնավորումն ընդհատվեց',
        [Locale.En]: 'Initialization Failed',
        [Locale.Pt]: 'Falha na inicialização',
        [Locale.Ge]: 'Initialization Failed',
    },
    processingFailed: {
        [Locale.Ru]: 'Ошибка выполнения',
        [Locale.Am]: 'Կատարման սխալ',
        [Locale.En]: 'Processing Failed',
        [Locale.Pt]: 'Falha no processamento',
        [Locale.Ge]: 'Processing Failed',
    },
    waitingForReceipt: {
        [Locale.Ru]: 'В ожидании чека',
        [Locale.Am]: 'Կտրոնի սպասում',
        [Locale.En]: 'Waiting For Receipt',
        [Locale.Pt]: 'Aguardando recebimento',
        [Locale.Ge]: 'Waiting For Receipt',
    },
    receiptFailed: {
        [Locale.Ru]: 'Ошибка получения чека',
        [Locale.Am]: 'Կտրոնի ստացման սխալ',
        [Locale.En]: 'Receipt Failed',
        [Locale.Pt]: 'Falha no recebimento',
        [Locale.Ge]: 'Receipt Failed',
    },
    processing: {
        [Locale.Ru]: 'Выполняется',
        [Locale.Am]: 'Կատարվում է',
        [Locale.En]: 'Processing',
        [Locale.Pt]: 'Processando',
        [Locale.Ge]: 'Processing',
    },
    schedule: {
        [Locale.Ru]: 'Расписание',
        [Locale.Am]: 'Ժամանակացույց',
        [Locale.En]: 'Schedule',
        [Locale.Pt]: 'Agenda',
        [Locale.Ge]: 'განრიგი',
    },
    references: {
        [Locale.Ru]: 'Справки',
        [Locale.Am]: 'Տեղեկանքներ',
        [Locale.En]: 'References',
        [Locale.Pt]: 'Referências',
        [Locale.Ge]: 'ცნობარი',
    },
    Описание: {
        [Locale.Ru]: 'Описание',
        [Locale.Am]: 'Նկարագրություն',
        [Locale.En]: 'Description',
        [Locale.Pt]: 'Descrição',
        [Locale.Ge]: 'აღწერილობა',
    },
    'Админ панель': {
        [Locale.Ru]: 'Админ панель',
        [Locale.Am]: 'Ադմին վահանակ',
        [Locale.En]: 'Admin panel',
        [Locale.Pt]: 'Painel de administração',
        [Locale.Ge]: 'Admin panel',
    },
    prompts: {
        [Locale.Ru]: 'Промпты',
        [Locale.Am]: 'Փրոմպթներ',
        [Locale.En]: 'Prompts',
        [Locale.Pt]: 'Prompts',
        [Locale.Ge]: 'Prompts',
    },
    addPrompt: {
        [Locale.Ru]: 'Добавить промпт',
        [Locale.Am]: 'Ավելացնել փրոմպթ',
        [Locale.En]: 'Add prompt',
        [Locale.Pt]: 'Adicionar prompt',
        [Locale.Ge]: 'Add prompt',
    },
    addRule: {
        [Locale.Ru]: 'Добавить правило',
        [Locale.Am]: 'Ավելացնել կանոն',
        [Locale.En]: 'Add rule',
        [Locale.Pt]: 'Adicionar regra',
        [Locale.Ge]: 'Add rule',
    },
    rule: {
        [Locale.Ru]: 'Правило',
        [Locale.Am]: 'Կանոն',
        [Locale.En]: 'Rule',
        [Locale.Pt]: 'Regra',
        [Locale.Ge]: 'Rule',
    },
    promptName: {
        [Locale.Ru]: 'Промпт',
        [Locale.Am]: 'Փրոմպթ',
        [Locale.En]: 'Prompt',
        [Locale.Pt]: 'Prompt',
        [Locale.Ge]: 'Prompt',
    },
    promptsSettings: {
        [Locale.Ru]: 'Настройки промптов',
        [Locale.Am]: 'Փրոմպթների կարգավորումներ',
        [Locale.En]: 'Prompt settings',
        [Locale.Pt]: 'Configurações de prompts',
        [Locale.Ge]: 'Prompt settings',
    },
    additionalRules: {
        [Locale.Ru]: 'Доп. правила',
        [Locale.Am]: 'Լրաց. կանոններ',
        [Locale.En]: 'Additional rules',
        [Locale.Pt]: 'Regras adicionais',
        [Locale.Ge]: 'Additional rules',
    },
    systemPrompt: {
        [Locale.Ru]: 'Системный промпт',
        [Locale.Am]: 'Համակարգային փրոմպթ',
        [Locale.En]: 'System prompt',
        [Locale.Pt]: 'Prompt do sistema',
        [Locale.Ge]: 'System prompt',
    },
    userMessageTemplate: {
        [Locale.Ru]: 'Шаблон сообщения пользователя',
        [Locale.Am]: 'Օգտատիրոջ հաղորդագրության ձևանմուշ',
        [Locale.En]: 'User message template',
        [Locale.Pt]: 'Modelo de mensagem do usuário',
        [Locale.Ge]: 'User message template',
    },
    defaultLanguage: {
        [Locale.Ru]: 'Язык по умолчанию',
        [Locale.Am]: 'Լռելյայն լեզու',
        [Locale.En]: 'Default language',
        [Locale.Pt]: 'Idioma padrão',
        [Locale.Ge]: 'Default language',
    },
    algorithmVersion: {
        [Locale.Ru]: 'Версия алгоритма',
        [Locale.Am]: 'Ալգորիթմի տարբերակ',
        [Locale.En]: 'Algorithm version',
        [Locale.Pt]: 'Versão do algoritmo',
        [Locale.Ge]: 'Algorithm version',
    },
    division: {
        [Locale.Ru]: 'Дивизион',
        [Locale.Am]: 'Դիվիզիոն',
        [Locale.En]: 'Division',
        [Locale.Pt]: 'Divisão',
        [Locale.Ge]: 'Division',
    },
    procedural: {
        [Locale.Ru]: 'Процедурная',
        [Locale.Am]: 'Պրոցեդուրային կաբինետ',
        [Locale.En]: 'Procedural',
        [Locale.Pt]: 'Processual',
        [Locale.Ge]: 'პროცედურული',
    },
    billing: {
        [Locale.Ru]: 'Оплата',
        [Locale.Am]: 'Վճարում',
        [Locale.En]: 'Payment',
        [Locale.Pt]: 'Faturamento',
        [Locale.Ge]: 'გადახდა',
    },
    billingSecond: {
        [Locale.Ru]: 'Услуги',
        [Locale.Am]: 'Ծառայություններ',
        [Locale.En]: 'Billing',
        [Locale.Pt]: 'Cobrança',
        [Locale.Ge]: 'გადახდა',
    },
    walkIn: {
        [Locale.Ru]: 'Walk-in',
        [Locale.Am]: 'Walk-in',
        [Locale.En]: 'Walk-in',
        [Locale.Pt]: 'Walk-in',
        [Locale.Ge]: 'Walk-in',
    },
    laboratoryDiagnostics: {
        [Locale.Ru]: 'Лабораторная диагностика',
        [Locale.Am]: 'Լաբորատոր ախտորոշում',
        [Locale.En]: 'Laboratory diagnostics',
        [Locale.Pt]: 'Diagnóstico laboratorial',
        [Locale.Ge]: 'ლაბორატორიული დიაგნოსტიკა',
    },
    radiology: {
        [Locale.Ru]: 'Лучевая',
        [Locale.Am]: 'Ռադիոլոգիա',
        [Locale.En]: 'Radiology',
        [Locale.Pt]: 'Radiologia',
        [Locale.Ge]: 'რადიოლოგია',
    },
    instrumental: {
        [Locale.Ru]: 'Инструментальная',
        [Locale.Am]: 'Գործիքային',
        [Locale.En]: 'Instrumental',
        [Locale.Pt]: 'Instrumental',
        [Locale.Ge]: 'ინსტრუმენტული',
    },
    radiologyDiagnostics: {
        [Locale.Ru]: 'Лучевая диагностика',
        [Locale.Am]: 'Ռադիոլոգիական ախտորոշում',
        [Locale.En]: 'Radiology diagnostics',
        [Locale.Pt]: 'Diagnóstico radiológico',
        [Locale.Ge]: 'რადიოლოგიური დიაგნოსტიკა',
    },
    instrumentalDiagnostics: {
        [Locale.Ru]: 'Инструментальная диагностика',
        [Locale.Am]: 'Գործիքային ախտորոշում',
        [Locale.En]: 'Instrumental diagnostics',
        [Locale.Pt]: 'Diagnóstico instrumental',
        [Locale.Ge]: 'ინსტრუმენტული დიაგნოსტიკა',
    },
    createEntryAndSendToDevice: {
        [Locale.Ru]: 'Создать запись в карте и отправить на прибор',
        [Locale.Am]: 'Ստեղծել գրառում քարտում և ուղարկել սարքին',
        [Locale.En]: 'Create an entry in the record and send it to the device',
        [Locale.Pt]: 'Criar um registro no prontuário e enviá-lo para o equipamento',
        [Locale.Ge]: 'ბარათში ჩანაწერის შექმნა და აპარატზე გაგზავნა',
    },
    specifyEntryDoctor: {
        [Locale.Ru]: 'Укажите врача записи',
        [Locale.Am]: 'Նշեք գրառման բժշկին',
        [Locale.En]: 'Specify the entry doctor',
        [Locale.Pt]: 'Indique o médico do registro',
        [Locale.Ge]: 'მიუთითეთ ჩანაწერის ექიმი',
    },
    referralEntryDoctorDescription: {
        [Locale.Ru]: 'Вы создаёте ответную запись по направлению и отправляете задание на прибор. Выберите врача, который будет описывать исследование.',
        [Locale.Am]: 'Դուք ստեղծում եք պատասխան գրառում ըստ ուղեգրի և առաջադրանքն ուղարկում եք սարքին։ Ընտրեք այն բժշկին, ով նկարագրելու է հետազոտությունը։',
        [Locale.En]: 'You are creating a response entry for the referral and sending the task to the device. Select the doctor who will describe the examination.',
        [Locale.Pt]: 'Você está criando um registro de resposta ao encaminhamento e enviando a tarefa para o equipamento. Selecione o médico que irá descrever o exame.',
        [Locale.Ge]: 'თქვენ ქმნით საპასუხო ჩანაწერს მიმართვაზე და აგზავნით დავალებას აპარატზე. აირჩიეთ ექიმი, რომელიც აღწერს კვლევას.',
    },
    entryCreating: {
        [Locale.Ru]: 'Создание',
        [Locale.Am]: 'Ստեղծվում է',
        [Locale.En]: 'Creating',
        [Locale.Pt]: 'Criando',
        [Locale.Ge]: 'იქმნება',
    },
    referralEntryDoctorDescriptionWithoutDeviceTask: {
        [Locale.Ru]: 'Вы создаёте ответную запись по направлению. Выберите врача, который будет описывать исследование.',
        [Locale.Am]: 'Դուք ստեղծում եք պատասխան գրառում ըստ ուղեգրի։ Ընտրեք այն բժշկին, ով նկարագրելու է հետազոտությունը։',
        [Locale.En]: 'You are creating a response entry for the referral. Select the doctor who will describe the examination.',
        [Locale.Pt]: 'Você está criando um registro de resposta ao encaminhamento. Selecione o médico que irá descrever o exame.',
        [Locale.Ge]: 'თქვენ ქმნით საპასუხო ჩანაწერს მიმართვაზე. აირჩიეთ ექიმი, რომელიც აღწერს კვლევას.',
    },
    changingReferralDoctorWarning: {
        [Locale.Ru]: 'Вы меняете доктора, который был указан в направлении',
        [Locale.Am]: 'Դուք փոխում եք ուղեգրում նշված բժշկին',
        [Locale.En]: 'You are changing the doctor specified in the referral',
        [Locale.Pt]: 'Você está alterando o médico indicado no encaminhamento',
        [Locale.Ge]: 'თქვენ ცვლით მიმართვაში მითითებულ ექიმს',
    },
    referralDoctorRequiredTitle: {
        [Locale.Ru]: 'Укажите врача',
        [Locale.Am]: 'Նշեք բժշկին',
        [Locale.En]: 'Specify the doctor',
        [Locale.Pt]: 'Indique o médico',
        [Locale.Ge]: 'მიუთითეთ ექიმი',
    },
    referralDoctorRequiredDescription: {
        [Locale.Ru]: 'Для этого направления необходимо указать врача. Редактировать?',
        [Locale.Am]: 'Այս ուղեգրի համար անհրաժեշտ է նշել բժշկին։ Խմբագրե՞լ։',
        [Locale.En]: 'This referral requires a doctor. Edit it?',
        [Locale.Pt]: 'Este encaminhamento exige a indicação de um médico. Editar?',
        [Locale.Ge]: 'ამ მიმართვისთვის აუცილებელია ექიმის მითითება. გსურთ რედაქტირება?',
    },
    dashboard: {
        [Locale.Ru]: 'Дашборды',
        [Locale.Am]: 'Դաշբորդներ',
        [Locale.En]: 'Dashboards',
        [Locale.Pt]: 'Painel',
        [Locale.Ge]: 'დაფები',
    },
    diagnostic: {
        [Locale.Ru]: 'Описание исследований',
        [Locale.Am]: 'Հետազոտությունների նկարագրություն',
        [Locale.En]: 'Research Description',
        [Locale.Pt]: 'Descrição da pesquisa',
        [Locale.Ge]: 'კვლევის აღწერა',
    },
    entryTypes: {
        [Locale.Ru]: 'Типы записей',
        [Locale.Am]: 'Գրառումների տեսակներ',
        [Locale.En]: 'Entry types',
        [Locale.Pt]: 'Tipos de entrada',
        [Locale.Ge]: 'პოსტის ტიპები',
    },
    notification: {
        [Locale.Ru]: 'Уведомления',
        [Locale.Am]: 'Ծանուցումներ',
        [Locale.En]: 'Notifications',
        [Locale.Pt]: 'Notificação',
        [Locale.Ge]: 'შეტყობინებები',
    },
    users: {
        [Locale.Ru]: 'Пользователи',
        [Locale.Am]: 'Օգտատերեր',
        [Locale.En]: 'Users',
        [Locale.Pt]: 'Usuários',
        [Locale.Ge]: 'მომხმარებლები',
    },
    organizations: {
        [Locale.Ru]: 'Организации',
        [Locale.Am]: 'Կազմակերպություններ',
        [Locale.En]: 'Organizations',
        [Locale.Pt]: 'Organizações',
        [Locale.Ge]: 'ორგანიზაციები',
    },
    services: {
        [Locale.Ru]: 'Услуги',
        [Locale.Am]: 'Ծառայություններ',
        [Locale.En]: 'Services',
        [Locale.Pt]: 'Serviços',
        [Locale.Ge]: 'სერვისები',
    },
    insuranceAndPayments: {
        [Locale.Ru]: 'Счета и оплата',
        [Locale.Am]: 'Հաշիվներ և վճարում',
        [Locale.En]: 'Insurance and payments',
        [Locale.Pt]: 'Seguros e pagamentos',
        [Locale.Ge]: 'Insurance and payments',
    },
    servicesDone: {
        [Locale.Ru]: 'Услуг',
        [Locale.Am]: 'Ծառայություններ',
        [Locale.En]: 'Services',
        [Locale.Pt]: 'Serviços',
        [Locale.Ge]: 'სერვისები',
    },
    material: {
        [Locale.Ru]: 'Материал',
        [Locale.Am]: 'Նյութ',
        [Locale.En]: 'Material',
        [Locale.Pt]: 'Material',
        [Locale.Ge]: 'Material',
    },
    materialTwo: {
        [Locale.Ru]: 'Материала',
        [Locale.Am]: 'Նյութ',
        [Locale.En]: 'Materials',
        [Locale.Pt]: 'Materiais',
        [Locale.Ge]: 'Materials',
    },
    materials: {
        [Locale.Ru]: 'Материалов',
        [Locale.Am]: 'Նյութեր',
        [Locale.En]: 'Materials',
        [Locale.Pt]: 'Materiais',
        [Locale.Ge]: 'Materials',
    },
    servicesAndPrices: {
        [Locale.Ru]: 'Услуги и цены',
        [Locale.Am]: 'Ծառայություններ և գներ',
        [Locale.En]: 'Services & Prices',
        [Locale.Pt]: 'Serviços e Preços',
        [Locale.Ge]: 'სერვისები & ფასები',
    },
    priceList: {
        [Locale.Ru]: 'Прайс-лист',
        [Locale.Am]: 'Գնացուցակ',
        [Locale.En]: 'Price list',
        [Locale.Pt]: 'Lista de preços',
        [Locale.Ge]: 'ფასის სია',
    },
    individualPriceList: {
        [Locale.Ru]: 'Индивидуальный прайс лист',
        [Locale.Am]: 'Անհատական գնացուցակ',
        [Locale.En]: 'Individual price list',
        [Locale.Pt]: 'Lista de preços individuais',
        [Locale.Ge]: 'ინდივიდუალური ფასების სია',
    },
    plans: {
        [Locale.Ru]: 'Программы',
        [Locale.Am]: 'Ծրագրեր',
        [Locale.En]: 'Programs',
        [Locale.Pt]: 'Programas',
        [Locale.Ge]: 'პროგრამები',
    },
    plan: {
        [Locale.Ru]: 'Программа',
        [Locale.Am]: 'Ծրագիր',
        [Locale.En]: 'Program',
        [Locale.Pt]: 'LAN',
        [Locale.Ge]: 'გამოყენება',
    },
    featureToggle: {
        [Locale.Ru]: 'Фича флаги',
        [Locale.Am]: 'Ֆունկցիոնալ դրոշակներ',
        [Locale.En]: 'Feature toggle',
        [Locale.Pt]: 'Alternar recurso',
        [Locale.Ge]: 'გამორჩეული დროშები',
    },
    attachment: {
        [Locale.Ru]: 'Статусы прикреплений',
        [Locale.Am]: 'Կցումների կարգավիճակներ',
        [Locale.En]: 'Attachment',
        [Locale.Pt]: 'Anexo',
        [Locale.Ge]: 'Attachment',
    },
    insuranceRecords: {
        [Locale.Ru]: 'История прикреплений',
        [Locale.Am]: 'Կցումների պատմություն',
        [Locale.En]: 'Insurance records',
        [Locale.Pt]: 'Registros de seguros',
        [Locale.Ge]: 'Insurance records',
    },
    financeConfiguration: {
        [Locale.Ru]: 'Настройки оплат',
        [Locale.Am]: 'Վճարումների կարգավորումներ',
        [Locale.En]: 'Finance configuration',
        [Locale.Pt]: 'Configuração financeira',
        [Locale.Ge]: 'Finance configuration',
    },
    dataIsolation: {
        [Locale.Ru]: 'Изоляция данных',
        [Locale.Am]: 'Տվյալների մեկուսացում',
        [Locale.En]: 'Data isolation',
        [Locale.Pt]: 'Isolamento de dados',
        [Locale.Ge]: 'მონაცემთა იზოლაცია',
    },
    accessRights: {
        [Locale.Ru]: 'Доступы',
        [Locale.Am]: 'Հասանելիության իրավունքներ',
        [Locale.En]: 'Access rights',
        [Locale.Pt]: 'Direitos de acesso',
        [Locale.Ge]: 'წვდომის უფლებები',
    },
    accessBlocks: {
        [Locale.Ru]: 'Блокировки',
        [Locale.Am]: 'Արգելափակումներ',
        [Locale.En]: 'Blocks',
        [Locale.Pt]: 'Bloqueios',
        [Locale.Ge]: 'დაბლოკვები',
    },
    blockDate: {
        [Locale.Ru]: 'Дата блокировки',
        [Locale.Am]: 'Արգելափակման ամսաթիվ',
        [Locale.En]: 'Block date',
        [Locale.Pt]: 'Data do bloqueio',
        [Locale.Ge]: 'დაბლოკვის თარიღი',
    },
    ownEhr: {
        [Locale.Ru]: 'Своя медкарта',
        [Locale.Am]: 'Սեփական բժշկական քարտ',
        [Locale.En]: 'Own medical record',
        [Locale.Pt]: 'Prontuário próprio',
        [Locale.Ge]: 'საკუთარი სამედიცინო ბარათი',
    },
    grantBasis: {
        [Locale.Ru]: 'Основание',
        [Locale.Am]: 'Հիմք',
        [Locale.En]: 'Basis',
        [Locale.Pt]: 'Fundamento',
        [Locale.Ge]: 'საფუძველი',
    },
    searchByReason: {
        [Locale.Ru]: 'Поиск по причине',
        [Locale.Am]: 'Որոնում ըստ պատճառի',
        [Locale.En]: 'Search by reason',
        [Locale.Pt]: 'Pesquisar por motivo',
        [Locale.Ge]: 'ძიება მიზეზით',
    },
    accounting: {
        [Locale.Ru]: 'Бухгалтерия',
        [Locale.Am]: 'Հաշվապահություն',
        [Locale.En]: 'Accounting',
        [Locale.Pt]: 'Contabilidade',
        [Locale.Ge]: 'Accounting',
    },
    businessChaika: {
        [Locale.Ru]: 'Business chaika',
        [Locale.Am]: 'Business chaika',
        [Locale.En]: 'Business chaika',
        [Locale.Pt]: 'Chaika de negócios',
        [Locale.Ge]: 'Business chaika',
    },
    payment: {
        [Locale.Ru]: 'Оплата',
        [Locale.Am]: 'Վճարում',
        [Locale.En]: 'Payment',
        [Locale.Pt]: 'Pagamento',
        [Locale.Ge]: 'გადახდა',
    },
    refund: {
        [Locale.Ru]: 'Возврат',
        [Locale.Am]: 'Վերադարձ',
        [Locale.En]: 'Refund',
        [Locale.Pt]: 'Reembolso',
        [Locale.Ge]: 'Refund',
    },
    account_replenishment: {
        [Locale.Ru]: 'Пополнение личного счёта',
        [Locale.Am]: 'Անձնական հաշվի համալրում',
        [Locale.En]: 'Top up your personal account',
        [Locale.Pt]: 'Recarregue sua conta pessoal',
        [Locale.Ge]: 'Top up your personal account',
    },
    refund_to_account: {
        [Locale.Ru]: 'Возврат на личный счёт',
        [Locale.Am]: 'Վերադարձ անձնական հաշվին',
        [Locale.En]: 'Return to personal account',
        [Locale.Pt]: 'Quantidade',
        [Locale.Ge]: 'Return to personal account',
    },
    write_off: {
        [Locale.Ru]: 'Списание с ЛС',
        [Locale.Am]: 'Դուրսգրում անձնական հաշվից',
        [Locale.En]: 'Write-off from PA',
        [Locale.Pt]: 'Baixa do PA',
        [Locale.Ge]: 'Write-off from PA',
    },
    subscription: {
        [Locale.Ru]: 'Подписка',
        [Locale.Am]: 'Բաժանորդագրություն',
        [Locale.En]: 'Subscription',
        [Locale.Pt]: 'Assinatura',
        [Locale.Ge]: 'Subscription',
    },
    serviceCode: {
        [Locale.Ru]: 'Код услуги',
        [Locale.Am]: 'Ծառայության կոդ',
        [Locale.En]: 'Service code',
        [Locale.Pt]: 'Código de serviço',
        [Locale.Ge]: 'სერვისის კოდი',
    },
    serialNumber: {
        [Locale.Ru]: 'Серийный номер',
        [Locale.Am]: 'Սերիական համար',
        [Locale.En]: 'Serial number',
        [Locale.Pt]: 'Número de série',
        [Locale.Ge]: 'Serial number',
    },
    refunds: {
        [Locale.Ru]: 'Возвраты',
        [Locale.Am]: 'Վերադարձեր',
        [Locale.En]: 'Refunds',
        [Locale.Pt]: 'Reembolsos',
        [Locale.Ge]: 'Refunds',
    },
    reportFor: {
        [Locale.Ru]: 'Отчет за',
        [Locale.Am]: 'Հաշվետվություն՝',
        [Locale.En]: 'Report for',
        [Locale.Pt]: 'Relatório para',
        [Locale.Ge]: 'Report for',
    },
    cashless: {
        [Locale.Ru]: 'Безналичные',
        [Locale.Am]: 'Անկանխիկ',
        [Locale.En]: 'Cashless',
        [Locale.Pt]: 'Menos',
        [Locale.Ge]: 'Cashless',
    },
    executorBranch: {
        [Locale.Ru]: 'Филиал исполнителя',
        [Locale.Am]: 'Կատարողի մասնաճյուղ',
        [Locale.En]: 'Executor branch',
        [Locale.Pt]: 'Ramo executor',
        [Locale.Ge]: 'Executor branch',
    },
    entryDate: {
        [Locale.Ru]: 'Дата записи',
        [Locale.Am]: 'Գրառման ամսաթիվ',
        [Locale.En]: 'Entry date',
        [Locale.Pt]: 'Data de entrada',
        [Locale.Ge]: 'Entry date',
    },
    amountToPay: {
        [Locale.Ru]: 'Сумма к оплате',
        [Locale.Am]: 'Վճարման ենթակա գումար',
        [Locale.En]: 'Amount to pay',
        [Locale.Pt]: 'Valor a pagar',
        [Locale.Ge]: 'Amount to pay',
    },
    hasProgram: {
        [Locale.Ru]: 'Есть программа',
        [Locale.Am]: 'Կա ծրագիր',
        [Locale.En]: 'There is a program',
        [Locale.Pt]: 'Existe um programa',
        [Locale.Ge]: 'There is a program',
    },
    employee: {
        [Locale.Ru]: 'Сотрудник',
        [Locale.Am]: 'Աշխատակից',
        [Locale.En]: 'Employee',
        [Locale.Pt]: 'Funcionário',
        [Locale.Ge]: 'Employee',
    },
    linkToCard: {
        [Locale.Ru]: 'Ссылка на карту',
        [Locale.Am]: 'Քարտի հղում',
        [Locale.En]: 'Link to card',
        [Locale.Pt]: 'Link para cartão',
        [Locale.Ge]: 'Link to card',
    },
    sex: {
        [Locale.Ru]: 'Пол',
        [Locale.Am]: 'Սեռ',
        [Locale.En]: 'Sex',
        [Locale.Pt]: 'Sexo',
        [Locale.Ge]: 'Sex',
    },
    duty: {
        [Locale.Ru]: 'Долг',
        [Locale.Am]: 'Պարտք',
        [Locale.En]: 'Duty',
        [Locale.Pt]: 'Obrigação',
        [Locale.Ge]: 'Duty',
    },
    man: {
        [Locale.Ru]: 'Мужчина',
        [Locale.Am]: 'Տղամարդ',
        [Locale.En]: 'Man',
        [Locale.Pt]: 'Homem',
        [Locale.Ge]: 'Man',
    },
    woman: {
        [Locale.Ru]: 'Женщина',
        [Locale.Am]: 'Կին',
        [Locale.En]: 'Woman',
        [Locale.Pt]: 'Mulher',
        [Locale.Ge]: 'Woman',
    },
    noData: {
        [Locale.Ru]: 'Нет данных',
        [Locale.Am]: 'Տվյալներ չկան',
        [Locale.En]: 'No data',
        [Locale.Pt]: 'Sem dados',
        [Locale.Ge]: 'No data',
    },
    editing: {
        [Locale.Ru]: 'Редактирование',
        [Locale.Am]: 'Խմբագրում',
        [Locale.En]: 'Editing',
        [Locale.Pt]: 'Edição',
        [Locale.Ge]: 'Editing',
    },
    creation: {
        [Locale.Ru]: 'Создание',
        [Locale.Am]: 'Ստեղծում',
        [Locale.En]: 'Creation',
        [Locale.Pt]: 'Criação',
        [Locale.Ge]: 'Creation',
    },
    history: {
        [Locale.Ru]: 'История',
        [Locale.Am]: 'Պատմություն',
        [Locale.En]: 'History',
        [Locale.Pt]: 'Histórico',
        [Locale.Ge]: 'ისტორია',
    },
    episode: {
        [Locale.Ru]: 'Эпизод',
        [Locale.Am]: 'Էպիզոդ',
        [Locale.En]: 'Episode',
        [Locale.Pt]: 'Episódio',
        [Locale.Ge]: 'ეპიზოდი',
    },
    episodeTwo: {
        [Locale.Ru]: 'Эпизода',
        [Locale.Am]: 'Էպիզոդ',
        [Locale.En]: 'Episodes',
        [Locale.Pt]: 'Episódios',
        [Locale.Ge]: 'ეპიზოდი',
    },
    episodeMany: {
        [Locale.Ru]: 'Эпизодов',
        [Locale.Am]: 'Էպիզոդներ',
        [Locale.En]: 'Episodes',
        [Locale.Pt]: 'Episódios',
        [Locale.Ge]: 'ეპიზოდი',
    },
    episodes: {
        [Locale.Ru]: 'Эпизоды',
        [Locale.Am]: 'Էպիզոդներ',
        [Locale.En]: 'Episodes',
        [Locale.Pt]: 'Episódios',
        [Locale.Ge]: 'Episodes',
    },
    episodeReport: {
        [Locale.Ru]: 'Отчет по эпизодам',
        [Locale.Am]: 'Էպիզոդների հաշվետվություն',
        [Locale.En]: 'Episode report',
        [Locale.Pt]: 'porta',
        [Locale.Ge]: 'Episode report',
    },
    tasks: {
        [Locale.Ru]: 'Задания',
        [Locale.Am]: 'Առաջադրանքներ',
        [Locale.En]: 'Tasks',
        [Locale.Pt]: 'Tarefas',
        [Locale.Ge]: 'Tasks',
    },
    tasksTwo: {
        [Locale.Ru]: 'Заданий',
        [Locale.Am]: 'Առաջադրանքներ',
        [Locale.En]: 'Tasks',
        [Locale.Pt]: 'Tarefas',
        [Locale.Ge]: 'Tasks',
    },
    tasksSecond: {
        [Locale.Ru]: 'Follow up',
        [Locale.Am]: 'Follow up',
        [Locale.En]: 'Follow up',
        [Locale.Pt]: 'Seguir',
        [Locale.Ge]: 'Follow up',
    },
    referralTimeline: {
        [Locale.Ru]: 'Таймлайн направлений',
        [Locale.Am]: 'Ուղեգրերի ժամանակագրություն',
        [Locale.En]: 'Timeline of referrals',
        [Locale.Pt]: 'Cronograma de referências',
        [Locale.Ge]: 'Timeline of referrals',
    },
    subscriptions: {
        [Locale.Ru]: 'Подписки',
        [Locale.Am]: 'Բաժանորդագրություններ',
        [Locale.En]: 'Memberships',
        [Locale.Pt]: 'Associações',
        [Locale.Ge]: 'Memberships',
    },
    subscriptionsMany: {
        [Locale.Ru]: 'Подпискок',
        [Locale.Am]: 'Բաժանորդագրություններ',
        [Locale.En]: 'Memberships',
        [Locale.Pt]: 'Associações',
        [Locale.Ge]: 'Memberships',
    },
    subscriptionsCovid: {
        [Locale.Ru]: 'Подписки COVID',
        [Locale.Am]: 'COVID բաժանորդագրություններ',
        [Locale.En]: 'Subscriptions COVID',
        [Locale.Pt]: 'Assinaturas COVID',
        [Locale.Ge]: 'Subscriptions COVID',
    },
    myDoctors: {
        [Locale.Ru]: 'Мои доктора',
        [Locale.Am]: 'Իմ բժիշկները',
        [Locale.En]: 'My doctors',
        [Locale.Pt]: 'Meus médicos',
        [Locale.Ge]: 'My doctors',
    },
    myDoctor: {
        [Locale.Ru]: 'Мой доктор',
        [Locale.Am]: 'Իմ բժիշկը',
        [Locale.En]: 'My doctor',
        [Locale.Pt]: 'Meu médico',
        [Locale.Ge]: 'My doctor',
    },
    dictionaries: {
        [Locale.Ru]: 'Словари',
        [Locale.Am]: 'Բառարաններ',
        [Locale.En]: 'Dictionaries',
        [Locale.Pt]: 'Dicionários',
        [Locale.Ge]: 'Dictionaries',
    },
    dictionary: {
        [Locale.Ru]: 'Словарь',
        [Locale.Am]: 'Բառարան',
        [Locale.En]: 'Dictionary',
        [Locale.Pt]: 'Dicionário',
        [Locale.Ge]: 'Dictionary',
    },
    tags: {
        [Locale.Ru]: 'Теги',
        [Locale.Am]: 'Պիտակներ',
        [Locale.En]: 'Tags',
        [Locale.Pt]: 'Etiquetas',
        [Locale.Ge]: 'Tags',
    },
    sets: {
        [Locale.Ru]: 'Наборы',
        [Locale.Am]: 'Հավաքածուներ',
        [Locale.En]: 'Sets',
        [Locale.Pt]: 'Conjuntos',
        [Locale.Ge]: 'Sets',
    },
    set: {
        [Locale.Ru]: 'Набор',
        [Locale.Am]: 'Հավաքածու',
        [Locale.En]: 'Set',
        [Locale.Pt]: 'Definir',
        [Locale.Ge]: 'Set',
    },
    specialties: {
        [Locale.Ru]: 'Специальности',
        [Locale.Am]: 'Մասնագիտություններ',
        [Locale.En]: 'Specialties',
        [Locale.Pt]: 'Especialidades',
        [Locale.Ge]: 'Specialties',
    },
    specialty: {
        [Locale.Ru]: 'Специальность',
        [Locale.Am]: 'Մասնագիտություն',
        [Locale.En]: 'Specialty',
        [Locale.Pt]: 'Especialidade',
        [Locale.Ge]: 'Specialty',
    },
    basic: {
        [Locale.Ru]: 'Обычные',
        [Locale.Am]: 'Սովորական',
        [Locale.En]: 'Basic',
        [Locale.Pt]: 'Básicos',
        [Locale.Ge]: 'Basic',
    },
    general: {
        [Locale.Ru]: 'Общие',
        [Locale.Am]: 'Ընդհանուր',
        [Locale.En]: 'General',
        [Locale.Pt]: 'Geral',
        [Locale.Ge]: 'General',
    },
    insurances: {
        [Locale.Ru]: 'Страховые',
        [Locale.Am]: 'Ապահովագրական',
        [Locale.En]: 'Insurance',
        [Locale.Pt]: 'Seguros',
        [Locale.Ge]: 'Insurance',
    },
    complex: {
        [Locale.Ru]: 'Сложные',
        [Locale.Am]: 'Բարդ',
        [Locale.En]: 'Complex',
        [Locale.Pt]: 'Complexos',
        [Locale.Ge]: 'Complex',
    },
    outward: {
        [Locale.Ru]: 'Внешние',
        [Locale.Am]: 'Արտաքին',
        [Locale.En]: 'Outward',
        [Locale.Pt]: 'Externos',
        [Locale.Ge]: 'Outward',
    },
    composite: {
        [Locale.Ru]: 'Составные',
        [Locale.Am]: 'Բաղադրյալ',
        [Locale.En]: 'Composite',
        [Locale.Pt]: 'Compostos',
        [Locale.Ge]: 'Composite',
    },
    risk: {
        [Locale.Ru]: 'Риски',
        [Locale.Am]: 'Ռիսկեր',
        [Locale.En]: 'Risks',
        [Locale.Pt]: 'Risco',
        [Locale.Ge]: 'Risks',
    },
    serviceRelations: {
        [Locale.Ru]: 'Связи услуг',
        [Locale.Am]: 'Ծառայությունների կապեր',
        [Locale.En]: 'Service relations',
        [Locale.Pt]: 'Relações de serviço',
        [Locale.Ge]: 'Service relations',
    },
    reservation: {
        [Locale.Ru]: 'Бронь',
        [Locale.Am]: 'Ամրագրում',
        [Locale.En]: 'Reservation',
        [Locale.Pt]: 'Reserva',
        [Locale.Ge]: 'Reservation',
    },
    timeReservation: {
        [Locale.Ru]: 'Бронь времени',
        [Locale.Am]: 'Ժամի ամրագրում',
        [Locale.En]: 'Time reservation',
        [Locale.Pt]: 'Reserva de horário',
        [Locale.Ge]: 'Time reservation',
    },
    reserve: {
        [Locale.Ru]: 'Резерв',
        [Locale.Am]: 'Պահուստ',
        [Locale.En]: 'Reserve',
        [Locale.Pt]: 'Reserva',
        [Locale.Ge]: 'Reserve',
    },
    profile: {
        [Locale.Ru]: 'Профиль',
        [Locale.Am]: 'Պրոֆիլ',
        [Locale.En]: 'Profile',
        [Locale.Pt]: 'Arquivo',
        [Locale.Ge]: 'Profile',
    },
    scheduleModels: {
        [Locale.Ru]: 'Модели расписания',
        [Locale.Am]: 'Ժամանակացույցի մոդելներ',
        [Locale.En]: 'Schedule models',
        [Locale.Pt]: 'Modelos de cronograma',
        [Locale.Ge]: 'Schedule models',
    },
    scheduleV2: {
        [Locale.Ru]: 'Новое расписание',
        [Locale.Am]: 'Նոր ժամանակացույց',
        [Locale.En]: 'New schedule',
        [Locale.Pt]: 'Novo cronograma',
        [Locale.Ge]: 'New schedule',
    },
    clinics: {
        [Locale.Ru]: 'Клиники',
        [Locale.Am]: 'Կլինիկաներ',
        [Locale.En]: 'Clinics',
        [Locale.Pt]: 'Clínicas',
        [Locale.Ge]: 'Clinics',
    },
    toClinicList: {
        [Locale.Ru]: 'К списку клиник',
        [Locale.Am]: 'Կլինիկաների ցանկ',
        [Locale.En]: 'To clinic list',
        [Locale.Pt]: 'Para a lista de clínicas',
        [Locale.Ge]: 'To clinic list',
    },
    yourClinics: {
        [Locale.Ru]: 'Ваши клиники',
        [Locale.Am]: 'Ձեր կլինիկաները',
        [Locale.En]: 'Your clinics',
        [Locale.Pt]: 'Suas clínicas',
        [Locale.Ge]: 'Your clinics',
    },
    shiftFillNextMonth: {
        [Locale.Ru]: 'Заполненность смен на ближайший месяц',
        [Locale.Am]: 'Հերթափոխերի լրացվածությունը մոտակա ամսվա համար',
        [Locale.En]: 'Shift fill for the next month',
        [Locale.Pt]: 'Preenchimento de turnos no próximo mês',
        [Locale.Ge]: 'Shift fill for the next month',
    },
    shift: {
        [Locale.Ru]: 'Смена',
        [Locale.Am]: 'Հերթափոխ',
        [Locale.En]: 'Shift',
        [Locale.Pt]: 'Turno',
        [Locale.Ge]: 'Shift',
    },
    shifts: {
        [Locale.Ru]: 'Смены',
        [Locale.Am]: 'Հերթափոխեր',
        [Locale.En]: 'Shifts',
        [Locale.Pt]: 'Turnos',
        [Locale.Ge]: 'Shifts',
    },
    byNumbers: {
        [Locale.Ru]: 'По номерам',
        [Locale.Am]: 'Ըստ համարների',
        [Locale.En]: 'By numbers',
        [Locale.Pt]: 'Por números',
        [Locale.Ge]: 'By numbers',
    },
    byPractices: {
        [Locale.Ru]: 'По практикам',
        [Locale.Am]: 'Ըստ պրակտիկաների',
        [Locale.En]: 'By practices',
        [Locale.Pt]: 'Por práticas',
        [Locale.Ge]: 'By practices',
    },
    allPractices: {
        [Locale.Ru]: 'Все практики',
        [Locale.Am]: 'Բոլոր պրակտիկաները',
        [Locale.En]: 'All practices',
        [Locale.Pt]: 'Todas as práticas',
        [Locale.Ge]: 'All practices',
    },
    shiftInDifferentPractices: {
        [Locale.Ru]: 'Смена в разных практиках',
        [Locale.Am]: 'Հերթափոխ տարբեր պրակտիկաներում',
        [Locale.En]: 'Shift in different practices',
        [Locale.Pt]: 'Turno em práticas diferentes',
        [Locale.Ge]: 'Shift in different practices',
    },
    twoShiftsInRow: {
        [Locale.Ru]: 'Две смены подряд',
        [Locale.Am]: 'Երկու հերթափոխ անընդմեջ',
        [Locale.En]: 'Two shifts in a row',
        [Locale.Pt]: 'Dois turnos consecutivos',
        [Locale.Ge]: 'Two shifts in a row',
    },
    officesInShift: {
        [Locale.Ru]: 'Кабинеты в смене',
        [Locale.Am]: 'Կաբինետները հերթափոխում',
        [Locale.En]: 'Offices in the shift',
        [Locale.Pt]: 'Consultórios no turno',
        [Locale.Ge]: 'Offices in the shift',
    },
    additionalDoctor: {
        [Locale.Ru]: 'Дополнительный доктор',
        [Locale.Am]: 'Լրացուցիչ բժիշկ',
        [Locale.En]: 'Additional doctor',
        [Locale.Pt]: 'Médico adicional',
        [Locale.Ge]: 'Additional doctor',
    },
    noPractice: {
        [Locale.Ru]: 'Нет практики',
        [Locale.Am]: 'Պրակտիկա չկա',
        [Locale.En]: 'No practice',
        [Locale.Pt]: 'Sem prática',
        [Locale.Ge]: 'No practice',
    },
    noDoctor: {
        [Locale.Ru]: 'Нет доктора',
        [Locale.Am]: 'Բժիշկ չկա',
        [Locale.En]: 'No doctor',
        [Locale.Pt]: 'Sem médico',
        [Locale.Ge]: 'No doctor',
    },
    physicalOffices: {
        [Locale.Ru]: 'Физические кабинеты',
        [Locale.Am]: 'Ֆիզիկական կաբինետներ',
        [Locale.En]: 'Physical offices',
        [Locale.Pt]: 'Consultórios físicos',
        [Locale.Ge]: 'Physical offices',
    },
    responsible: {
        [Locale.Ru]: 'Ответственный',
        [Locale.Am]: 'Պատասխանատու',
        [Locale.En]: 'Responsible',
        [Locale.Pt]: 'Responsável',
        [Locale.Ge]: 'Responsible',
    },
    notAssigned: {
        [Locale.Ru]: 'Не назначен',
        [Locale.Am]: 'Նշանակված չէ',
        [Locale.En]: 'Not assigned',
        [Locale.Pt]: 'Não atribuído',
        [Locale.Ge]: 'Not assigned',
    },
    freeShiftsPerMonth: {
        [Locale.Ru]: 'Свободных смен на месяц',
        [Locale.Am]: 'Ազատ հերթափոխեր ամսվա համար',
        [Locale.En]: 'Free shifts per month',
        [Locale.Pt]: 'Turnos livres por mês',
        [Locale.Ge]: 'Free shifts per month',
    },
    devicesInOffice: {
        [Locale.Ru]: 'Приборы в кабинете',
        [Locale.Am]: 'Սարքեր կաբինետում',
        [Locale.En]: 'Devices in office',
        [Locale.Pt]: 'Dispositivos no consultório',
        [Locale.Ge]: 'Devices in office',
    },
    responsibleForOffice: {
        [Locale.Ru]: 'Ответственный за кабинет',
        [Locale.Am]: 'Կաբինետի պատասխանատու',
        [Locale.En]: 'Responsible for office',
        [Locale.Pt]: 'Responsável pelo consultório',
        [Locale.Ge]: 'Responsible for office',
    },
    practice: {
        [Locale.Ru]: 'Практика',
        [Locale.Am]: 'Պրակտիկա',
        [Locale.En]: 'Practice',
        [Locale.Pt]: 'Prática',
        [Locale.Ge]: 'Practice',
    },
    onlyOnlineReception: {
        [Locale.Ru]: 'Только онлайн-приём',
        [Locale.Am]: 'Միայն առցանց ընդունելություն',
        [Locale.En]: 'Online reception only',
        [Locale.Pt]: 'Apenas recepção online',
        [Locale.Ge]: 'Online reception only',
    },
    noSiteBooking: {
        [Locale.Ru]: 'Нет записи с сайта',
        [Locale.Am]: 'Կայքից գրանցում չկա',
        [Locale.En]: 'No booking from site',
        [Locale.Pt]: 'Sem agendamento pelo site',
        [Locale.Ge]: 'No booking from site',
    },
    hasAdditionalDoctors: {
        [Locale.Ru]: 'Есть дополнительные доктора',
        [Locale.Am]: 'Կան լրացուցիչ բժիշկներ',
        [Locale.En]: 'Has additional doctors',
        [Locale.Pt]: 'Há médicos adicionais',
        [Locale.Ge]: 'Has additional doctors',
    },
    documentation: {
        [Locale.Ru]: 'Документы',
        [Locale.Am]: 'Փաստաթղթեր',
        [Locale.En]: 'Documentation',
        [Locale.Pt]: 'Documentação',
        [Locale.Ge]: 'Documentation',
    },
    patientDocuments: {
        [Locale.Ru]: 'Документы',
        [Locale.Am]: 'Փաստաթղթեր',
        [Locale.En]: 'Documents',
        [Locale.Pt]: 'Documentos',
        [Locale.Ge]: 'დოკუმენტები',
    },
    vaccination: {
        [Locale.Ru]: 'Вакцинации',
        [Locale.Am]: 'Պատվաստումներ',
        [Locale.En]: 'Vaccination',
        [Locale.Pt]: 'Vacinação',
        [Locale.Ge]: 'Vaccination',
    },
    medicalEntries: {
        [Locale.Ru]: 'Медицинские записи',
        [Locale.Am]: 'Բժշկական գրառումներ',
        [Locale.En]: 'Medical records',
        [Locale.Pt]: 'Prontuários médicos',
        [Locale.Ge]: 'Medical records',
    },
    reservations: {
        [Locale.Ru]: 'Записи на прием',
        [Locale.Am]: 'Գրանցումներ ընդունելության',
        [Locale.En]: 'Bookings',
        [Locale.Pt]: 'Reservas',
        [Locale.Ge]: 'Bookings',
    },
    paymentUrls: {
        [Locale.Ru]: 'Ссылки на оплату',
        [Locale.Am]: 'Վճարման հղումներ',
        [Locale.En]: 'Billing links',
        [Locale.Pt]: 'Links de cobrança',
        [Locale.Ge]: 'Billing links',
    },
    attachments: {
        [Locale.Ru]: 'Прикрепления',
        [Locale.Am]: 'Կցումներ',
        [Locale.En]: 'Attachments',
        [Locale.Pt]: 'Anexos',
        [Locale.Ge]: 'Attachments',
    },
    generalInformation: {
        [Locale.Ru]: 'Общие сведения',
        [Locale.Am]: 'Ընդհանուր տեղեկություններ',
        [Locale.En]: 'General information',
        [Locale.Pt]: 'Informações gerais',
        [Locale.Ge]: 'General information',
    },
    offices: {
        [Locale.Ru]: 'Кабинеты',
        [Locale.Am]: 'Կաբինետներ',
        [Locale.En]: 'Offices',
        [Locale.Pt]: 'Escritórios',
        [Locale.Ge]: 'Offices',
    },
    device: {
        [Locale.Ru]: 'Прибор',
        [Locale.Am]: 'Սարք',
        [Locale.En]: 'Device',
        [Locale.Pt]: 'Dispositivo',
        [Locale.Ge]: 'Device',
    },
    devices: {
        [Locale.Ru]: 'Приборы',
        [Locale.Am]: 'Սարքեր',
        [Locale.En]: 'Devices',
        [Locale.Pt]: 'Dispositivos',
        [Locale.Ge]: 'Devices',
    },
    legalEntity: {
        [Locale.Ru]: 'Юридическое лицо',
        [Locale.Am]: 'Իրավաբանական անձ',
        [Locale.En]: 'Legal entity',
        [Locale.Pt]: 'Pessoa jurídica',
        [Locale.Ge]: 'იურიდიული პირი',
    },
    legalEntities: {
        [Locale.Ru]: 'Юридические лица',
        [Locale.Am]: 'Իրավաբանական անձինք',
        [Locale.En]: 'Legal entities',
        [Locale.Pt]: 'Pessoas jurídicas',
        [Locale.Ge]: 'იურიდიული პირი',
    },
    networks: {
        [Locale.Ru]: 'Сети',
        [Locale.Am]: 'Ցանցեր',
        [Locale.En]: 'Networks',
        [Locale.Pt]: 'Redes',
        [Locale.Ge]: 'Networks',
    },
    contracts: {
        [Locale.Ru]: 'Договоры',
        [Locale.Am]: 'Պայմանագրեր',
        [Locale.En]: 'Contracts',
        [Locale.Pt]: 'Contratos',
        [Locale.Ge]: 'Contracts',
    },
    contract: {
        [Locale.Ru]: 'Договор',
        [Locale.Am]: 'Պայմանագիր',
        [Locale.En]: 'Contract',
        [Locale.Pt]: 'ato',
        [Locale.Ge]: 'Contract',
    },
    configuration: {
        [Locale.Ru]: 'Конфигурирование',
        [Locale.Am]: 'Կարգավորում',
        [Locale.En]: 'Configuration',
        [Locale.Pt]: 'Configuração',
        [Locale.Ge]: 'Configuration',
    },
    gps: {
        [Locale.Ru]: 'Гарантийные письма',
        [Locale.Am]: 'Երաշխիքային նամակներ',
        [Locale.En]: 'Letters of guarantee',
        [Locale.Pt]: 'GPS',
        [Locale.Ge]: 'Letters of guarantee',
    },
    registry: {
        [Locale.Ru]: 'Реестр',
        [Locale.Am]: 'Ռեեստր',
        [Locale.En]: 'Registry',
        [Locale.Pt]: 'Registro',
        [Locale.Ge]: 'რეესტრი',
    },
    myActive: {
        [Locale.Ru]: 'Мои активные',
        [Locale.Am]: 'Իմ ակտիվները',
        [Locale.En]: 'My active',
        [Locale.Pt]: 'Meu ativo',
        [Locale.Ge]: 'My active',
    },
    myExpired: {
        [Locale.Ru]: 'Мои истекшие',
        [Locale.Am]: 'Իմ ժամկետանցները',
        [Locale.En]: 'My expired',
        [Locale.Pt]: 'Meu expirou',
        [Locale.Ge]: 'My expired',
    },
    laboratories: {
        [Locale.Ru]: 'Лаборатории',
        [Locale.Am]: 'Լաբորատորիաներ',
        [Locale.En]: 'Laboratories',
        [Locale.Pt]: 'Laboratórios',
        [Locale.Ge]: 'Laboratories',
    },
    laboratoryServices: {
        [Locale.Ru]: 'Лабораторные услуги',
        [Locale.Am]: 'Լաբորատոր ծառայություններ',
        [Locale.En]: 'Laboratory services',
        [Locale.Pt]: 'Serviços de laboratório',
        [Locale.Ge]: 'Laboratory services',
    },
    laboratoryReferencesTables: {
        [Locale.Ru]: 'Таблицы лабораторных референсов',
        [Locale.Am]: 'Լաբորատոր ռեֆերենսների աղյուսակներ',
        [Locale.En]: 'Laboratory references tables',
        [Locale.Pt]: 'Tabelas de referências laboratoriais',
        [Locale.Ge]: 'Laboratory references tables',
    },
    laboratoryReferences: {
        [Locale.Ru]: 'Лабораторные референсы',
        [Locale.Am]: 'Լաբորատոր ռեֆերենսներ',
        [Locale.En]: 'Laboratory references',
        [Locale.Pt]: 'Referências laboratoriais',
        [Locale.Ge]: 'Laboratory references',
    },
    addLaboratoryService: {
        [Locale.Ru]: 'Добавить лабораторную услугу',
        [Locale.Am]: 'Ավելացնել լաբորատոր ծառայություն',
        [Locale.En]: 'Add laboratory service',
        [Locale.Pt]: 'Adicionar serviço de laboratório',
        [Locale.Ge]: 'Add laboratory service',
    },
    protest: {
        [Locale.Ru]: 'Опротестования',
        [Locale.Am]: 'Բողոքարկումներ',
        [Locale.En]: 'Protest',
        [Locale.Pt]: 'Protesto',
        [Locale.Ge]: 'Protest',
    },
    equipments: {
        [Locale.Ru]: 'Устройства',
        [Locale.Am]: 'Սարքավորումներ',
        [Locale.En]: 'Equipments',
        [Locale.Pt]: 'Equipamentos',
        [Locale.Ge]: 'Equipments',
    },
    equipment: {
        [Locale.Ru]: 'Устройство',
        [Locale.Am]: 'Սարքավորում',
        [Locale.En]: 'Equipment',
        [Locale.Pt]: 'Equipamento',
        [Locale.Ge]: 'Equipment',
    },
    paymentIntegrations: {
        [Locale.Ru]: 'Платежные интеграции',
        [Locale.Am]: 'Վճարային ինտեգրացիաներ',
        [Locale.En]: 'Payment integrations',
        [Locale.Pt]: 'Integrações de pagamento',
        [Locale.Ge]: 'Payment integrations',
    },
    checkIntegrations: {
        [Locale.Ru]: 'Чековые интеграции',
        [Locale.Am]: 'Կտրոնային ինտեգրացիաներ',
        [Locale.En]: 'Check integrations',
        [Locale.Pt]: 'Verifique integrações',
        [Locale.Ge]: 'Check integrations',
    },
    executor: {
        [Locale.Ru]: 'Исполнитель',
        [Locale.Am]: 'Կատարող',
        [Locale.En]: 'Executor',
        [Locale.Pt]: 'Executor',
        [Locale.Ge]: 'შემსრულებელი',
    },
    executors: {
        [Locale.Ru]: 'Исполнители',
        [Locale.Am]: 'Կատարողներ',
        [Locale.En]: 'Executors',
        [Locale.Pt]: 'Executores',
        [Locale.Ge]: 'შემსრულებელი',
    },
    addExecutors: {
        [Locale.Ru]: 'Добавить исполнителей',
        [Locale.Am]: 'Ավելացնել կատարողներ',
        [Locale.En]: 'Add executors',
        [Locale.Pt]: 'Adicionar executores',
        [Locale.Ge]: 'შემსრულებლების დამატება',
    },
    removeExecutors: {
        [Locale.Ru]: 'Убрать исполнителей',
        [Locale.Am]: 'Հեռացնել կատարողներին',
        [Locale.En]: 'Remove executors',
        [Locale.Pt]: 'Remover executores',
        [Locale.Ge]: 'Remove executors',
    },
    external: {
        [Locale.Ru]: 'Внешнее',
        [Locale.Am]: 'Արտաքին',
        [Locale.En]: 'External',
        [Locale.Pt]: 'Externo',
        [Locale.Ge]: 'გარე',
    },
    givenAway: {
        [Locale.Ru]: 'Отдано',
        [Locale.Am]: 'Հանձնված է',
        [Locale.En]: 'Given away',
        [Locale.Pt]: 'Doado',
        [Locale.Ge]: 'Given away',
    },
    sent: {
        [Locale.Ru]: 'Отправлено',
        [Locale.Am]: 'Ուղարկված է',
        [Locale.En]: 'Sent',
        [Locale.Pt]: 'Enviado',
        [Locale.Ge]: 'Sent',
    },
    writeOff: {
        [Locale.Ru]: 'Списать',
        [Locale.Am]: 'Դուրս գրել',
        [Locale.En]: 'Write off',
        [Locale.Pt]: 'Eliminar',
        [Locale.Ge]: 'Write off',
    },
    canceledFem: {
        [Locale.Ru]: 'Отменена',
        [Locale.Am]: 'Չեղարկված է',
        [Locale.En]: 'Canceled',
        [Locale.Pt]: 'Cancelado',
        [Locale.Ge]: 'Canceled',
    },
    canceledMale: {
        [Locale.Ru]: 'Отменен',
        [Locale.Am]: 'Չեղարկված է',
        [Locale.En]: 'Canceled',
        [Locale.Pt]: 'Cancelado',
        [Locale.Ge]: 'Canceled',
    },
    changedFem: {
        [Locale.Ru]: 'Изменена',
        [Locale.Am]: 'Փոփոխված է',
        [Locale.En]: 'Changed',
        [Locale.Pt]: 'Mudado',
        [Locale.Ge]: 'Changed',
    },
    createdFem: {
        [Locale.Ru]: 'Создана',
        [Locale.Am]: 'Ստեղծված է',
        [Locale.En]: 'Created',
        [Locale.Pt]: 'Criado',
        [Locale.Ge]: 'Created',
    },
    createdNet: {
        [Locale.Ru]: 'Создано',
        [Locale.Am]: 'Ստեղծված է',
        [Locale.En]: 'Created',
        [Locale.Pt]: 'Criado',
        [Locale.Ge]: 'Created',
    },
    count: {
        [Locale.Ru]: 'Количество',
        [Locale.Am]: 'Քանակ',
        [Locale.En]: 'Count',
        [Locale.Pt]: 'Quantidade',
        [Locale.Ge]: 'Count',
    },
    validUntil: {
        [Locale.Ru]: 'Действительно до',
        [Locale.Am]: 'Վավեր է մինչև',
        [Locale.En]: 'Valid until',
        [Locale.Pt]: 'Válido até',
        [Locale.Ge]: 'Valid until',
    },
    deletedFem: {
        [Locale.Ru]: 'Удалена',
        [Locale.Am]: 'Ջնջված է',
        [Locale.En]: 'Deleted',
        [Locale.Pt]: 'Excluído',
        [Locale.Ge]: 'წაშლილი',
    },
    toRefund: {
        [Locale.Ru]: 'К возврату',
        [Locale.Am]: 'Վերադարձման ենթակա',
        [Locale.En]: 'To return',
        [Locale.Pt]: 'Para voltar',
        [Locale.Ge]: 'To return',
    },
    refundMethod: {
        [Locale.Ru]: 'Способ возврата',
        [Locale.Am]: 'Վերադարձի եղանակ',
        [Locale.En]: 'Refund method',
        [Locale.Pt]: 'Método de reembolso',
        [Locale.Ge]: 'Refund method',
    },
    system: {
        [Locale.Ru]: 'Система',
        [Locale.Am]: 'Համակարգ',
        [Locale.En]: 'System',
        [Locale.Pt]: 'Sistema',
        [Locale.Ge]: 'System',
    },
    telegram: {
        [Locale.Ru]: 'Телеграм',
        [Locale.Am]: 'Թելեգրամ',
        [Locale.En]: 'Telegram',
        [Locale.Pt]: 'Telegrama',
        [Locale.Ge]: 'Telegram',
    },
    telegramName: {
        [Locale.Ru]: 'Имя в телеграм',
        [Locale.Am]: 'Անունը Թելեգրամում',
        [Locale.En]: 'Telegram name',
        [Locale.Pt]: 'Nome do telegrama',
        [Locale.Ge]: 'Telegram name',
    },
    contractor: {
        [Locale.Ru]: 'Подрядчик',
        [Locale.Am]: 'Կապալառու',
        [Locale.En]: 'Contractor',
        [Locale.Pt]: 'Contratante',
        [Locale.Ge]: 'Contractor',
    },
    prices: {
        [Locale.Ru]: 'Цены',
        [Locale.Am]: 'Գներ',
        [Locale.En]: 'Prices',
        [Locale.Pt]: 'Preços',
        [Locale.Ge]: 'ფასები',
    },
    price: {
        [Locale.Ru]: 'Цена',
        [Locale.Am]: 'Գին',
        [Locale.En]: 'Price',
        [Locale.Pt]: 'Preço',
        [Locale.Ge]: 'ფასები',
    },
    compositeService: {
        [Locale.Ru]: 'Составная услуга',
        [Locale.Am]: 'Բաղադրյալ ծառայություն',
        [Locale.En]: 'Composite service',
        [Locale.Pt]: 'Serviço composto',
        [Locale.Ge]: 'Composite service',
    },
    roles: {
        [Locale.Ru]: 'Роли',
        [Locale.Am]: 'Դերեր',
        [Locale.En]: 'Roles',
        [Locale.Pt]: 'Funções',
        [Locale.Ge]: 'Roles',
    },
    password: {
        [Locale.Ru]: 'Пароль',
        [Locale.Am]: 'Գաղտնաբառ',
        [Locale.En]: 'Password',
        [Locale.Pt]: 'Senha',
        [Locale.Ge]: 'Password',
    },
    old: {
        [Locale.Ru]: 'Старые',
        [Locale.Am]: 'Հին',
        [Locale.En]: 'Old',
        [Locale.Pt]: 'Antigo',
        [Locale.Ge]: 'Old',
    },
    news: {
        [Locale.Ru]: 'Новые',
        [Locale.Am]: 'Նոր',
        [Locale.En]: 'New',
        [Locale.Pt]: 'WS',
        [Locale.Ge]: 'New',
    },
    manager: {
        [Locale.Ru]: 'Менеджер',
        [Locale.Am]: 'Մենեջեր',
        [Locale.En]: 'Manager',
        [Locale.Pt]: 'Gerente',
        [Locale.Ge]: 'Manager',
    },
    startFrom: {
        [Locale.Ru]: 'Начиная с',
        [Locale.Am]: 'Սկսած',
        [Locale.En]: 'Start from',
        [Locale.Pt]: 'Começar de',
        [Locale.Ge]: 'Start from',
    },
    ending: {
        [Locale.Ru]: 'Заканчивая',
        [Locale.Am]: 'Ավարտելով',
        [Locale.En]: 'Ending',
        [Locale.Pt]: 'Final',
        [Locale.Ge]: 'Ending',
    },
    openingDate: {
        [Locale.Ru]: 'Дата открытия',
        [Locale.Am]: 'Բացման ամսաթիվ',
        [Locale.En]: 'Opening date',
        [Locale.Pt]: 'Data de abertura',
        [Locale.Ge]: 'Opening date',
    },
    maleShort: {
        [Locale.Ru]: 'М',
        [Locale.Am]: 'Ա',
        [Locale.En]: 'M',
        [Locale.Pt]: 'M',
        [Locale.Ge]: 'M',
    },
    femaleShort: {
        [Locale.Ru]: 'Ж',
        [Locale.Am]: 'Ի',
        [Locale.En]: 'F',
        [Locale.Pt]: 'F',
        [Locale.Ge]: 'F',
    },
    ddmmyyyy: {
        [Locale.Am]: 'ՕՕ.ԱԱ.ՏՏՏՏ',
        [Locale.Ru]: 'ДД.ММ.ГГГГ',
        [Locale.En]: 'DD.MM.YYYY',
        [Locale.Pt]: 'DD.MM.AAAA',
        [Locale.Ge]: 'DD.MM.YYYY',
    },
    on: {
        [Locale.Ru]: 'на',
        [Locale.Am]: 'ին',
        [Locale.En]: 'on',
        [Locale.Pt]: 'Ligado',
        [Locale.Ge]: 'on',
    },
    turnOn: {
        [Locale.Ru]: 'Включить',
        [Locale.Am]: 'Միացնել',
        [Locale.En]: 'Turn on',
        [Locale.Pt]: 'Ligar',
        [Locale.Ge]: 'Turn on',
    },
    startOfCareer: {
        [Locale.Ru]: 'Начало карьеры',
        [Locale.Am]: 'Կարիերայի սկիզբ',
        [Locale.En]: 'Start of career',
        [Locale.Pt]: 'Início de carreira',
        [Locale.Ge]: 'Start of career',
    },
    languages: {
        [Locale.Ru]: 'Владение языками',
        [Locale.Am]: 'Լեզուների իմացություն',
        [Locale.En]: 'languages',
        [Locale.Pt]: 'idiomas',
        [Locale.Ge]: 'languages',
    },
    generalInfo: {
        [Locale.Ru]: 'Общая информация',
        [Locale.Am]: 'Ընդհանուր տեղեկություն',
        [Locale.En]: 'General information',
        [Locale.Pt]: 'Informações gerais',
        [Locale.Ge]: 'General information',
    },
    siteProfile: {
        [Locale.Ru]: 'Профиль на сайте',
        [Locale.Am]: 'Պրոֆիլը կայքում',
        [Locale.En]: 'Profile on the site',
        [Locale.Pt]: 'Perfil no site',
        [Locale.Ge]: 'Profile on the site',
    },
    fullNameOnSite: {
        [Locale.Ru]: 'ФИО (как отображается на сайте)',
        [Locale.Am]: 'Անուն, ազգանուն, հայրանուն (ինչպես ցուցադրվում է կայքում)',
        [Locale.En]: 'Full name (as displayed on the site)',
        [Locale.Pt]: 'Nome completo (como exibido no site)',
        [Locale.Ge]: 'Full name (as displayed on the site)',
    },
    fullNameInDocuments: {
        [Locale.Ru]: 'ФИО (как в документах)',
        [Locale.Am]: 'Անուն, ազգանուն, հայրանուն (ինչպես փաստաթղթերում)',
        [Locale.En]: 'Full name (as in documents)',
        [Locale.Pt]: 'Nome completo (como nos documentos)',
        [Locale.Ge]: 'Full name (as in documents)',
    },
    addNumber: {
        [Locale.Ru]: 'Добавить номер',
        [Locale.Am]: 'Ավելացնել համար',
        [Locale.En]: 'Add number',
        [Locale.Pt]: 'Adicionar número',
        [Locale.Ge]: 'Add number',
    },
    wasLastNameChanged: {
        [Locale.Ru]: 'Была смена фамилии',
        [Locale.Am]: 'Եղել է ազգանվան փոփոխություն',
        [Locale.En]: 'Last name was changed',
        [Locale.Pt]: 'Houve mudança de sobrenome',
        [Locale.Ge]: 'Last name was changed',
    },
    employeeOwnPatientCards: {
        [Locale.Ru]: 'Медкарты сотрудника как пациента',
        [Locale.Am]: 'Աշխատակցի բժշկական քարտերը որպես պացիենտի',
        [Locale.En]: 'Employee patient records',
        [Locale.Pt]: 'Prontuários do funcionário como paciente',
        [Locale.Ge]: 'Employee patient records',
    },
    rightsAndAccess: {
        [Locale.Ru]: 'Права и доступы',
        [Locale.Am]: 'Իրավունքներ և հասանելիություն',
        [Locale.En]: 'Rights and access',
        [Locale.Pt]: 'Direitos e acessos',
        [Locale.Ge]: 'Rights and access',
    },
    forAccountingTitle: {
        [Locale.Ru]: 'Для бухгалтерии',
        [Locale.Am]: 'Հաշվապահության համար',
        [Locale.En]: 'For accounting',
        [Locale.Pt]: 'Para contabilidade',
        [Locale.Ge]: 'For accounting',
    },
    degrees: {
        [Locale.Ru]: 'Звания, степени',
        [Locale.Am]: 'Կոչումներ, աստիճաններ',
        [Locale.En]: 'Degrees',
        [Locale.Pt]: 'Graus',
        [Locale.Ge]: 'Degrees',
    },
    introductory: {
        [Locale.Ru]: 'Вводная',
        [Locale.Am]: 'Ներածական',
        [Locale.En]: 'Introductory',
        [Locale.Pt]: 'Introdutório',
        [Locale.Ge]: 'Introductory',
    },
    education: {
        [Locale.Ru]: 'Образование',
        [Locale.Am]: 'Կրթություն',
        [Locale.En]: 'Education',
        [Locale.Pt]: 'Educação',
        [Locale.Ge]: 'Education',
    },
    experience: {
        [Locale.Ru]: 'Опыт работы',
        [Locale.Am]: 'Աշխատանքային փորձ',
        [Locale.En]: 'Experience',
        [Locale.Pt]: 'Experiência',
        [Locale.Ge]: 'Experience',
    },
    inEnglish: {
        [Locale.Ru]: 'На английском',
        [Locale.Am]: 'Անգլերեն',
        [Locale.En]: 'In english',
        [Locale.Pt]: 'Em inglês',
        [Locale.Ge]: 'In english',
    },
    inArmenian: {
        [Locale.Ru]: 'На армянском',
        [Locale.Am]: 'Հայերեն',
        [Locale.En]: 'In armenian',
        [Locale.Pt]: 'Em armênio',
        [Locale.Ge]: 'In armenian',
    },
    inRussian: {
        [Locale.Ru]: 'На русском',
        [Locale.Am]: 'Ռուսերեն',
        [Locale.En]: 'In Russian',
        [Locale.Pt]: 'Em russo',
        [Locale.Ge]: 'In Russian',
    },
    inGeorgian: {
        [Locale.Ru]: 'На грузинском',
        [Locale.Am]: 'Վրացերեն',
        [Locale.En]: 'In georgian',
        [Locale.Pt]: 'Em georgiano',
        [Locale.Ge]: 'In georgian',
    },
    forAccounting: {
        [Locale.Ru]: 'для бухгалтерии',
        [Locale.Am]: 'հաշվապահության համար',
        [Locale.En]: 'for accounting',
        [Locale.Pt]: 'para contabilidade',
        [Locale.Ge]: 'for accounting',
    },
    inStatus: {
        [Locale.Ru]: 'В статусе',
        [Locale.Am]: 'Կարգավիճակում',
        [Locale.En]: 'In status',
        [Locale.Pt]: 'Em estado',
        [Locale.Ge]: 'In status',
    },
    deletePermanently: {
        [Locale.Ru]: 'Удалить безвозвратно',
        [Locale.Am]: 'Ջնջել անվերադարձ',
        [Locale.En]: 'Delete permanently',
        [Locale.Pt]: 'Excluir permanentemente',
        [Locale.Ge]: 'Delete permanently',
    },
    inDoor: {
        [Locale.Ru]: 'Внутри клиники',
        [Locale.Am]: 'Կլինիկայի ներսում',
        [Locale.En]: 'In door',
        [Locale.Pt]: 'Na porta',
        [Locale.Ge]: 'In door',
    },
    entryTypeLabel: {
        [Locale.Ru]: 'Тип записи',
        [Locale.Am]: 'Գրառման տեսակ',
        [Locale.En]: 'Record type',
        [Locale.Pt]: 'Tipo de registro',
        [Locale.Ge]: 'ჩანაწერის ტიპი',
    },
    myEntries: {
        [Locale.Ru]: 'Мои записи',
        [Locale.Am]: 'Իմ գրառումները',
        [Locale.En]: 'My entryies',
        [Locale.Pt]: 'Minhas entradas',
        [Locale.Ge]: 'My entries',
    },
    byDate: {
        [Locale.Ru]: 'По дате',
        [Locale.Am]: 'Ըստ ամսաթվի',
        [Locale.En]: 'By date',
        [Locale.Pt]: 'Por data',
        [Locale.Ge]: 'By date',
    },
    az: {
        [Locale.Ru]: 'А — Я',
        [Locale.Am]: 'Ա — Ֆ',
        [Locale.En]: 'A - Z',
        [Locale.Pt]: 'A-Z',
        [Locale.Ge]: 'A - Z',
    },
    byAuthor: {
        [Locale.Ru]: 'По автору',
        [Locale.Am]: 'Ըստ հեղինակի',
        [Locale.En]: 'By author',
        [Locale.Pt]: 'Por autor',
        [Locale.Ge]: 'By author',
    },
    byUrgent: {
        [Locale.Ru]: 'По срочности',
        [Locale.Am]: 'Ըստ հրատապության',
        [Locale.En]: 'By urgent',
        [Locale.Pt]: 'Por urgente',
        [Locale.Ge]: 'By urgent',
    },
    startDateAction: {
        [Locale.Ru]: 'Дата начала действия',
        [Locale.Am]: 'Գործողության սկզբի ամսաթիվ',
        [Locale.En]: 'Start date',
        [Locale.Pt]: 'Data de início',
        [Locale.Ge]: 'Start date',
    },
    endDateAction: {
        [Locale.Ru]: 'Дата окончания действия',
        [Locale.Am]: 'Գործողության ավարտի ամսաթիվ',
        [Locale.En]: 'End date',
        [Locale.Pt]: 'Data de término',
        [Locale.Ge]: 'End date',
    },
    recipient: {
        [Locale.Ru]: 'Получатель',
        [Locale.Am]: 'Ստացող',
        [Locale.En]: 'Recipient',
        [Locale.Pt]: 'Destinatário',
        [Locale.Ge]: 'Recipient',
    },
    eventType: {
        [Locale.Ru]: 'Тип события',
        [Locale.Am]: 'Իրադարձության տեսակ',
        [Locale.En]: 'Event type',
        [Locale.Pt]: 'Tipo de evento',
        [Locale.Ge]: 'Event type',
    },
    message: {
        [Locale.Ru]: 'Сообщение',
        [Locale.Am]: 'Հաղորդագրություն',
        [Locale.En]: 'Message',
        [Locale.Pt]: 'Mensagem',
        [Locale.Ge]: 'შეტყობინება',
    },
    executedUnsuccessfully: {
        [Locale.Ru]: 'Выполнено неуспешно',
        [Locale.Am]: 'Կատարվել է անհաջող',
        [Locale.En]: 'Executed unsuccessfully',
        [Locale.Pt]: 'Executado sem sucesso',
        [Locale.Ge]: 'Executed unsuccessfully',
    },
    introductionDate: {
        [Locale.Ru]: 'Дата введения',
        [Locale.Am]: 'Ներարկման ամսաթիվ',
        [Locale.En]: 'Date of introduction',
        [Locale.Pt]: 'Data de introdução',
        [Locale.Ge]: 'Date of introduction',
    },
    disease: {
        [Locale.Ru]: 'Заболевание',
        [Locale.Am]: 'Հիվանդություն',
        [Locale.En]: 'Disease',
        [Locale.Pt]: 'Doença',
        [Locale.Ge]: 'Disease',
    },
    dose: {
        [Locale.Ru]: 'Доза',
        [Locale.Am]: 'Դեղաչափ',
        [Locale.En]: 'Dose',
        [Locale.Pt]: 'Dose',
        [Locale.Ge]: 'Dose',
    },
    seriesTitle: {
        [Locale.Ru]: 'Серия',
        [Locale.Am]: 'Սերիա',
        [Locale.En]: 'Series',
        [Locale.Pt]: 'Série',
        [Locale.Ge]: 'Series',
    },
    expirationDate: {
        [Locale.Ru]: 'Срок годности',
        [Locale.Am]: 'Պիտանիության ժամկետ',
        [Locale.En]: 'Expiration date',
        [Locale.Pt]: 'Data de validade',
        [Locale.Ge]: 'Expiration date',
    },
    stage: {
        [Locale.Ru]: 'Этап',
        [Locale.Am]: 'Փուլ',
        [Locale.En]: 'Stage',
        [Locale.Pt]: 'Etapa',
        [Locale.Ge]: 'Stage',
    },
    injectionSite: {
        [Locale.Ru]: 'Место введения',
        [Locale.Am]: 'Ներարկման վայր',
        [Locale.En]: 'Injection site',
        [Locale.Pt]: 'Local de injeção',
        [Locale.Ge]: 'Injection site',
    },
    method: {
        [Locale.Ru]: 'Метод',
        [Locale.Am]: 'Մեթոդ',
        [Locale.En]: 'Method',
        [Locale.Pt]: 'Método',
        [Locale.Ge]: 'Method',
    },
    reaction: {
        [Locale.Ru]: 'Реакция',
        [Locale.Am]: 'Ռեակցիա',
        [Locale.En]: 'Reaction',
        [Locale.Pt]: 'Reação',
        [Locale.Ge]: 'Reaction',
    },
    only: {
        [Locale.Ru]: 'Только',
        [Locale.Am]: 'Միայն',
        [Locale.En]: 'Only',
        [Locale.Pt]: 'Apenas',
        [Locale.Ge]: 'Only',
    },
    dayShort: {
        [Locale.Ru]: 'д.',
        [Locale.Am]: 'օր',
        [Locale.En]: 'd.',
        [Locale.Pt]: 'd.',
        [Locale.Ge]: 'd.',
    },
    hoursShort: {
        [Locale.Ru]: 'ч.',
        [Locale.Am]: 'ժ.',
        [Locale.En]: 'd.',
        [Locale.Pt]: 'd.',
        [Locale.Ge]: 'd.',
    },
    male: {
        [Locale.Ru]: 'Мужской',
        [Locale.Am]: 'Արական',
        [Locale.En]: 'Male',
        [Locale.Pt]: 'Masculino',
        [Locale.Ge]: 'Male',
    },
    female: {
        [Locale.Ru]: 'Женский',
        [Locale.Am]: 'Իգական',
        [Locale.En]: 'Female',
        [Locale.Pt]: 'Feminino',
        [Locale.Ge]: 'Female',
    },
    atFirst: {
        [Locale.Ru]: 'Сначала',
        [Locale.Am]: 'Սկզբում',
        [Locale.En]: 'At first',
        [Locale.Pt]: 'Inicialmente',
        [Locale.Ge]: 'At first',
    },
    byProgram: {
        [Locale.Ru]: `По программе`,
        [Locale.Am]: `Ըստ ծրագրի`,
        [Locale.En]: `By program`,
        [Locale.Pt]: 'Por programa',
        [Locale.Ge]: `By program`,
    },
    validity: {
        [Locale.Ru]: `Период действия`,
        [Locale.Am]: `Գործողության ժամկետ`,
        [Locale.En]: `Validity`,
        [Locale.Pt]: 'Validade',
        [Locale.Ge]: `Validity`,
    },
    scheduleModel: {
        [Locale.Ru]: `Модель расписания`,
        [Locale.Am]: `Ժամանակացույցի մոդել`,
        [Locale.En]: `Schedule model`,
        [Locale.Pt]: 'Modelo de cronograma',
        [Locale.Ge]: `Schedule model`,
    },
    daysOfWeek: {
        [Locale.Ru]: `Дни недели`,
        [Locale.Am]: `Շաբաթվա օրեր`,
        [Locale.En]: `Days of the week`,
        [Locale.Pt]: 'Dias da semana',
        [Locale.Ge]: `Days of the week`,
    },
    byLocalTime: {
        [Locale.Ru]: `По местному времени`,
        [Locale.Am]: `Տեղական ժամանակով`,
        [Locale.En]: `By local time`,
        [Locale.Pt]: 'Por hora local',
        [Locale.Ge]: `By local time`,
    },
    morning: {
        [Locale.Ru]: `Утренняя`,
        [Locale.Am]: `Առավոտյան`,
        [Locale.En]: `Morning`,
        [Locale.Pt]: 'Manhã',
        [Locale.Ge]: `Morning`,
    },
    evening: {
        [Locale.Ru]: `Вечерняя`,
        [Locale.Am]: `Երեկոյան`,
        [Locale.En]: `Evening`,
        [Locale.Pt]: 'Noite',
        [Locale.Ge]: `Evening`,
    },
    fullDay: {
        [Locale.Ru]: `Весь день`,
        [Locale.Am]: `Ամբողջ օրը`,
        [Locale.En]: `Full day`,
        [Locale.Pt]: 'Dia inteiro',
        [Locale.Ge]: `Full day`,
    },
    night: {
        [Locale.Ru]: `Ночная`,
        [Locale.Am]: `Գիշերային`,
        [Locale.En]: `Night`,
        [Locale.Pt]: 'Noite',
        [Locale.Ge]: `Night`,
    },
    setTimeYourself: {
        [Locale.Ru]: `Указать время самостоятельно`,
        [Locale.Am]: `Ժամը նշել ինքնուրույն`,
        [Locale.En]: `Set the time yourself`,
        [Locale.Pt]: 'Defina você mesmo o horário',
        [Locale.Ge]: `Set the time yourself`,
    },
    confirm: {
        [Locale.Ru]: `Подтвердить`,
        [Locale.Am]: `Հաստատել`,
        [Locale.En]: `Confirm`,
        [Locale.Pt]: `Confirmar`,
        [Locale.Ge]: `Confirm`,
    },
    confirmed: {
        [Locale.Ru]: `Подтвержден`,
        [Locale.Am]: `Հաստատված է`,
        [Locale.En]: `Confirmed`,
        [Locale.Pt]: 'Confirmado',
        [Locale.Ge]: `Confirmed`,
    },
    confirmedNeutral: {
        [Locale.Ru]: `Подтверждено`,
        [Locale.Am]: `Հաստատված է`,
        [Locale.En]: `Confirmed`,
        [Locale.Pt]: 'Confirmado',
        [Locale.Ge]: `Confirmed`,
    },
    write: {
        [Locale.Ru]: `Написать`,
        [Locale.Am]: `Գրել`,
        [Locale.En]: `Write`,
        [Locale.Pt]: 'Escrever',
        [Locale.Ge]: `Write`,
    },
    contacts: {
        [Locale.Ru]: `Контакты`,
        [Locale.Am]: `Կոնտակտներ`,
        [Locale.En]: `Contacts`,
        [Locale.Pt]: 'Contatos',
        [Locale.Ge]: `Contacts`,
    },
    coverage: {
        [Locale.Ru]: `Процент покрытия`,
        [Locale.Am]: `Ծածկույթի տոկոս`,
        [Locale.En]: `Coverage`,
        [Locale.Pt]: 'Idade',
        [Locale.Ge]: `Coverage`,
    },
    createNewFem: {
        [Locale.Ru]: `Создать новую`,
        [Locale.Am]: `Ստեղծել նորը`,
        [Locale.En]: `Create new`,
        [Locale.Pt]: `Criar novo`,
        [Locale.Ge]: `Create new`,
    },
    conditions: {
        [Locale.Ru]: `Условия`,
        [Locale.Am]: `Պայմաններ`,
        [Locale.En]: `Conditions`,
        [Locale.Pt]: 'Condições',
        [Locale.Ge]: `Conditions`,
    },
    addProgram: {
        [Locale.Ru]: `Добавить программу`,
        [Locale.Am]: `Ավելացնել ծրագիր`,
        [Locale.En]: `Add program`,
        [Locale.Pt]: 'Adicionar programa',
        [Locale.Ge]: `Add program`,
    },
    createProgram: {
        [Locale.Ru]: `Создать программу`,
        [Locale.Am]: `Ստեղծել ծրագիր`,
        [Locale.En]: `Create program`,
        [Locale.Pt]: 'Criar programa',
        [Locale.Ge]: `Create program`,
    },
    addData: {
        [Locale.Ru]: `Добавить данные`,
        [Locale.Am]: `Ավելացնել տվյալներ`,
        [Locale.En]: `Add data`,
        [Locale.Pt]: 'Adicionar dados',
        [Locale.Ge]: `Add data`,
    },
    answer: {
        [Locale.Ru]: `Ответить`,
        [Locale.Am]: `Պատասխանել`,
        [Locale.En]: `Answer`,
        [Locale.Pt]: 'Responder',
        [Locale.Ge]: `Answer`,
    },
    owner: {
        [Locale.Ru]: `Владелец`,
        [Locale.Am]: `Սեփականատեր`,
        [Locale.En]: `Owner`,
        [Locale.Pt]: 'Proprietário',
        [Locale.Ge]: `Owner`,
    },
    valid: {
        [Locale.Ru]: `Действителен`,
        [Locale.Am]: `Վավեր է`,
        [Locale.En]: `Valid`,
        [Locale.Pt]: 'Válido',
        [Locale.Ge]: `Valid`,
    },
    searchingResults: {
        [Locale.Ru]: `Результаты поиска`,
        [Locale.Am]: `Որոնման արդյունքներ`,
        [Locale.En]: `Searching results`,
        [Locale.Pt]: 'Pesquisando resultados',
        [Locale.Ge]: `Searching results`,
    },
    toPatients: {
        [Locale.Ru]: `К пациентам`,
        [Locale.Am]: `Դեպի պացիենտներ`,
        [Locale.En]: `To patients`,
        [Locale.Pt]: 'Para pacientes',
        [Locale.Ge]: `To patients`,
    },
    toPatient: {
        [Locale.Ru]: `К пациенту`,
        [Locale.Am]: `Դեպի պացիենտ`,
        [Locale.En]: `To patient`,
        [Locale.Pt]: 'Para o paciente',
        [Locale.Ge]: `To patient`,
    },
    saveInFile: {
        [Locale.Ru]: `Сохранить в файл`,
        [Locale.Am]: `Պահպանել ֆայլում`,
        [Locale.En]: `Save in file`,
        [Locale.Pt]: 'Salvar em arquivo',
        [Locale.Ge]: `Save in file`,
    },
    minuteShort: {
        [Locale.Ru]: `мин.`,
        [Locale.Am]: `ր.`,
        [Locale.En]: `min.`,
        [Locale.Pt]: 'min.',
        [Locale.Ge]: `min.`,
    },
    minuteShortWithoutDot: {
        [Locale.Ru]: `мин`,
        [Locale.Am]: `ր`,
        [Locale.En]: `min`,
        [Locale.Pt]: 'min',
        [Locale.Ge]: `min`,
    },
    secondShort: {
        [Locale.Ru]: `сек.`,
        [Locale.Am]: `վրկ.`,
        [Locale.En]: `sec.`,
        [Locale.Pt]: 'seg.',
        [Locale.Ge]: `sec.`,
    },
    prepared: {
        [Locale.Ru]: `Подготовлен`,
        [Locale.Am]: `Պատրաստված է`,
        [Locale.En]: `Prepared`,
        [Locale.Pt]: 'Preparado',
        [Locale.Ge]: `Prepared`,
    },
    criticalError: {
        [Locale.Ru]: `Критическая ошибка`,
        [Locale.Am]: `Կրիտիկական սխալ`,
        [Locale.En]: `Critical error`,
        [Locale.Pt]: 'Erro crítico',
        [Locale.Ge]: `Critical error`,
    },
    operationFail: {
        [Locale.Ru]: `Операция не удалась`,
        [Locale.Am]: `Գործողությունը չհաջողվեց`,
        [Locale.En]: `The operation failed`,
        [Locale.Pt]: 'A operação falhou',
        [Locale.Ge]: `The operation failed`,
    },
    block: {
        [Locale.Ru]: `Заблокировать`,
        [Locale.Am]: `Արգելափակել`,
        [Locale.En]: `Block`,
        [Locale.Pt]: 'Bloquear',
        [Locale.Ge]: `Block`,
    },
    program: {
        [Locale.Ru]: `Программа`,
        [Locale.Am]: `Ծրագիր`,
        [Locale.En]: `Program`,
        [Locale.Pt]: 'Programa',
        [Locale.Ge]: `Program`,
    },
    notSpecified: {
        [Locale.Ru]: `Не указан`,
        [Locale.Am]: `Նշված չէ`,
        [Locale.En]: `Not specified`,
        [Locale.Pt]: 'Não especificado',
        [Locale.Ge]: `Not specified`,
    },
    newProgram: {
        [Locale.Ru]: `Новая программа`,
        [Locale.Am]: `Նոր ծրագիր`,
        [Locale.En]: `New program`,
        [Locale.Pt]: 'Novo programa',
        [Locale.Ge]: `New program`,
    },
    download: {
        [Locale.Ru]: 'Скачать',
        [Locale.Am]: 'Ներբեռնել',
        [Locale.En]: 'Download',
        [Locale.Pt]: 'Baixar',
        [Locale.Ge]: 'Download',
    },
    miscellaneous: {
        [Locale.Ru]: `Разное`,
        [Locale.Am]: `Այլ`,
        [Locale.En]: `Miscellaneous`,
        [Locale.Pt]: 'Variado',
        [Locale.Ge]: `Miscellaneous`,
    },
    analyzes: {
        [Locale.Ru]: `Анализы`,
        [Locale.Am]: `Անալիզներ`,
        [Locale.En]: `Analyzes`,
        [Locale.Pt]: 'Análises',
        [Locale.Ge]: `Analyzes`,
    },
    labResults: {
        [Locale.Ru]: `Результаты лабораторных исследований`,
        [Locale.Am]: `Լաբորատորիայի արդյունքներ`,
        [Locale.En]: `Lab Results`,
        [Locale.Pt]: 'Resultados de laboratório',
        [Locale.Ge]: `ლაბორატორიული შედეგები`,
    },
    needToDo: {
        [Locale.Ru]: `Нужно сделать`,
        [Locale.Am]: `Անհրաժեշտ է կատարել`,
        [Locale.En]: `To do`,
        [Locale.Pt]: 'Pendência',
        [Locale.Ge]: `რა უნდა გააკეთოს`,
    },
    waitingExecution: {
        [Locale.Ru]: `Жду исполнения`,
        [Locale.Am]: `Սպասում եմ կատարման`,
        [Locale.En]: `Waiting for execution`,
        [Locale.Pt]: 'Aguardando execução',
        [Locale.Ge]: `ველოდები აღსრულებას`,
    },
    mine: {
        [Locale.Ru]: `Мои`,
        [Locale.Am]: `Իմ`,
        [Locale.En]: `Mine`,
        [Locale.Pt]: 'Meu',
        [Locale.Ge]: `ჩემი`,
    },
    issuedByMe: {
        [Locale.Ru]: `Выданные мной`,
        [Locale.Am]: `Իմ կողմից տրված`,
        [Locale.En]: `Issued by me`,
        [Locale.Pt]: 'Emitido por mim',
        [Locale.Ge]: `ჩემს მიერ გაცემული`,
    },
    referralToMe: {
        [Locale.Ru]: `Направили ко мне`,
        [Locale.Am]: `Ուղղորդել են ինձ մոտ`,
        [Locale.En]: `Referral to me`,
        [Locale.Pt]: 'Referência para mim',
        [Locale.Ge]: `რეფერალური ჩემთვის`,
    },
    toReferral: {
        [Locale.Ru]: `По направлению`,
        [Locale.Am]: `Ըստ ուղեգրի`,
        [Locale.En]: `To referral`,
        [Locale.Pt]: 'Para referência',
        [Locale.Ge]: `რეფერალური`,
    },
    toDo: {
        [Locale.Ru]: `Что нужно сделать`,
        [Locale.Am]: `Ինչ է անհրաժեշտ կատարել`,
        [Locale.En]: `To do`,
        [Locale.Pt]: 'Pendência',
        [Locale.Ge]: `რა უნდა გააკეთოს`,
    },
    actual: {
        [Locale.Ru]: `Актуальное`,
        [Locale.Am]: `Արդիական`,
        [Locale.En]: `Actual`,
        [Locale.Pt]: 'Real',
        [Locale.Ge]: `Actual`,
    },
    actualMany: {
        [Locale.Ru]: `Актуальные`,
        [Locale.Am]: `Արդիական`,
        [Locale.En]: `Actual`,
        [Locale.Pt]: 'Real',
        [Locale.Ge]: `Actual`,
    },
    reviewedMany: {
        [Locale.Ru]: `Проверенные`,
        [Locale.Am]: `Ստուգված`,
        [Locale.En]: `Reviewed`,
        [Locale.Pt]: 'Revisados',
        [Locale.Ge]: `Reviewed`,
    },
    reviewScore: {
        [Locale.Ru]: `Оценка`,
        [Locale.Am]: `Գնահատական`,
        [Locale.En]: `Score`,
        [Locale.Pt]: 'Pontuação',
        [Locale.Ge]: `Score`,
    },
    createdManually: {
        [Locale.Ru]: `Создано вручную`,
        [Locale.Am]: `Ստեղծվել է ձեռքով`,
        [Locale.En]: `Created manually`,
        [Locale.Pt]: 'Criado manualmente',
        [Locale.Ge]: `Created manually`,
    },
    newDraftEntriesNotification: {
        [Locale.Ru]: `В медицинских записях появились новые черновики`,
        [Locale.Am]: `Բժշկական գրառումներում հայտնվել են նոր սևագրեր`,
        [Locale.En]: `New draft entries have appeared in the medical records`,
        [Locale.Pt]: `Novos rascunhos apareceram nos registros médicos`,
        [Locale.Ge]: `New draft entries have appeared in the medical records`,
    },
    today: {
        [Locale.Ru]: `Сегодня`,
        [Locale.Am]: `Այսօր`,
        [Locale.En]: `Today`,
        [Locale.Pt]: 'Hoje',
        [Locale.Ge]: `Today`,
    },
    todayMany: {
        [Locale.Ru]: `Сегодняшние`,
        [Locale.Am]: `Այսօրվա`,
        [Locale.En]: `Today`,
        [Locale.Pt]: 'Hoje',
        [Locale.Ge]: `Today's`,
    },
    byNextWeek: {
        [Locale.Ru]: `На следующей неделе`,
        [Locale.Am]: `Հաջորդ շաբաթ`,
        [Locale.En]: `By next week`,
        [Locale.Pt]: 'Na próxima semana',
        [Locale.Ge]: `By next week`,
    },
    // На следующей неделе
    executedMany: {
        [Locale.Ru]: `Выполненные`,
        [Locale.Am]: `Կատարվածներ`,
        [Locale.En]: `Executed`,
        [Locale.Pt]: 'Executado',
        [Locale.Ge]: `Executed`,
    },
    executed: {
        [Locale.Ru]: `Выполнено`,
        [Locale.Am]: `Կատարված է`,
        [Locale.En]: `Executed`,
        [Locale.Pt]: 'Executado',
        [Locale.Ge]: `Executed`,
    },
    onTomorrow: {
        [Locale.Ru]: `На завтра`,
        [Locale.Am]: `Վաղվա համար`,
        [Locale.En]: `Tomorrow`,
        [Locale.Pt]: 'Amanhã',
        [Locale.Ge]: `Tomorrow`,
    },
    unsignedEDS: {
        [Locale.Ru]: `Не подписаны ЭЦП`,
        [Locale.Am]: `Չեն ստորագրվել էլեկտրոնային ստորագրությամբ`,
        [Locale.En]: `Unsigned by EDS`,
        [Locale.Pt]: 'Não assinado por EDS',
        [Locale.Ge]: `Unsigned by EDS`,
    },
    details: {
        [Locale.Ru]: `Подробности`,
        [Locale.Am]: `Մանրամասներ`,
        [Locale.En]: `Details`,
        [Locale.Pt]: 'Detalhes',
        [Locale.Ge]: `Details`,
    },
    user: {
        [Locale.Ru]: `Пользователь`,
        [Locale.Am]: `Օգտատեր`,
        [Locale.En]: `User`,
        [Locale.Pt]: `Usuário`,
        [Locale.Ge]: `User`,
    },
    question: {
        [Locale.Ru]: `Вопрос`,
        [Locale.Am]: `Հարց`,
        [Locale.En]: `Question`,
        [Locale.Pt]: 'Pergunta',
        [Locale.Ge]: `Question`,
    },
    required: {
        [Locale.Ru]: `Обязательный`,
        [Locale.Am]: `Պարտադիր`,
        [Locale.En]: `Required`,
        [Locale.Pt]: 'Obrigatório',
        [Locale.Ge]: `Required`,
    },
    exitDo: {
        [Locale.Ru]: `Выйти`,
        [Locale.Am]: `Դուրս գալ`,
        [Locale.En]: `Exit`,
        [Locale.Pt]: 'Saída',
        [Locale.Ge]: `Exit`,
    },
    options: {
        [Locale.Ru]: `Варианты`,
        [Locale.Am]: `Տարբերակներ`,
        [Locale.En]: `Options`,
        [Locale.Pt]: 'Opções',
        [Locale.Ge]: `Options`,
    },
    copy: {
        [Locale.Ru]: `Скопировать`,
        [Locale.Am]: `Պատճենել`,
        [Locale.En]: `Copy`,
        [Locale.Pt]: 'Copiar',
        [Locale.Ge]: `Copy`,
    },
    linkTitle: {
        [Locale.Ru]: `Текст ссылки`,
        [Locale.Am]: `Հղման տեքստ`,
        [Locale.En]: `Link title`,
        [Locale.Pt]: 'Título do link',
        [Locale.Ge]: `Link title`,
    },
    removeLink: {
        [Locale.Ru]: `Удалить ссылку`,
        [Locale.Am]: `Ջնջել հղումը`,
        [Locale.En]: `Remove link`,
        [Locale.Pt]: 'Remover link',
        [Locale.Ge]: `Remove link`,
    },
    link: {
        [Locale.Ru]: `Ссылка`,
        [Locale.Am]: `Հղում`,
        [Locale.En]: `Link`,
        [Locale.Pt]: 'Link',
        [Locale.Ge]: `Link`,
    },
    bold: {
        [Locale.Ru]: `Полужирный`,
        [Locale.Am]: `Թավ`,
        [Locale.En]: `Bold`,
        [Locale.Pt]: 'Negrito',
        [Locale.Ge]: `Bold`,
    },
    italic: {
        [Locale.Ru]: `Курсив`,
        [Locale.Am]: `Շեղ`,
        [Locale.En]: `Italic`,
        [Locale.Pt]: 'Itálico',
        [Locale.Ge]: `Italic`,
    },
    underline: {
        [Locale.Ru]: `Подчеркнутый`,
        [Locale.Am]: `Ընդգծված`,
        [Locale.En]: `Underline`,
        [Locale.Pt]: 'Sublinhado',
        [Locale.Ge]: `Underline`,
    },
    numberedList: {
        [Locale.Ru]: `Нумерованный список`,
        [Locale.Am]: `Համարակալված ցուցակ`,
        [Locale.En]: `Numbered list`,
        [Locale.Pt]: 'Lista numerada',
        [Locale.Ge]: `Numbered list`,
    },
    bulletedList: {
        [Locale.Ru]: `Маркированный список`,
        [Locale.Am]: `Նշիկավոր ցուցակ`,
        [Locale.En]: `Bulleted list`,
        [Locale.Pt]: 'Lista com marcadores',
        [Locale.Ge]: `Bulleted list`,
    },
    payAttention: {
        [Locale.Ru]: `Обратите внимание`,
        [Locale.Am]: `Ուշադրություն դարձրեք`,
        [Locale.En]: `Pay attention`,
        [Locale.Pt]: 'Prestar atenção',
        [Locale.Ge]: `Pay attention`,
    },
    day: {
        [Locale.Ru]: `День`,
        [Locale.Am]: `Օր`,
        [Locale.En]: `Day`,
        [Locale.Pt]: 'Dia',
        [Locale.Ge]: `Day`,
    },
    daysTwo: {
        [Locale.Ru]: `Дня`,
        [Locale.Am]: `Օր`,
        [Locale.En]: `Days`,
        [Locale.Pt]: 'Dias',
        [Locale.Ge]: `Days`,
    },
    days: {
        [Locale.Ru]: `Дней`,
        [Locale.Am]: `Օր`,
        [Locale.En]: `Days`,
        [Locale.Pt]: 'Dias',
        [Locale.Ge]: `Days`,
    },
    week: {
        [Locale.Ru]: `Неделя`,
        [Locale.Am]: `Շաբաթ`,
        [Locale.En]: `Week`,
        [Locale.Pt]: 'Semana',
        [Locale.Ge]: `Week`,
    },
    weekTwo: {
        [Locale.Ru]: `Недели`,
        [Locale.Am]: `Շաբաթ`,
        [Locale.En]: `Weeks`,
        [Locale.Pt]: 'Semanas',
        [Locale.Ge]: `Weeks`,
    },
    weeks: {
        [Locale.Ru]: `Недель`,
        [Locale.Am]: `Շաբաթ`,
        [Locale.En]: `Weeks`,
        [Locale.Pt]: 'Semanas',
        [Locale.Ge]: `Weeks`,
    },
    changesNotSaved: {
        [Locale.Ru]: `Изменения не сохранились.`,
        [Locale.Am]: `Փոփոխությունները չեն պահպանվել։`,
        [Locale.En]: `The changes were not saved.`,
        [Locale.Pt]: 'As alterações não foram salvas.',
        [Locale.Ge]: `The changes were not saved.`,
    },
    notSet: {
        [Locale.Ru]: `Не задано`,
        [Locale.Am]: `Սահմանված չէ`,
        [Locale.En]: `Not set`,
        [Locale.Pt]: 'Não definido',
        [Locale.Ge]: `Not set`,
    },
    archiveDate: {
        [Locale.Ru]: `Дата архивации`,
        [Locale.Am]: `Արխիվացման ամսաթիվ`,
        [Locale.En]: `Archive date`,
        [Locale.Pt]: 'Data de arquivo',
        [Locale.Ge]: `Archive date`,
    },
    mon: {
        [Locale.Ru]: `Пн`,
        [Locale.Am]: `Երկ`,
        [Locale.En]: `Mon`,
        [Locale.Pt]: 'Dizer',
        [Locale.Ge]: `Mon`,
    },
    tue: {
        [Locale.Ru]: `Вт`,
        [Locale.Am]: `Երք`,
        [Locale.En]: `Tue`,
        [Locale.Pt]: 'Ter',
        [Locale.Ge]: `Tue`,
    },
    wed: {
        [Locale.Ru]: `Ср`,
        [Locale.Am]: `Չրք`,
        [Locale.En]: `Wed`,
        [Locale.Pt]: 'Através',
        [Locale.Ge]: `Wed`,
    },
    thu: {
        [Locale.Ru]: `Чт`,
        [Locale.Am]: `Հնգ`,
        [Locale.En]: `Thu`,
        [Locale.Pt]: 'Quem',
        [Locale.Ge]: `Thu`,
    },
    fri: {
        [Locale.Ru]: `Пт`,
        [Locale.Am]: `Ուրբ`,
        [Locale.En]: `Fri`,
        [Locale.Pt]: 'Sexo',
        [Locale.Ge]: `Fri`,
    },
    sat: {
        [Locale.Ru]: `Сб`,
        [Locale.Am]: `Շբթ`,
        [Locale.En]: `Sat`,
        [Locale.Pt]: 'Sáb',
        [Locale.Ge]: `Sat`,
    },
    sun: {
        [Locale.Ru]: `Вс`,
        [Locale.Am]: `Կիր`,
        [Locale.En]: `Sun`,
        [Locale.Pt]: 'Dom',
        [Locale.Ge]: `Sun`,
    },
    january: {
        [Locale.Ru]: `Январь`,
        [Locale.Am]: `Հունվար`,
        [Locale.En]: `January`,
        [Locale.Pt]: 'Janeiro',
        [Locale.Ge]: `January`,
    },
    february: {
        [Locale.Ru]: `Февраль`,
        [Locale.Am]: `Փետրվար`,
        [Locale.En]: `February`,
        [Locale.Pt]: 'Fevereiro',
        [Locale.Ge]: `February`,
    },
    march: {
        [Locale.Ru]: `Март`,
        [Locale.Am]: `Մարտ`,
        [Locale.En]: `March`,
        [Locale.Pt]: 'Março',
        [Locale.Ge]: `March`,
    },
    april: {
        [Locale.Ru]: `Апрель`,
        [Locale.Am]: `Ապրիլ`,
        [Locale.En]: `April`,
        [Locale.Pt]: 'Abril',
        [Locale.Ge]: `April`,
    },
    may: {
        [Locale.Ru]: `Май`,
        [Locale.Am]: `Մայիս`,
        [Locale.En]: `May`,
        [Locale.Pt]: 'Maio',
        [Locale.Ge]: `May`,
    },
    june: {
        [Locale.Ru]: `Июнь`,
        [Locale.Am]: `Հունիս`,
        [Locale.En]: `June`,
        [Locale.Pt]: 'Junho',
        [Locale.Ge]: `June`,
    },
    july: {
        [Locale.Ru]: `Июль`,
        [Locale.Am]: `Հուլիս`,
        [Locale.En]: `July`,
        [Locale.Pt]: 'Julho',
        [Locale.Ge]: `July`,
    },
    august: {
        [Locale.Ru]: `Август`,
        [Locale.Am]: `Օգոստոս`,
        [Locale.En]: `August`,
        [Locale.Pt]: 'Agosto',
        [Locale.Ge]: `August`,
    },
    september: {
        [Locale.Ru]: `Сентябрь`,
        [Locale.Am]: `Սեպտեմբեր`,
        [Locale.En]: `September`,
        [Locale.Pt]: 'Setembro',
        [Locale.Ge]: `September`,
    },
    october: {
        [Locale.Ru]: `Октябрь`,
        [Locale.Am]: `Հոկտեմբեր`,
        [Locale.En]: `October`,
        [Locale.Pt]: 'Outubro',
        [Locale.Ge]: `October`,
    },
    november: {
        [Locale.Ru]: `Ноябрь`,
        [Locale.Am]: `Նոյեմբեր`,
        [Locale.En]: `November`,
        [Locale.Pt]: 'Novembro',
        [Locale.Ge]: `November`,
    },
    december: {
        [Locale.Ru]: `Декабрь`,
        [Locale.Am]: `Դեկտեմբեր`,
        [Locale.En]: `December`,
        [Locale.Pt]: 'Dezembro',
        [Locale.Ge]: `December`,
    },
    resultOne: {
        [Locale.Ru]: `Результат`,
        [Locale.Am]: `Արդյունք`,
        [Locale.En]: `Result`,
        [Locale.Pt]: 'Resultado',
        [Locale.Ge]: `Result`,
    },
    resultTwo: {
        [Locale.Ru]: `Результата`,
        [Locale.Am]: `Արդյունք`,
        [Locale.En]: `Results`,
        [Locale.Pt]: 'Resultados',
        [Locale.Ge]: `Results`,
    },
    results: {
        [Locale.Ru]: `Результатов`,
        [Locale.Am]: `Արդյունքներ`,
        [Locale.En]: `Results`,
        [Locale.Pt]: 'Resultados',
        [Locale.Ge]: `Results`,
    },
    rendered: {
        [Locale.Ru]: `Оказана`,
        [Locale.Am]: `Մատուցվել է`,
        [Locale.En]: `Rendered`,
        [Locale.Pt]: 'Renderizado',
        [Locale.Ge]: `Rendered`,
    },
    renderedNet: {
        [Locale.Ru]: `Оказано`,
        [Locale.Am]: `Մատուցվել է`,
        [Locale.En]: `Rendered`,
        [Locale.Pt]: 'Renderizado',
        [Locale.Ge]: `Rendered`,
    },
    entry: {
        [Locale.Ru]: `Запись`,
        [Locale.Am]: `Գրառում`,
        [Locale.En]: `Entry`,
        [Locale.Pt]: 'Entrada',
        [Locale.Ge]: `Entry`,
    },
    recordFrom: {
        [Locale.Ru]: `Запись от`,
        [Locale.Am]: `Գրառում՝`,
        [Locale.En]: `Entry from`,
        [Locale.Pt]: 'Entrada de',
        [Locale.Ge]: `Entry from`,
    },
    entries: {
        [Locale.Ru]: 'Записи',
        [Locale.Am]: 'Գրառումներ',
        [Locale.En]: 'Entries',
        [Locale.Pt]: 'Entradas',
        [Locale.Ge]: 'Entries',
    },
    entriesInSchedule: {
        [Locale.Ru]: `Записи в расписании`,
        [Locale.Am]: `Գրանցումները ժամանակացույցում`,
        [Locale.En]: `Entries in schedule`,
        [Locale.Pt]: 'Inscrições no cronograma',
        [Locale.Ge]: `Entries in schedule`,
    },
    entriesMany: {
        [Locale.Ru]: `Записей`,
        [Locale.Am]: `Գրառումներ`,
        [Locale.En]: `Entries`,
        [Locale.Pt]: 'Entradas',
        [Locale.Ge]: `Entries`,
    },
    entryLanguage: {
        [Locale.Ru]: `Язык записи`,
        [Locale.Am]: `Գրառման լեզու`,
        [Locale.En]: `Entry language`,
        [Locale.Pt]: 'Idade',
        [Locale.Ge]: `Entry language`,
    },
    main: {
        [Locale.Ru]: `Основной`,
        [Locale.Am]: `Հիմնական`,
        [Locale.En]: `Main`,
        [Locale.Pt]: 'Principal',
        [Locale.Ge]: `Main`,
    },
    entryCreatedAt: {
        [Locale.Ru]: `Запись создана`,
        [Locale.Am]: `Գրառումը ստեղծված է`,
        [Locale.En]: `Entry created at`,
        [Locale.Pt]: 'Entrada criada em',
        [Locale.Ge]: `Entry created at`,
    },
    onThisWeek: {
        [Locale.Ru]: `На эту неделю`,
        [Locale.Am]: `Այս շաբաթվա համար`,
        [Locale.En]: `On this week`,
        [Locale.Pt]: 'Nesta semana',
        [Locale.Ge]: `On this week`,
    },
    canceledReservation: {
        [Locale.Ru]: `Отменённые приёмы`,
        [Locale.Am]: `Չեղարկված ընդունելություններ`,
        [Locale.En]: `Canceled reservations`,
        [Locale.Pt]: 'Reservas canceladas',
        [Locale.Ge]: `Canceled reservations`,
    },
    fromSite: {
        [Locale.Ru]: `Через сайт`,
        [Locale.Am]: `Կայքի միջոցով`,
        [Locale.En]: `From site`,
        [Locale.Pt]: 'Do site',
        [Locale.Ge]: `From site`,
    },
    byAppointment: {
        [Locale.Ru]: `По назначению врача`,
        [Locale.Am]: `Ըստ բժշկի նշանակման`,
        [Locale.En]: `By appointment`,
        [Locale.Pt]: 'Por marcação',
        [Locale.Ge]: `By appointment`,
    },
    scheduleEntry: {
        [Locale.Ru]: 'Запись в расписании',
        [Locale.Am]: `Գրանցում ժամանակացույցում`,
        [Locale.En]: `Schedule entry`,
        [Locale.Pt]: 'Entrada de agendamento',
        [Locale.Ge]: `Schedule entry`,
    },
    serviceIsNotSpecified: {
        [Locale.Ru]: `Услуга не указана`,
        [Locale.Am]: `Ծառայությունը նշված չէ`,
        [Locale.En]: `Service is not specified`,
        [Locale.Pt]: 'O serviço não está especificado',
        [Locale.Ge]: `Service is not specified`,
    },
    planNewPrice: {
        [Locale.Ru]: `Запланировать новую цену`,
        [Locale.Am]: `Պլանավորել նոր գին`,
        [Locale.En]: `Plan a new price`,
        [Locale.Pt]: 'Planeje um novo preço',
        [Locale.Ge]: `Plan a new price`,
    },
    archiveIt: {
        [Locale.Ru]: `Убрать в архив`,
        [Locale.Am]: `Տեղափոխել արխիվ`,
        [Locale.En]: `Archive it`,
        [Locale.Pt]: 'Arquivar',
        [Locale.Ge]: `Archive it`,
    },
    payForService: {
        [Locale.Ru]: `Оплачивает услугу`,
        [Locale.Am]: `Վճարում է ծառայության համար`,
        [Locale.En]: `Pay for service`,
        [Locale.Pt]: 'Pague pelo serviço',
        [Locale.Ge]: `Pay for service`,
    },
    notPayedServices: {
        [Locale.Ru]: `Неоплаченные услуги`,
        [Locale.Am]: `Չվճարված ծառայություններ`,
        [Locale.En]: `Not payed services`,
        [Locale.Pt]: 'Serviços não pagos',
        [Locale.Ge]: `Not payed services`,
    },
    full: {
        [Locale.Ru]: `Целиком`,
        [Locale.Am]: `Ամբողջությամբ`,
        [Locale.En]: `Full`,
        [Locale.Pt]: 'Completo',
        [Locale.Ge]: `Full`,
    },
    searchByName: {
        [Locale.Ru]: 'Поиск по имени',
        [Locale.Am]: 'Որոնում ըստ անվան',
        [Locale.En]: 'Search by name',
        [Locale.Pt]: 'Buscar por nome',
        [Locale.Ge]: 'ძებნა სახელით',
    },
    searchByTitle: {
        [Locale.Ru]: 'Поиск по названию',
        [Locale.Am]: 'Որոնում ըստ անվանման',
        [Locale.En]: 'Search by title',
        [Locale.Pt]: 'Pesquisar por título',
        [Locale.Ge]: 'ძიება სათაურის მიხედვით',
    },
    perMonth: {
        [Locale.Ru]: `в месяц`,
        [Locale.Am]: `ամսական`,
        [Locale.En]: `per month`,
        [Locale.Pt]: 'por mês',
        [Locale.Ge]: `per month`,
    },
    over: {
        [Locale.Ru]: `Закончилась`,
        [Locale.Am]: `Ավարտվել է`,
        [Locale.En]: `It's over`,
        [Locale.Pt]: 'Concluído',
        [Locale.Ge]: `It's over`,
    },
    overMusc: {
        [Locale.Ru]: `Закончится`,
        [Locale.Am]: `Կավարտվի`,
        [Locale.En]: `It will end`,
        [Locale.Pt]: 'Isso vai acabar',
        [Locale.Ge]: `It will end`,
    },
    exceptions: {
        [Locale.Ru]: `Исключения`,
        [Locale.Am]: `Բացառություններ`,
        [Locale.En]: `Exceptions`,
        [Locale.Pt]: 'Exceções',
        [Locale.Ge]: `Exceptions`,
    },
    planned: {
        [Locale.Ru]: `Планируемые`,
        [Locale.Am]: `Պլանավորվողներ`,
        [Locale.En]: `Planned`,
        [Locale.Pt]: 'Planejado',
        [Locale.Ge]: `Planned`,
    },
    in: {
        [Locale.Ru]: `в`,
        [Locale.Am]: `ում`,
        [Locale.En]: `in`,
        [Locale.Pt]: 'em',
        [Locale.Ge]: `in`,
    },
    at: {
        [Locale.Ru]: `в`,
        [Locale.Am]: `ժամը`,
        [Locale.En]: `at`,
        [Locale.Pt]: 'Em',
        [Locale.Ge]: `at`,
    },
    noListed: {
        [Locale.Ru]: `Не выставлены`,
        [Locale.Am]: `Դուրս գրված չեն`,
        [Locale.En]: `No listed`,
        [Locale.Pt]: 'Não listado',
        [Locale.Ge]: `No listed`,
    },
    maxAmountToPay: {
        [Locale.Ru]: `Максимальная сумма к оплате`,
        [Locale.Am]: `Վճարման ենթակա առավելագույն գումար`,
        [Locale.En]: `Maximum amount to pay`,
        [Locale.Pt]: 'Valor máximo a pagar',
        [Locale.Ge]: `Maximum amount to pay`,
    },
    paymentsByLegalEntities: {
        [Locale.Ru]: `Оплаты по юр. лицам`,
        [Locale.Am]: `Վճարումներ ըստ իրավաբանական անձանց`,
        [Locale.En]: `Payments by legal entities`,
        [Locale.Pt]: 'Pagamentos por pessoas jurídicas',
        [Locale.Ge]: `Payments by legal entities`,
    },
    onlySigned: {
        [Locale.Ru]: `Только подписанные`,
        [Locale.Am]: `Միայն ստորագրվածները`,
        [Locale.En]: `Only signed`,
        [Locale.Pt]: 'Apenas assinado',
        [Locale.Ge]: `Only signed`,
    },
    onlyActive: {
        [Locale.Ru]: `Только активные`,
        [Locale.Am]: `Միայն ակտիվները`,
        [Locale.En]: `Only active`,
        [Locale.Pt]: 'Somente ativo',
        [Locale.Ge]: `Only active`,
    },
    everythingForLastMonth: {
        [Locale.Ru]: `Все за последний месяц`,
        [Locale.Am]: `Բոլորը վերջին ամսվա համար`,
        [Locale.En]: `Everything for last month`,
        [Locale.Pt]: 'Tudo do mês passado',
        [Locale.Ge]: `Everything for last month`,
    },
    Russia: {
        [Locale.Ru]: `Россия`,
        [Locale.Am]: `Ռուսաստան`,
        [Locale.En]: `Russia`,
        [Locale.Pt]: 'Rússia',
        [Locale.Ge]: `Russia`,
    },
    Georgia: {
        [Locale.Ru]: `Грузия`,
        [Locale.Am]: `Վրաստան`,
        [Locale.En]: `Georgia`,
        [Locale.Pt]: 'Geórgia',
        [Locale.Ge]: `Georgia`,
    },
    Armenia: {
        [Locale.Ru]: `Армения`,
        [Locale.Am]: `Հայաստան`,
        [Locale.En]: `Armenia`,
        [Locale.Pt]: 'Armênia',
        [Locale.Ge]: `Armenia`,
    },
    Portugal: {
        [Locale.Ru]: `Португалия`,
        [Locale.Am]: `Պորտուգալիա`,
        [Locale.En]: `Portugal`,
        [Locale.Pt]: 'Portugal',
        [Locale.Ge]: `Portugal`,
    },
    UAE: {
        [Locale.Ru]: 'Объединенные Арабские Эмираты',
        [Locale.Am]: 'Արաբական Միացյալ Էմիրություններ',
        [Locale.En]: 'United Arab Emirates',
        [Locale.Pt]: 'Emirados Árabes Unidos',
        [Locale.Ge]: 'United Arab Emirates',
    },
    UnitedKingdom: {
        [Locale.Ru]: 'Великобритания',
        [Locale.Am]: 'Մեծ Բրիտանիա',
        [Locale.En]: 'United Kingdom',
        [Locale.Pt]: 'Reino Unido',
        [Locale.Ge]: 'United Kingdom',
    },
    medicalData: {
        [Locale.Ru]: `Медицинские данные`,
        [Locale.Am]: `Բժշկական տվյալներ`,
        [Locale.En]: `Medical data`,
        [Locale.Pt]: 'Dados médicos',
        [Locale.Ge]: `Medical data`,
    },
    usedMedications: {
        [Locale.Ru]: `Принимаемые медикаменты`,
        [Locale.Am]: `Ընդունվող դեղամիջոցներ`,
        [Locale.En]: `Used medications`,
        [Locale.Pt]: 'Medicamentos utilizados',
        [Locale.Ge]: `Used medications`,
    },
    medicalHistory: {
        [Locale.Ru]: `История болезни`,
        [Locale.Am]: `Հիվանդության պատմություն`,
        [Locale.En]: `Medical history`,
        [Locale.Pt]: 'Histórico médico',
        [Locale.Ge]: `Medical history`,
    },
    laboratoryResearchData: {
        [Locale.Ru]: `Данные лабораторных исследований`,
        [Locale.Am]: `Լաբորատոր հետազոտությունների տվյալներ`,
        [Locale.En]: `Laboratory data`,
        [Locale.Pt]: 'Dados de pesquisa laboratorial',
        [Locale.Ge]: `Laboratory data`,
    },
    instrumentalResearchData: {
        [Locale.Ru]: `Данные инструментальных исследований`,
        [Locale.Am]: `Գործիքային հետազոտությունների տվյալներ`,
        [Locale.En]: `Instrumental data`,
        [Locale.Pt]: 'Dados de pesquisa instrumental',
        [Locale.Ge]: `Instrumental data`,
    },
    generalData: {
        [Locale.Ru]: 'Общие данные',
        [Locale.Am]: 'Ընդհանուր տվյալներ',
        [Locale.En]: 'General data',
        [Locale.Pt]: 'Dados gerais',
        [Locale.Ge]: 'General data',
    },
    inheritance: {
        [Locale.Ru]: 'Наследственность',
        [Locale.Am]: 'Ժառանգականություն',
        [Locale.En]: 'Inheritance',
        [Locale.Pt]: 'Hereditariedade',
        [Locale.Ge]: 'Inheritance',
    },
    injuriesAndSurgeries: {
        [Locale.Ru]: 'Травмы и операции',
        [Locale.Am]: 'Վնասվածքներ և վիրահատություններ',
        [Locale.En]: 'Injuries and surgeries',
        [Locale.Pt]: 'Lesões e cirurgias',
        [Locale.Ge]: 'Injuries and surgeries',
    },
    chronicDiseases: {
        [Locale.Ru]: 'Хронические болезни',
        [Locale.Am]: 'Քրոնիկ հիվանդություններ',
        [Locale.En]: 'Chronic diseases',
        [Locale.Pt]: 'Doenças crônicas',
        [Locale.Ge]: 'Chronic diseases',
    },
    socialHistoryInformationAboutLifestyleAndOccupation: {
        [Locale.Ru]: 'Социальный анамнез, сведения об образе жизни и роде занятий',
        [Locale.Am]: 'Սոցիալական անամնեզ, տեղեկություններ ապրելակերպի և զբաղմունքի մասին',
        [Locale.En]: 'Social history, information about lifestyle and occupation',
        [Locale.Pt]: 'História social, informações sobre estilo de vida e ocupação',
        [Locale.Ge]: 'Social history, information about lifestyle and occupation',
    },
    chooseFromListOrAddNew: {
        [Locale.Ru]: 'Выберите из списка или добавьте новую',
        [Locale.Am]: 'Ընտրեք ցանկից կամ ավելացրեք նորը',
        [Locale.En]: 'Choose from list or add new',
        [Locale.Pt]: 'Escolha na lista ou adicione novo',
        [Locale.Ge]: 'Choose from list or add new',
    },
    medicalAssistanceEpisodesShort: {
        [Locale.Ru]: 'Эпизоды мед. помощи',
        [Locale.Am]: 'Բժշկ. օգնության էպիզոդներ',
        [Locale.En]: 'Medical assistance episodes',
        [Locale.Pt]: 'Episódios de assistência médica',
        [Locale.Ge]: 'Medical assistance episodes',
    },
    medicalAssistanceEpisodes: {
        [Locale.Ru]: 'Эпизоды медицинской помощи',
        [Locale.Am]: 'Բժշկական օգնության էպիզոդներ',
        [Locale.En]: 'Medical assistance episodes',
        [Locale.Pt]: 'Episódios de assistência médica',
        [Locale.Ge]: 'Medical assistance episodes',
    },
    episodesWithNamesNotFromList: {
        [Locale.Ru]: `Эпизоды с названиями не из списка`,
        [Locale.Am]: `Էպիզոդներ՝ ցանկից դուրս անվանումներով`,
        [Locale.En]: `Episodes with names not from the list`,
        [Locale.Pt]: `Episódios com nomes fora da lista`,
        [Locale.Ge]: `Episodes with names not from the list`,
    },
    patientOrganizationAssociation: {
        [Locale.Ru]: 'Связь между пациентом и организацией во время которой могут происходить встречи',
        [Locale.Am]: 'Կապ պացիենտի և կազմակերպության միջև, որի ընթացքում կարող են տեղի ունենալ հանդիպումներ',
        [Locale.En]: 'An association between a patient and an organization during which time encounters may occur',
        [Locale.Pt]: 'Uma associação entre um paciente e uma organização durante a qual podem ocorrer encontros',
        [Locale.Ge]: 'An association between a patient and an organization during which time encounters may occur',
    },
    forTheCurrentEntry: {
        [Locale.Ru]: `Для текущей записи`,
        [Locale.Am]: `Ընթացիկ գրառման համար`,
        [Locale.En]: `For the current entry`,
        [Locale.Pt]: 'Para a entrada atual',
        [Locale.Ge]: `For the current entry`,
    },
    dontTake: {
        [Locale.Ru]: 'Не принимает',
        [Locale.Am]: 'Չի ընդունում',
        [Locale.En]: 'Does not take',
        [Locale.Pt]: 'Não leva',
        [Locale.Ge]: 'Does not take',
    },
    showPrevVersionData: {
        [Locale.Ru]: 'Показать данные из прошлой версии',
        [Locale.Am]: 'Ցուցադրել նախորդ տարբերակի տվյալները',
        [Locale.En]: 'Show data from the previous version',
        [Locale.Pt]: 'Mostrar dados da versão anterior',
        [Locale.Ge]: 'Show data from the previous version',
    },
    hidePrevVersionData: {
        [Locale.Ru]: 'Скрыть данные из прошлой версии',
        [Locale.Am]: 'Թաքցնել նախորդ տարբերակի տվյալները',
        [Locale.En]: 'Hide data from the previous version',
        [Locale.Pt]: 'Ocultar dados da versão anterior',
        [Locale.Ge]: 'Hide data from the previous version',
    },
    notNeed: {
        [Locale.Ru]: 'Не нужно',
        [Locale.Am]: 'Անհրաժեշտ չէ',
        [Locale.En]: 'Not needed',
        [Locale.Pt]: 'Não é necessário',
        [Locale.Ge]: 'Not needed',
    },
    notNeeds: {
        [Locale.Ru]: 'Не нужны',
        [Locale.Am]: 'Անհրաժեշտ չեն',
        [Locale.En]: 'Not needed',
        [Locale.Pt]: 'Não é necessário',
        [Locale.Ge]: 'Not needed',
    },
    referralNotNeed: {
        [Locale.Ru]: 'Направления не нужны',
        [Locale.Am]: 'Ուղեգրեր անհրաժեշտ չեն',
        [Locale.En]: 'Referrals not needed',
        [Locale.Pt]: 'Referências não necessárias',
        [Locale.Ge]: 'Referrals not needed',
    },
    usedMedication: {
        [Locale.Ru]: `Принимаемый медикамент`,
        [Locale.Am]: `Ընդունվող դեղամիջոց`,
        [Locale.En]: `Used medication`,
        [Locale.Pt]: 'Medicação usada',
        [Locale.Ge]: `Used medication`,
    },
    medicalAssistanceEpisodeNotAssigned: {
        [Locale.Ru]: `Эпизод медицинской помощи не назначен`,
        [Locale.Am]: `Բժշկական օգնության էպիզոդ նշանակված չէ`,
        [Locale.En]: `Medical assistance episode is not assigned`,
        [Locale.Pt]: 'Episódio de assistência médica não atribuído',
        [Locale.Ge]: `Medical assistance episode is not assigned`,
    },
    medicationAddedFromPatientWordsOrEarlier: {
        [Locale.Ru]: `Медикамент добавлен со слов пациента или был добавлен ранее`,
        [Locale.Am]: `Դեղամիջոցն ավելացվել է պացիենտի խոսքերից կամ ավելացվել է ավելի վաղ`,
        [Locale.En]: `Medication added from patient's words or was added earlier`,
        [Locale.Pt]: 'Medicamento adicionado a partir do relato do paciente ou adicionado anteriormente',
        [Locale.Ge]: `Medication added from patient's words or was added earlier`,
    },
    fromPatientWords: {
        [Locale.Ru]: `Со слов пациента`,
        [Locale.Am]: `Պացիենտի խոսքերից`,
        [Locale.En]: `From patient words`,
        [Locale.Pt]: 'De palavras pacientes',
        [Locale.Ge]: `From patient words`,
    },
    openChat: {
        [Locale.Ru]: 'Открыть чат',
        [Locale.Am]: 'Բացել չաթը',
        [Locale.En]: 'Open chat',
        [Locale.Pt]: 'Em',
        [Locale.Ge]: 'Open chat',
    },
    newToday: {
        [Locale.Ru]: 'Новые за сегодня',
        [Locale.Am]: 'Այսօրվա նորերը',
        [Locale.En]: 'New today',
        [Locale.Pt]: 'Sim',
        [Locale.Ge]: 'New today',
    },
    forLastDay: {
        [Locale.Ru]: 'За последние сутки',
        [Locale.Am]: 'Վերջին օրվա համար',
        [Locale.En]: 'For last day',
        [Locale.Pt]: 'Para o último dia',
        [Locale.Ge]: 'For last day',
    },
    forLastWeek: {
        [Locale.Ru]: 'За последнюю неделю',
        [Locale.Am]: 'Վերջին շաբաթվա համար',
        [Locale.En]: 'For last week',
        [Locale.Pt]: 'Para a semana passada',
        [Locale.Ge]: 'For last week',
    },
    forLastMonth: {
        [Locale.Ru]: 'За последний месяц',
        [Locale.Am]: 'Վերջին ամսվա համար',
        [Locale.En]: 'For last month',
        [Locale.Pt]: 'Para o mês passado',
        [Locale.Ge]: 'For last month',
    },
    premium: {
        [Locale.Ru]: 'Премиум',
        [Locale.Am]: 'Պրեմիում',
        [Locale.En]: 'Premium',
        [Locale.Pt]: 'Prêmio',
        [Locale.Ge]: 'Premium',
    },
    changePatient: {
        [Locale.Ru]: `Изменить пациента`,
        [Locale.Am]: `Փոփոխել պացիենտին`,
        [Locale.En]: `Change patient`,
        [Locale.Pt]: 'Mudar de paciente',
        [Locale.Ge]: `Change patient`,
    },
    currentPatient: {
        [Locale.Ru]: `Текущий пациент`,
        [Locale.Am]: `Ընթացիկ պացիենտ`,
        [Locale.En]: `Current patient`,
        [Locale.Pt]: 'Paciente atual',
        [Locale.Ge]: `Current patient`,
    },
    newPatient: {
        [Locale.Ru]: `Новый пациент`,
        [Locale.Am]: `Նոր պացիենտ`,
        [Locale.En]: `New patient`,
        [Locale.Pt]: 'Novo paciente',
        [Locale.Ge]: `New patient`,
    },
    insuranceCoordination: {
        [Locale.Ru]: `Согласование со страховой компанией`,
        [Locale.Am]: `Համաձայնեցում ապահովագրական ընկերության հետ`,
        [Locale.En]: `Coordination with the insurance company`,
        [Locale.Pt]: 'Coordenação com a seguradora',
        [Locale.Ge]: `Coordination with the insurance company`,
    },
    addInstructionsForThePatientToFollow: {
        [Locale.Ru]: `Добавьте указания для пациента, которые необходимо соблюдать`,
        [Locale.Am]: `Ավելացրեք ցուցումներ պացիենտի համար, որոնք անհրաժեշտ է պահպանել`,
        [Locale.En]: `Add instructions for the patient to follow`,
        [Locale.Pt]: 'Adicione instruções para o paciente seguir',
        [Locale.Ge]: `Add instructions for the patient to follow`,
    },
    createOrdersInTreatmentPlan: {
        [Locale.Ru]: `Создать назначения в плане лечения`,
        [Locale.Am]: `Ստեղծել նշանակումներ բուժման պլանում`,
        [Locale.En]: `Create orders in the treatment plan`,
        [Locale.Pt]: 'Criar prescrições no plano de tratamento',
        [Locale.Ge]: `Create orders in the treatment plan`,
    },
    ordersProcessing: {
        [Locale.Ru]: `Обрабатываем данные`,
        [Locale.Am]: `Մշակում ենք տվյալները`,
        [Locale.En]: `Processing data`,
        [Locale.Pt]: 'Processando dados',
        [Locale.Ge]: `Processing data`,
    },
    ordersProcessingHint: {
        [Locale.Ru]: `(занимает около минуты)`,
        [Locale.Am]: `(տևում է մոտ մեկ րոպե)`,
        [Locale.En]: `(takes about a minute)`,
        [Locale.Pt]: '(leva cerca de um minuto)',
        [Locale.Ge]: `(takes about a minute)`,
    },
    ordersCreated: {
        [Locale.Ru]: `Назначения созданы`,
        [Locale.Am]: `Նշանակումները ստեղծված են`,
        [Locale.En]: `Orders created`,
        [Locale.Pt]: 'Prescrições criadas',
        [Locale.Ge]: `Orders created`,
    },
    ordersPartiallyCreated: {
        [Locale.Ru]: `Не все назначения удалось создать`,
        [Locale.Am]: `Ոչ բոլոր նշանակումները հաջողվեց ստեղծել`,
        [Locale.En]: `Not all orders could be created`,
        [Locale.Pt]: 'Nem todas as prescrições foram criadas',
        [Locale.Ge]: `Not all orders could be created`,
    },
    ordersCreationFailed: {
        [Locale.Ru]: `Не удалось создать назначения`,
        [Locale.Am]: `Չհաջողվեց ստեղծել նշանակումները`,
        [Locale.En]: `Failed to create orders`,
        [Locale.Pt]: 'Não foi possível criar prescrições',
        [Locale.Ge]: `Failed to create orders`,
    },
    ordersFailedListTitle: {
        [Locale.Ru]: `Не были созданы:`,
        [Locale.Am]: `Չեն ստեղծվել՝`,
        [Locale.En]: `Not created:`,
        [Locale.Pt]: 'Não criados:',
        [Locale.Ge]: `Not created:`,
    },
    ordersPartiallyCreatedDescription: {
        [Locale.Ru]: `Проверьте заполнение описания плана и уточните назначения`,
        [Locale.Am]: `Ստուգեք պլանի նկարագրության լրացումը և ճշտեք նշանակումները`,
        [Locale.En]: `Check the plan description and refine the orders`,
        [Locale.Pt]: 'Verifique o preenchimento da descrição do plano e ajuste as prescrições',
        [Locale.Ge]: `Check the plan description and refine the orders`,
    },
    ordersCreationFailedDescription: {
        [Locale.Ru]: `Из описания плана не удалось создать ни одного назначения. Проверьте формулировки, возможно, пациенту они тоже будут непонятны.`,
        [Locale.Am]: `Պլանի նկարագրությունից չհաջողվեց ստեղծել ոչ մի նշանակում։ Ստուգեք ձևակերպումները, հնարավոր է՝ դրանք պացիենտի համար ևս անհասկանալի լինեն։`,
        [Locale.En]: `No orders could be created from the plan description. Check the wording — it may be unclear to the patient as well.`,
        [Locale.Pt]: 'Não foi possível criar nenhuma prescrição a partir da descrição do plano. Verifique a formulação — pode ser que o paciente também não a entenda.',
        [Locale.Ge]: `No orders could be created from the plan description. Check the wording — it may be unclear to the patient as well.`,
    },
    textMessage: {
        [Locale.Ru]: `Сообщение для пациента`,
        [Locale.Am]: `Հաղորդագրություն պացիենտի համար`,
        [Locale.En]: `Message for the patient`,
        [Locale.Pt]: 'Idade',
        [Locale.Ge]: `Message for the patient`,
    },
    inputMessage: {
        [Locale.Ru]: `Введите сообщение`,
        [Locale.Am]: `Մուտքագրեք հաղորդագրությունը`,
        [Locale.En]: `Enter a message`,
        [Locale.Pt]: 'Idade',
        [Locale.Ge]: `Enter a message`,
    },
    signIn: {
        [Locale.Ru]: `Войти`,
        [Locale.Am]: `Մուտք գործել`,
        [Locale.En]: `Sign in`,
        [Locale.Pt]: 'Entrar',
        [Locale.Ge]: `Sign in`,
    },
    signInWithGoogle: {
        [Locale.Ru]: `Войти через Google`,
        [Locale.Am]: `Մուտք գործել Google-ով`,
        [Locale.En]: `Sign in with Google`,
        [Locale.Pt]: 'Faça login com o Google',
        [Locale.Ge]: `Sign in with Google`,
    },
    doctorsChat: {
        [Locale.Ru]: `Чат доктора`,
        [Locale.Am]: `Բժշկի չաթ`,
        [Locale.En]: `Doctor's chat`,
        [Locale.Pt]: `Bate-papo do médico`,
        [Locale.Ge]: `Doctor's chat`,
    },
    chatWithAssistants: {
        [Locale.Ru]: `Чат с ассистентами`,
        [Locale.Am]: `Չաթ օգնականների հետ`,
        [Locale.En]: `Chat with assistants`,
        [Locale.Pt]: 'Converse com assistentes',
        [Locale.Ge]: `Chat with assistants`,
    },
    chatWithDoctor: {
        [Locale.Ru]: `Чат с доктором`,
        [Locale.Am]: `Չաթ բժշկի հետ`,
        [Locale.En]: `Chat with doctor`,
        [Locale.Pt]: 'Converse com médico',
        [Locale.Ge]: `Chat with doctor`,
    },
    selectChatWithPractice: {
        [Locale.Ru]: `Выберите чат практики`,
        [Locale.Am]: `Ընտրեք պրակտիկայի չաթը`,
        [Locale.En]: `Select practice chat`,
        [Locale.Pt]: 'Selecione o bate-papo prático',
        [Locale.Ge]: `Select practice chat`,
    },
    selectChat: {
        [Locale.Ru]: `Выберите чат`,
        [Locale.Am]: `Ընտրեք չաթը`,
        [Locale.En]: `Select chat`,
        [Locale.Pt]: 'Em',
        [Locale.Ge]: `Select chat`,
    },
    creatingChat: {
        [Locale.Ru]: `Создаем чат (пару минут)...`,
        [Locale.Am]: `Ստեղծում ենք չաթը (մի քանի րոպե)...`,
        [Locale.En]: `Creating chat (couple of minutes)...`,
        [Locale.Pt]: 'Em',
        [Locale.Ge]: `Creating chat (couple of minutes)...`,
    },
    chatWithPractice: {
        [Locale.Ru]: `Написать в чат практики`,
        [Locale.Am]: `Գրել պրակտիկայի չաթում`,
        [Locale.En]: `Chat with practice`,
        [Locale.Pt]: 'Converse com a prática',
        [Locale.Ge]: `Chat with practice`,
    },
    registerInChatWithPractice: {
        [Locale.Ru]: `Вступить в групповой чат практики`,
        [Locale.Am]: `Միանալ պրակտիկայի խմբային չաթին`,
        [Locale.En]: `Join practice group chat`,
        [Locale.Pt]: 'Participe do bate-papo em grupo de prática',
        [Locale.Ge]: `Join practice group chat`,
    },
    noFollowUpPresetHint: {
        [Locale.Ru]: `Эпизоды, у которых более 7 дней не было активного задания или брони расписания`,
        [Locale.Am]: `Էպիզոդներ, որոնք ավելի քան 7 օր չեն ունեցել ակտիվ առաջադրանք կամ ժամանակացույցի ամրագրում`,
        [Locale.En]: `Episodes that have had no active task or schedule appointment for more than 7 days`,
        [Locale.Pt]: 'Episódios sem tarefa ativa ou agendamento há mais de 7 dias',
        [Locale.Ge]: `Episodes that have had no active task or schedule appointment for more than 7 days`,
    },
    customTitles: {
        [Locale.Ru]: `Пользовательские названия`,
        [Locale.Am]: `Օգտատիրոջ անվանումներ`,
        [Locale.En]: `Custom episode`,
        [Locale.Pt]: `Títulos personalizados`,
        [Locale.Ge]: `Custom titles`,
    },
    customEpisodeTitlesHint: {
        [Locale.Ru]: `Эпизоды с пользовательскими названиями, введёнными вручную`,
        [Locale.Am]: `Էպիզոդներ՝ ձեռքով մուտքագրված օգտատիրոջ անվանումներով`,
        [Locale.En]: `Episodes with manually entered custom titles`,
        [Locale.Pt]: `Episódios com títulos personalizados inseridos manualmente`,
        [Locale.Ge]: `Episodes with manually entered custom titles`,
    },
    recommendationSearch: {
        [Locale.Ru]: `Поиск рекомендаций`,
        [Locale.Am]: `Հանձնարարականների որոնում`,
        [Locale.En]: `Recommendation search`,
        [Locale.Pt]: 'Pesquisa de recomendação',
        [Locale.Ge]: `Recommendation search`,
    },
    others: {
        [Locale.Ru]: `Другие`,
        [Locale.Am]: `Այլ`,
        [Locale.En]: `Others`,
        [Locale.Pt]: `Outros`,
        [Locale.Ge]: `Others`,
    },
    otherEpisodes: {
        [Locale.Ru]: `Остальные эпизоды`,
        [Locale.Am]: `Մնացած էպիզոդները`,
        [Locale.En]: `Other episodes`,
        [Locale.Pt]: 'Outros episódios',
        [Locale.Ge]: `Other episodes`,
    },
    selectEpisodesFromPreviouslyCreatedOrStartNew: {
        [Locale.Ru]: `Выберите эпизоды из ранее созданных или начните новый:`,
        [Locale.Am]: `Ընտրեք էպիզոդներ նախկինում ստեղծվածներից կամ սկսեք նորը՝`,
        [Locale.En]: `Select episodes from previously created or start a new one:`,
        [Locale.Pt]: 'Selecione episódios criados anteriormente ou inicie um novo:',
        [Locale.Ge]: `Select episodes from previously created or start a new one:`,
    },
    assignEpisodesForTheCurrentEntry: {
        [Locale.Ru]: `Назначьте эпизоды для текущей записи:`,
        [Locale.Am]: `Նշանակեք էպիզոդներ ընթացիկ գրառման համար՝`,
        [Locale.En]: `Assign episodes for the current entry:`,
        [Locale.Pt]: 'Atribua episódios para a entrada atual:',
        [Locale.Ge]: `Assign episodes for the current entry:`,
    },
    startWithdrawalAct: {
        [Locale.Ru]: `Начальная сумма акта`,
        [Locale.Am]: `Ակտի սկզբնական գումար`,
        [Locale.En]: `Initial amount of the act`,
        [Locale.Pt]: 'Valor inicial do ato',
        [Locale.Ge]: `Initial amount of the act`,
    },
    finalWithdrawalAct: {
        [Locale.Ru]: `Финальная сумма акта`,
        [Locale.Am]: `Ակտի վերջնական գումար`,
        [Locale.En]: `Final amount of the act`,
        [Locale.Pt]: 'Valor final do ato',
        [Locale.Ge]: `Final amount of the act`,
    },
    enterHereTheContractualArrangements: {
        [Locale.Ru]: `Внесите сюда договоренности со страховой компанией пациента относительно покрытия услуг по выданным направлениям`,
        [Locale.Am]: `Այստեղ մուտքագրեք պացիենտի ապահովագրական ընկերության հետ ձեռք բերված պայմանավորվածությունները՝ տրված ուղեգրերով ծառայությունների ծածկույթի վերաբերյալ`,
        [Locale.En]: `Enter here the contractual arrangements with the patient's insurance company in relation to coverage of services provided`,
        [Locale.Pt]: 'Insira aqui os acordos contratuais com a seguradora do paciente sobre a cobertura dos serviços prestados',
        [Locale.Ge]: `Enter here the contractual arrangements with the patient's insurance company in relation to coverage of services provided`,
    },
    startingToTake: {
        [Locale.Ru]: `Начало приема`,
        [Locale.Am]: `Ընդունելության սկիզբ`,
        [Locale.En]: `Starting to take`,
        [Locale.Pt]: 'Começando a tomar',
        [Locale.Ge]: `Starting to take`,
    },
    restoreLinkHasBeenSentOnEmail: {
        [Locale.Ru]: `Ссылка для восстановления пароля была отправлена на почту`,
        [Locale.Am]: `Գաղտնաբառը վերականգնելու հղումն ուղարկվել է էլ. փոստին`,
        [Locale.En]: `Link to reset your password has been sent to your email`,
        [Locale.Pt]: 'O link para redefinir sua senha foi enviado para seu e-mail',
        [Locale.Ge]: `Link to reset your password has been sent to your email`,
    },
    theMedicationPeriodHasExpired: {
        [Locale.Ru]: `Истёк срок приема медикамента`,
        [Locale.Am]: `Դեղամիջոցի ընդունման ժամկետը լրացել է`,
        [Locale.En]: `The medication period has expired`,
        [Locale.Pt]: 'O período de medicação expirou',
        [Locale.Ge]: `The medication period has expired`,
    },
    cancelledMedication: {
        [Locale.Ru]: `Отмененный медикамент`,
        [Locale.Am]: `Չեղարկված դեղամիջոց`,
        [Locale.En]: `Cancelled medication`,
        [Locale.Pt]: 'Medicação cancelada',
        [Locale.Ge]: `Cancelled medication`,
    },
    entryPublicationErrorsDescription: {
        [Locale.Ru]: `При проверке записей для публикации возникли ошибки`,
        [Locale.Am]: `Հրապարակման համար գրառումները ստուգելիս առաջացել են սխալներ`,
        [Locale.En]: `Errors occurred while checking entries for publication`,
        [Locale.Pt]: 'Ocorreram erros ao verificar entradas para publicação',
        [Locale.Ge]: `შენიშვნების გამოქვეყნების შემოწმებისას მოხდა შეცდომები`,
    },
    entryPublicationErrorsInstruction: {
        [Locale.Ru]: `Устраните ошибки и повторите попытку публикации`,
        [Locale.Am]: `Վերացրեք սխալները և կրկնեք հրապարակման փորձը`,
        [Locale.En]: `Correct the errors and retry the publication`,
        [Locale.Pt]: 'Corrija os erros e tente publicar novamente',
        [Locale.Ge]: `გაასწორეთ შეცდომები და კვლავ სცადეთ გამოქვეყნება`,
    },
    entriesWithErrorsTitle: {
        [Locale.Ru]: `Записи, в которых возникли ошибки`,
        [Locale.Am]: `Գրառումներ, որոնցում առաջացել են սխալներ`,
        [Locale.En]: `Entries with errors`,
        [Locale.Pt]: 'Entradas com erros',
        [Locale.Ge]: `ჩანაწერები, რომლებშიც მოხდა შეცდომები`,
    },
    signEntriesWithEds: {
        [Locale.Ru]: 'Подписать записи с помощью ЭЦП?',
        [Locale.Am]: 'Ստորագրե՞լ գրառումները էլեկտրոնային ստորագրությամբ',
        [Locale.En]: 'Sign entries with EDS?',
        [Locale.Pt]: 'Assinar entradas com EDS?',
        [Locale.Ge]: 'ნიშანი EDS-ით?',
    },
    signWithEds: {
        [Locale.Ru]: 'Подписать ЭЦП',
        [Locale.Am]: 'Ստորագրել էլեկտրոնային ստորագրությամբ',
        [Locale.En]: 'Sign with EDS',
        [Locale.Pt]: 'Assinar com EDS',
        [Locale.Ge]: 'ხელმოწერა EDS-ით',
    },
    remd: {
        [Locale.Ru]: 'РЭМД',
        [Locale.Am]: 'РЭМД',
        [Locale.En]: 'REMD',
        [Locale.Pt]: 'REMD',
        [Locale.Ge]: 'REMD',
    },
    iemk: {
        [Locale.Ru]: 'ИЭМК',
        [Locale.Am]: 'ИЭМК',
        [Locale.En]: 'IEMK',
        [Locale.Pt]: 'IEMK',
        [Locale.Ge]: 'IEMK',
    },
    cdaDeliveryQueued: {
        [Locale.Ru]: 'В очереди',
        [Locale.Am]: 'Հերթում',
        [Locale.En]: 'Queued',
        [Locale.Pt]: 'Na fila',
        [Locale.Ge]: 'რიგში',
    },
    cdaDeliveryRegistered: {
        [Locale.Ru]: 'Зарегистрирован',
        [Locale.Am]: 'Գրանցված է',
        [Locale.En]: 'Registered',
        [Locale.Pt]: 'Registado',
        [Locale.Ge]: 'რეგისტრირებული',
    },
    retryRemdDelivery: {
        [Locale.Ru]: 'Повторить отправку в РЭМД',
        [Locale.Am]: 'Կրկին ուղարկել РЭМД',
        [Locale.En]: 'Retry sending to REMD',
        [Locale.Pt]: 'Reenviar para REMD',
        [Locale.Ge]: 'REMD-ში ხელახლა გაგზავნა',
    },
    retryIemkDelivery: {
        [Locale.Ru]: 'Повторить отправку в ИЭМК',
        [Locale.Am]: 'Կրկին ուղարկել ИЭМК',
        [Locale.En]: 'Retry sending to IEMK',
        [Locale.Pt]: 'Reenviar para IEMK',
        [Locale.Ge]: 'IEMK-ში ხელახლა გაგზავნა',
    },
    cdaDeliveryRetryFailed: {
        [Locale.Ru]: 'Не удалось повторить отправку',
        [Locale.Am]: 'Չհաջողվեց կրկին ուղարկել',
        [Locale.En]: 'Failed to retry sending',
        [Locale.Pt]: 'Não foi possível reenviar',
        [Locale.Ge]: 'ხელახლა გაგზავნა ვერ მოხერხდა',
    },
    resignCdaWithEds: {
        [Locale.Ru]: 'Заново подписать ЭЦП для РЭМД/ИЭМК',
        [Locale.Am]: 'Կրկին ստորագրել էլեկտրոնային ստորագրությամբ РЭМД/ИЭМК-ի համար',
        [Locale.En]: 'Re-sign with EDS for REMD/IEMK',
        [Locale.Pt]: 'Assinar novamente com EDS para REMD/IEMK',
        [Locale.Ge]: 'ხელახლა ხელმოწერა EDS-ით REMD/IEMK-სთვის',
    },
    cdaResignInProgress: {
        [Locale.Ru]: 'Идёт подписание СЭМД для РЭМД/ИЭМК. Подписано:',
        [Locale.Am]: 'Ընթանում է CDA փաստաթղթերի ստորագրումը РЭМД/ИЭМК-ի համար։ Ստորագրված է՝',
        [Locale.En]: 'Signing CDA documents for REMD/IEMK. Signed:',
        [Locale.Pt]: 'Assinando documentos CDA para REMD/IEMK. Assinados:',
        [Locale.Ge]: 'მიმდინარეობს CDA დოკუმენტების ხელმოწერა REMD/IEMK-სთვის. ხელმოწერილია:',
    },
    cdaDeliveryResponses: {
        [Locale.Ru]: 'Ответы РЭМД/ИЭМК',
        [Locale.Am]: 'РЭМД/ИЭМК պատասխաններ',
        [Locale.En]: 'REMD/IEMK responses',
        [Locale.Pt]: 'Respostas REMD/IEMK',
        [Locale.Ge]: 'REMD/IEMK პასუხები',
    },
    viewCdaDeliveryResponses: {
        [Locale.Ru]: 'Посмотреть ответы РЭМД/ИЭМК',
        [Locale.Am]: 'Դիտել РЭМД/ИЭМК պատասխանները',
        [Locale.En]: 'View REMD/IEMK responses',
        [Locale.Pt]: 'Ver respostas REMD/IEMK',
        [Locale.Ge]: 'REMD/IEMK პასუხების ნახვა',
    },
    cdaRequest: {
        [Locale.Ru]: 'Запрос',
        [Locale.Am]: 'Հարցում',
        [Locale.En]: 'Request',
        [Locale.Pt]: 'Solicitação',
        [Locale.Ge]: 'მოთხოვნა',
    },
    syncResponse: {
        [Locale.Ru]: 'Синхронный ответ',
        [Locale.Am]: 'Համաժամանակյա պատասխան',
        [Locale.En]: 'Synchronous response',
        [Locale.Pt]: 'Resposta síncrona',
        [Locale.Ge]: 'სინქრონული პასუხი',
    },
    asyncResponse: {
        [Locale.Ru]: 'Асинхронный ответ',
        [Locale.Am]: 'Ասինխրոն պատասխան',
        [Locale.En]: 'Asynchronous response',
        [Locale.Pt]: 'Resposta assíncrona',
        [Locale.Ge]: 'ასინქრონული პასუხი',
    },
    cdaRequestId: {
        [Locale.Ru]: 'Идентификатор запроса',
        [Locale.Am]: 'Հարցման նույնացուցիչ',
        [Locale.En]: 'Request id',
        [Locale.Pt]: 'ID da solicitação',
        [Locale.Ge]: 'მოთხოვნის იდენტიფიკატორი',
    },
    noCdaDeliveryRequest: {
        [Locale.Ru]: 'Запроса нет',
        [Locale.Am]: 'Հարցում չկա',
        [Locale.En]: 'No request',
        [Locale.Pt]: 'Sem solicitação',
        [Locale.Ge]: 'მოთხოვნა არ არის',
    },
    noCdaDeliveryResponse: {
        [Locale.Ru]: 'Ответа нет',
        [Locale.Am]: 'Պատասխան չկա',
        [Locale.En]: 'No response',
        [Locale.Pt]: 'Sem resposta',
        [Locale.Ge]: 'პასუხი არ არის',
    },
    noCdaDeliveries: {
        [Locale.Ru]: 'У записи нет подписанного СЭМД',
        [Locale.Am]: 'Գրառումը չունի ստորագրված CDA փաստաթուղթ',
        [Locale.En]: 'The entry has no signed CDA document',
        [Locale.Pt]: 'A entrada não possui documento CDA assinado',
        [Locale.Ge]: 'ჩანაწერს არ აქვს ხელმოწერილი CDA დოკუმენტი',
    },
    cdaDeliveryResponsesLoadFailed: {
        [Locale.Ru]: 'Не удалось загрузить ответы',
        [Locale.Am]: 'Չհաջողվեց բեռնել պատասխանները',
        [Locale.En]: 'Failed to load responses',
        [Locale.Pt]: 'Não foi possível carregar as respostas',
        [Locale.Ge]: 'პასუხების ჩატვირთვა ვერ მოხერხდა',
    },
    entryReviewErrorsDescription: {
        [Locale.Ru]: `При проверке записей возникли ошибки`,
        [Locale.Am]: `Գրառումները ստուգելիս առաջացել են սխալներ`,
        [Locale.En]: `Errors occurred while checking entries for review`,
        [Locale.Pt]: 'Ocorreram erros ao verificar entradas para revisão',
        [Locale.Ge]: `ჩანაწერების შემოწმებისას მოხდა შეცდომები`,
    },
    entryReviewErrorsInstruction: {
        [Locale.Ru]: `Устраните ошибки в записях и повторите отправку на проверку`,
        [Locale.Am]: `Վերացրեք սխալները գրառումներում և կրկին ուղարկեք ստուգման`,
        [Locale.En]: `Correct the errors and retry sending for review`,
        [Locale.Pt]: 'Corrija os erros e tente enviar para revisão novamente',
        [Locale.Ge]: `გაასწორეთ შეცდომები და კვლავ გააგზავნეთ შესამოწმებლად`,
    },
    contractorChanged: {
        [Locale.Ru]: 'Изменён подрядчик',
        [Locale.Am]: 'Փոփոխվել է կապալառուն',
        [Locale.En]: 'Contractor changed',
        [Locale.Pt]: 'Contratante alterado',
        [Locale.Ge]: 'Contractor changed',
    },
    headOfClinic: {
        [Locale.Ru]: `Руководитель клиники`,
        [Locale.Am]: `Կլինիկայի ղեկավար`,
        [Locale.En]: `Head of clinic`,
        [Locale.Pt]: 'Chefe da clínica',
        [Locale.Ge]: `Head of clinic`,
    },
    practiceLeader: {
        [Locale.Ru]: `Руководитель практики`,
        [Locale.Am]: `Պրակտիկայի ղեկավար`,
        [Locale.En]: `Practice leader`,
        [Locale.Pt]: 'O',
        [Locale.Ge]: `Practice leader`,
    },
    helpdesk: {
        [Locale.Ru]: `Хелпдеск`,
        [Locale.Am]: `Հելփդեսկ`,
        [Locale.En]: `Helpdesk`,
        [Locale.Pt]: 'Central de atendimento',
        [Locale.Ge]: `Helpdesk`,
    },
    developer: {
        [Locale.Ru]: `Разработчик`,
        [Locale.Am]: `Ծրագրավորող`,
        [Locale.En]: `Developer`,
        [Locale.Pt]: 'Desenvolvedor',
        [Locale.Ge]: `Developer`,
    },
    accountant: {
        [Locale.Ru]: `Бухгалтер`,
        [Locale.Am]: `Հաշվապահ`,
        [Locale.En]: `Accountant`,
        [Locale.Pt]: 'Contador',
        [Locale.Ge]: `Accountant`,
    },
    medicalDirector: {
        [Locale.Ru]: 'Медицинский директор',
        [Locale.Am]: 'Բժշկական տնօրեն',
        [Locale.En]: 'Medical director',
        [Locale.Pt]: 'Diretor médico',
        [Locale.Ge]: 'Medical director',
    },
    care: {
        [Locale.Ru]: 'Клинико-экспертная работа',
        [Locale.Am]: 'Կլինիկա-փորձագիտական աշխատանք',
        [Locale.En]: 'Clinical Expert Work',
        [Locale.Pt]: 'Trabalho de Especialistas Clínicos',
        [Locale.Ge]: 'კლინიკურ-ექსპერტული სამუშაო',
    },
    procedureNurse: {
        [Locale.Ru]: 'Процедурная медсестра',
        [Locale.Am]: 'Պրոցեդուրային բուժքույր',
        [Locale.En]: 'Procedure nurse',
        [Locale.Pt]: 'Enfermeira de procedimento',
        [Locale.Ge]: 'Procedure nurse',
    },
    taxNumber: {
        [Locale.Ru]: `Налоговый номер (ИНН)`,
        [Locale.Am]: `Հարկային համար (ՀՎՀՀ)`,
        [Locale.En]: `Tax number`,
        [Locale.Pt]: 'Número fiscal',
        [Locale.Ge]: `Tax number`,
    },
    nsiPositionCode: {
        [Locale.Ru]: `Код НСИ`,
        [Locale.Am]: `ՆՍԻ կոդ`,
        [Locale.En]: `NSI code`,
        [Locale.Pt]: 'Código NSI',
        [Locale.Ge]: `NSI code`,
    },
    frmrPositionCode: {
        [Locale.Ru]: `Должность по ФРМР`,
        [Locale.Am]: `Պաշտոն ըստ ФРМР`,
        [Locale.En]: `FRMR position`,
        [Locale.Pt]: 'Cargo FRMR',
        [Locale.Ge]: `FRMR position`,
    },
    remdRoleCode: {
        [Locale.Ru]: `Роль подписанта (РЭМД)`,
        [Locale.Am]: `Ստորագրողի դերը (РЭМД)`,
        [Locale.En]: `Signer role (REMD)`,
        [Locale.Pt]: 'Função do signatário (REMD)',
        [Locale.Ge]: `Signer role (REMD)`,
    },
    recurringSubscription: {
        [Locale.Ru]: `Рекуррентная подписка`,
        [Locale.Am]: `Կրկնվող բաժանորդագրություն`,
        [Locale.En]: `Recurring subscription`,
        [Locale.Pt]: 'Recurring subscription',
        [Locale.Ge]: `Recurring subscription`,
    },
    numberOfCopies: {
        [Locale.Ru]: `Количество копий`,
        [Locale.Am]: `Պատճենների քանակ`,
        [Locale.En]: `Number of copies`,
        [Locale.Pt]: 'Número de cópias',
        [Locale.Ge]: `Number of copies`,
    },
    newEncounter: {
        [Locale.Ru]: `Новый приём`,
        [Locale.Am]: `Նոր ընդունելություն`,
        [Locale.En]: `New encounter`,
        [Locale.Pt]: `Nova consulta`,
        [Locale.Ge]: `New encounter`,
    },
    officeCreationRequiresApproval: {
        [Locale.Ru]: `Добавление кабинетов нужно обязательно согласовать с Дмитрием Афанасьевым`,
        [Locale.Am]: `Կաբինետների ավելացումը պարտադիր պետք է համաձայնեցվի Դմիտրի Աֆանասևի հետ`,
        [Locale.En]: `Adding offices must be approved by Dmitry Afanasyev`,
        [Locale.Pt]: `A adição de escritórios deve ser obrigatoriamente aprovada por Dmitry Afanasyev`,
        [Locale.Ge]: `ოფისების დამატება აუცილებლად უნდა შეთანხმდეს დმიტრი აფანასიევთან`,
    },
    approved: {
        [Locale.Ru]: `Согласовано`,
        [Locale.Am]: `Համաձայնեցված է`,
        [Locale.En]: `Approved`,
        [Locale.Pt]: `Aprovado`,
        [Locale.Ge]: `შეთანხმებულია`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
